/* ============================================================
   BATCH MATH — Quantity & Scaling Calculators · LAYER'D Cakes
   Static asset: upload once to the theme's assets/ folder.

   Reads the JSON config island `#bmath-config` in the page
   template — the yield table, batch constant and ganache
   ratios all live THERE. This file holds no tunable numbers;
   Mariya edits the template, never this file.

   All quantities are computed in grams (the studio standard),
   with cups as a secondary display.
   ============================================================ */
(function () {
  'use strict';
  /* SPINE r234: EMBED MODE. When Batch Math runs inside the workspace (studio
     spine) — an iframe or ?embed=1 — hide its own page chrome (html.ld-embed,
     CSS in learn-batch-math.css) so only the calculators show, and report
     height to the parent so the frame sizes to content. Math untouched. */
  var BM_EMBED = /[?&]embed=1/.test(location.search) || (window.self !== window.top);
  if (BM_EMBED) {
    try { document.documentElement.classList.add('ld-embed'); } catch (eEm) { }
    var bmPostHeight = function () {
      try {
        var h = Math.max(document.body ? document.body.scrollHeight : 0, document.documentElement.scrollHeight);
        parent.postMessage({ ldEmbed: 'batch', height: h }, '*');
      } catch (e) { }
    };
    window.addEventListener('load', bmPostHeight);
    window.addEventListener('resize', bmPostHeight);
    window.addEventListener('layerd:cakefile', function () { setTimeout(bmPostHeight, 90); });
    [300, 900, 1800].forEach(function (t) { setTimeout(bmPostHeight, t); });
  }
  /* r78 (Mariya's recording, frames 117-122): tapping this tab from another
     page arrived SCROLLED to the last visit's position - the sticky slider
     bar pinned at the very top, header off-screen - then snapped to the top
     a beat later as the JS-built content mounted. That lurch was "the
     glitch" on exactly the sliding-bar pages. Same cure the Planner got for
     the same disease: own the scroll, arrive at the top. Deep links
     (#batter, #ganache...) keep their sanctioned landing. */
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (eSR) { }
  if (!location.hash) {
    try { window.scrollTo(0, 0); } catch (eST) { }
    setTimeout(function () { try { if (!location.hash) window.scrollTo(0, 0); } catch (e) { } }, 0);
  }

  /* Redesign fix 4 (handoff 2026-07-22): the six calculators are a quiet
     numbered ACCORDION — one open at a time, each previewing its headline
     result on the collapsed row, so nothing hides and nothing walls. The
     sticky pill bar and #hash deep links OPEN their section (they never
     just scroll to a closed fold). Math untouched. */
  function initBmAccordion() {
    var folds = Array.prototype.slice.call(document.querySelectorAll('details[data-bmacc]'));
    if (!folds.length) return;
    var secOf = function (d) { var sec = d.closest('section'); return sec ? sec.id : null; };
    var byId = {};
    folds.forEach(function (d) { var id = secOf(d); if (id) byId[id] = d; });

    /* one open at a time */
    var muting = false;
    folds.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (muting || !d.open) return;
        muting = true;
        folds.forEach(function (o) { if (o !== d && o.open) o.open = false; });
        muting = false;
        /* round nineteen (Mariya): closing the section ABOVE shrinks the
           page and the viewport lands somewhere odd — park the opened
           header right under the sticky bars instead, deterministically */
        setTimeout(function () {
          /* redesign r2: in tab mode the summaries are hidden and only one
             section is on screen — measuring a hidden node returns 0,0 and
             this would scroll the page on every tab switch. Tabs own the
             viewport there; nothing to park. */
          if (document.body.classList.contains('bmath-tabmode')) return;
          var sum = d.querySelector('.ld-collapse__sum');
          if (!sum) return;
          var pb = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ld-pipebar-h')) || 0;
          var want = 64 + pb;
          var r = sum.getBoundingClientRect();
          if (Math.abs(r.top - want) > 8) window.scrollTo({ top: window.scrollY + r.top - want });
        }, 0);
      });
    });
    function openSec(id) {
      var d = byId[id];
      if (d && !d.open) d.open = true;
    }

    /* collapsed rows preview their headline result (Jost lining figures) */
    var PV = {
      batter: ['#batter .bmath-headline__num', '#batter .bmath-line--total .bmath-num'],
      ganache: ['#ganache .bmath-line--total .bmath-num', '#ganache .bmath-headline__num'],
      fillings: ['#fillings .bmath-line--total .bmath-num', '#fillings .bmath-headline__num'],
      buttercream: ['#buttercream .bmath-line--total .bmath-num', '#buttercream .bmath-headline__num'],
      scaling: ['#scaling .bmath-factor__x'],
      reference: []
    };
    var pvEls = {};
    folds.forEach(function (d) {
      var id = secOf(d);
      var sum = d.querySelector('.ld-collapse__sum');
      var x = sum && sum.querySelector('.ld-collapse__x');
      /* round 26: EVERY fold gets the span — an empty one still holds the
         value column open, so the "open" tag lands at the same edge on
         rows that have no headline number (the Guide) */
      if (!sum || !id) return;
      var pv = document.createElement('span');
      pv.className = 'bm-acc__pv';
      sum.insertBefore(pv, x || null);
      pvEls[id] = pv;
    });
    /* redesign r2: the same value also rides its TAB (the prototype's
       label-over-value pills). One span per pill, created once; the
       existing debounced listeners keep both in step. */
    var tabValEls = {};
    (function buildTabVals() {
      var nav0 = document.querySelector('.bmath-jump');
      if (!nav0) return;
      Array.prototype.slice.call(nav0.querySelectorAll('a[href^="#"]')).forEach(function (a) {
        var id = (a.getAttribute('href') || '').slice(1);
        if (!id) return;
        var lab = document.createElement('span');
        lab.className = 'bmath-tab__lbl';
        lab.textContent = a.textContent.trim();
        var val = document.createElement('span');
        val.className = 'bmath-tab__val';
        a.textContent = '';
        a.appendChild(lab);
        a.appendChild(val);
        tabValEls[id] = val;
      });
    })();
    var pvTimer = null;
    function updatePreviews() {
      Object.keys(pvEls).forEach(function (id) {
        var txt = '';
        (PV[id] || []).some(function (sel) {
          var n = document.querySelector(sel);
          if (n && n.textContent.trim()) { txt = n.textContent.trim(); return true; }
          return false;
        });
        /* CO#1 B5.2 (round 45): collapsed summaries abbreviate the unit so
           the NUMBER is never the casualty - the full wording lives in the
           expanded card */
        pvEls[id].textContent = txt.replace('quarter-sheet', 'qtr-sheet');
      });
      /* the tab pills carry a tighter form: the figure + its short unit */
      Object.keys(tabValEls).forEach(function (id) {
        var txt = '';
        (PV[id] || []).some(function (sel) {
          var n = document.querySelector(sel);
          if (n && n.textContent.trim()) { txt = n.textContent.trim(); return true; }
          return false;
        });
        tabValEls[id].textContent = txt
          .replace('quarter-sheet batches', 'batches').replace('quarter-sheet batch', 'batch')
          .replace('qtr-sheet batches', 'batches').replace('qtr-sheet batch', 'batch');
      });
    }
    ['input', 'change', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        if (pvTimer) clearTimeout(pvTimer);
        pvTimer = setTimeout(updatePreviews, 180);
      }, true);
    });
    setTimeout(updatePreviews, 400);
    setTimeout(updatePreviews, 1200);

    /* the sticky pill bar: a tap OPENS the section, then the anchor
       scroll lands it (scroll-margin clears the bar) */
    var nav = document.querySelector('.bmath-jump');
    var links = nav ? Array.prototype.slice.call(nav.querySelectorAll('a')) : [];
    var ids = links.map(function (a) { return (a.getAttribute('href') || '').slice(1); }).filter(Boolean);
    function mark(cur) {
      if (document.body.classList.contains('bmath-tabmode')) return;   /* tabs own it */
      links.forEach(function (a) {
        var on = (a.getAttribute('href') || '').slice(1) === cur;
        a.classList.toggle('is-here', on);
        a.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    links.forEach(function (a) {
      a.addEventListener('click', function () {
        var id = (a.getAttribute('href') || '').slice(1);
        openSec(id);
        mark(id);
      });
    });
    function openFromHash() {
      var h = (location.hash || '').slice(1);
      if (h && byId[h]) openSec(h);
    }
    window.addEventListener('hashchange', openFromHash);
    openFromHash();

    /* scroll-spy keeps the bar honest */
    var ticking = false;
    function spy() {
      ticking = false;
      /* redesign r2: tabs own the active pill (one section on screen) —
         a position-based spy would repaint it wrongly */
      if (document.body.classList.contains('bmath-tabmode')) return;
      if (!ids.length) return;
      var cur = ids[0];
      for (var i = 0; i < ids.length; i++) {
        var sec = document.getElementById(ids[i]);
        if (sec && sec.getBoundingClientRect().top <= 80) cur = ids[i];
      }
      mark(cur);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(spy); }
    }, { passive: true });
    spy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBmAccordion);
  else initBmAccordion();

  /* every viewport move routes through the ONE shared utility
     (nav rule 2026-07-20); absent = no scroll, never a local fallback */
  function ldNav(target, opts) {
    var C2 = window.LAYERD && window.LAYERD.components;
    return !!(C2 && C2.navigateToSection && C2.navigateToSection(target, opts));
  }


  /* ---------- config from the template's data island ---------- */
  var cfg = null;
  var cfgEl = document.getElementById('bmath-config');
  if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = null; } }

  var bcRoot = document.getElementById('bmath-buttercream');
  var gaRoot = document.getElementById('bmath-ganache');
  var scRoot = document.getElementById('bmath-scaling');
  var ctRoot = document.getElementById('bmath-batter');
  var flRoot = document.getElementById('bmath-fillings');
  if (!cfg || (!bcRoot && !gaRoot && !scRoot && !ctRoot)) return;

  /* ---------- the shared quantity engine (§4) ----------
     ONE source of truth for the math, consumed here and by the Planner.
     learn-quantities.js loads BEFORE this file (template script order);
     if it's somehow absent the tool no-ops rather than show numbers that
     could disagree with the Planner. Every local compute below is a thin
     wrapper that binds this page's cfg + bowl choice. */
  var Q = window.LAYERD && window.LAYERD.quantities;
  if (!Q) return;

  var TIERS_KEY = 'layerd-learn-tiers';   // shared with the Structure tool (Brief 02)
  var STATE_KEY = 'layerd-batch-math';

  /* ---------- units: inches ↔ cm, shared suite-wide ----------
     One preference for every Learn tool (same localStorage key).
     Internal math NEVER changes — sizes are stored and computed in
     inches; cm is a LABEL, mapped to the standard retail metric pan
     sizes (6" ↔ 15 cm, 8" ↔ 20 cm…), so the shared-cake key keeps
     working across tools and Mariya's verified numbers stay put. */
  var UNITS_KEY = 'layerd-learn-units';
  var IN2CM = { 4: 10, 5: 13, 6: 15, 7: 18, 8: 20, 9: 23, 10: 25, 11: 28, 12: 30, 13: 33, 14: 35, 15: 38, 16: 40 };
  function unitPref() {
    try { return localStorage.getItem(UNITS_KEY) === 'cm' ? 'cm' : 'in'; } catch (e) { return 'in'; }
  }
  function sizeLabel(n) {
    return unitPref() === 'cm' ? (IN2CM[n] || Math.round(n * 2.54)) + ' cm' : n + '"';
  }
  var unitListeners = [];   // each tool registers its rebuild here
  /* r87: with the in-page bowl picker retired, the settings pop-up is the
     one editor — and its writes arrive here as storage events (components'
     set() fires a synthetic one for the same tab, real ones cross tabs).
     A bowl or units change re-runs every registered rebuild, exactly the
     fan-out the picker's own click used to trigger, and re-labels the
     bowl note chip. */
  window.addEventListener('storage', function (e) {
    if (e && e.key && e.key !== 'layerd-bm-bowl' && e.key !== 'layerd-learn-units'
      && e.key !== 'layerd-quantity-calibration') return;   /* r95: tuning re-runs everything too */
    unitListeners.forEach(function (fn) { try { fn(); } catch (e2) { } });
    var n = document.getElementById('bmathBowlNote');
    if (n) n.textContent = unitsBowlLabel();
  });

  /* ---------- tiny DOM helpers (same idiom as Cake ER) ---------- */
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function clearNode(n) { while (n.firstChild) n.removeChild(n.firstChild); }
  /* one shape vocabulary suite-wide (§2.2): round · square · heart —
     never silently flatten heart to round when adopting a shared cake */
  function normShape(s) { return s === 'square' ? 'square' : s === 'heart' ? 'heart' : 'round'; }
  /* the ONE layer rule (round 30) - shared with the client file so the
     file and this page can never disagree about the bake again */
  function stdLayers(h) {
    if (window.LdCakeFile && window.LdCakeFile.standardLayers) return window.LdCakeFile.standardLayers(h);
    return Math.max(1, Math.round(+h || 4) - 1);
  }

  /* ---------- formatting ---------- */
  function fmtInt(n) { return Math.round(n).toLocaleString('en-CA'); }
  function fmtG(n) { return fmtInt(n) + ' g'; }
  function fmt1(n) { return String(Math.round(n * 10) / 10); }
  function fmtNum(n) {
    // sensible display for scaled quantities
    if (n >= 1000) return fmtInt(n);
    if (n === Math.round(n)) return String(n);
    return String(Math.round(n * 100) / 100);
  }

  /* ---------- geometry (inches) — from the shared engine ----------
     §2.2 heart, §4 single-source: topArea applies heartAreaFactor to the
     round of the same diameter; sides/edges use the bounding round. All
     three live in learn-quantities.js so Batch Math and the Planner agree. */
  var HEART_FACTOR = Q.heartFactor(cfg);
  function topArea(t) { return Q.topArea(cfg, t); }

  /* ---------- mixing-bowl fit (2026-07-09, Mariya) ----------
     Batter volume ≈ pan area × 1" layers — the exact model the batter
     tool already uses — so bowl-fit is one conversion away:
     1 US qt = 57.75 in³. Numbers live in cfg.bowl (VERIFY). */
  var BOWL_KEY = 'layerd-bm-bowl';   // '5' | '6' ('7' = legacy alias, r86) — the baker's own mixer, per device
  function bowlPref() {
    var sizes = (cfg && cfg.bowl && cfg.bowl.sizes) || null;
    var dflt = (cfg && cfg.bowl && cfg.bowl.default) || '5';
    var v = dflt;
    try { v = localStorage.getItem(BOWL_KEY) || dflt; } catch (e) { /* private mode */ }
    /* r86 (2026-08-23): the r62 rename is reverted — the box says 6 qt.
       A '7' stored during the r62 window migrates back; numbers identical
       either way, so no computation ever changed. */
    if (v === '7' && sizes && sizes['6']) {
      v = '6';
      try { localStorage.setItem(BOWL_KEY, '6'); } catch (e2) { }
    }
    return (sizes && sizes[v]) ? v : dflt;
  }
  function bowlCfg() { return Q.bowlCfg(cfg, bowlPref()); }
  function batterQtsOf(areaLayers) { return Q.batterQtsOf(areaLayers); }
  function qtsLabel(q) {
    return unitPref() === 'cm'
      ? (Math.round(q * 0.946 * 10) / 10) + ' L'
      : (Math.round(q * 10) / 10) + ' qt';
  }
  /* { fits, mixes, text } for a batter volume in area×layers units.
     Numbers from the engine's bowlFit (same 5% sliver tolerance); the
     unit-aware "qt / L" sentence is built here, in the UI. */
  function bowlFit(areaLayers) {
    var f = Q.bowlFit(cfg, bowlPref(), areaLayers);
    var b = f.bowl;
    if (f.fits) {
      return { fits: true, mixes: 1, text: 'About ' + qtsLabel(f.qts) + ' of batter, fits one ' + b.label + '.' };
    }
    return { fits: false, mixes: f.mixes, text:
      'About ' + qtsLabel(f.qts) + ' of batter, more than a ' + b.label + ' mixes comfortably (~' +
      qtsLabel(b.batterQts) + '). Mix it in ' + f.mixes + ' equal rounds, not one heroic bowl.' };
  }
  function sideArea(t) { return Q.sideArea(t); }
  function edgeLength(t) { return Q.edgeLength(t); }
  function tierLabel(t) { return sizeLabel(t.d) + ' ' + t.shape + ', ' + sizeLabel(t.h) + ' tall'; }
  function newTier(d) { return { d: d, h: 4, shape: 'round' }; }

  /* ---------- state, remembered for the visit ---------- */
  function readJSON(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
  }
  function writeJSON(key, v) {
    try { sessionStorage.setItem(key, JSON.stringify(v)); } catch (e) { /* private mode etc. */ }
  }

  var saved = readJSON(STATE_KEY) || {};

  /* ---------- shared-cake CONTRACT v2 (2026-07-09) ----------
     The mismatch fix: Serving wrote a cake, this tool kept showing (and
     re-broadcasting!) an older one. Now every write is stamped
     { tiers, at, from } and lands in BOTH localStorage (cross-tab,
     survives overnight) and sessionStorage (legacy readers during the
     staggered deploy); readers adopt the NEWEST stamp. This tool only
     broadcasts the cake when the strip is actually edited — recomputes
     never touch the key. */
  function readSharedCake() {
    var best = null;
    [localStorage, sessionStorage].forEach(function (store) {
      try {
        var v = JSON.parse(store.getItem(TIERS_KEY));
        if (v && v.tiers && v.tiers.length && (!best || (v.at || 1) > (best.at || 1))) best = v;
      } catch (e) { /* private mode / corrupt */ }
    });
    return best;
  }
  function writeSharedCake(tiers) {
    /* the shared cake carries WHICH client it belongs to (null = unscoped
       "just the math"), so a scoped tool can tell a client's working cake
       from a stray edit and never shows the wrong tiers (2026-07-15 fix). */
    var payload = JSON.stringify({
      tiers: tiers.slice().sort(function (a, b) { return b.d - a.d; }),
      at: Date.now(), from: 'batch-math', bookingId: (state && state.bookingId) || null
    });
    try { localStorage.setItem(TIERS_KEY, payload); } catch (e) { }
    try { sessionStorage.setItem(TIERS_KEY, payload); } catch (e) { }
  }
  var shared = readSharedCake();

  /* ---------- THE cake (the "your cake" strip, 2026-07-09) ----------
     One tier list at the top of the page; every calculator below reads
     it (recipe pan-scaling is pan-to-pan, so it's exempt). Adoption
     rule: the NEWEST cake wins — a cake sized in Serving after this
     tool's last visit replaces the remembered one (Mariya's mismatch
     bug); the remembered cake carries its own stamp from the last strip
     edit. Each tool can flip to "A different cake" (s.custom) for the
     one-off jobs. cakeSeed + cakeFrom drive the provenance note. */
  var savedCakeOk = !!(saved.cake && saved.cake.tiers && saved.cake.tiers.length);
  /* only adopt the shared cake if it belongs to the SAME scope as the
     remembered booking (both unscoped, or both the same client) — a shared
     cake left by "just the math" or another client must not shadow this
     client's saved tiers (2026-07-15 fix; bookingInit re-seeds from tierSpec
     when they don't match). */
  var _scopeBid = (saved && saved.bookingId) || null;
  var _sharedBid = (shared && shared.bookingId !== undefined) ? (shared.bookingId || null) : null;
  var adoptShared = !!(shared && _sharedBid === _scopeBid && (shared.at || 1) > ((savedCakeOk && saved.cake.at) || 0));
  var cakeSeed = adoptShared ? 'suite' : (savedCakeOk ? 'visit' : 'fresh');
  var cakeFrom = adoptShared ? (shared.from || '') : '';
  var state = {
    cake: adoptShared ? {
      tiers: shared.tiers.map(function (t) {
        return { d: +t.d || 6, h: +t.h || 4, shape: normShape(t.shape) };
      }),
      at: shared.at || 1
    } : (savedCakeOk ? saved.cake : {
      tiers: (saved.bc && saved.bc.tiers && saved.bc.tiers.length)
        ? saved.bc.tiers : [newTier(6), newTier(8), newTier(10)],
      at: 0
    }),
    bc: saved.bc || {
      custom: false, tiers: null,
      /* dams default to 2 — the studio method, and the setting the
         2.65 g/in rate was calibrated against (2026-08-04). Saved state
         from before this existed comes back without `dams`, so bcEffState
         fills it in rather than silently costing those cakes nothing. */
      finish: 'sharp', fillOn: false, layers: 3, fillThick: 'standard', dams: 2
    },
    /* 2026-08-12 (Mariya): ganache opens on the FULL COAT, not the drip —
       "most people will use that and not the drip option". A drip is a
       finishing flourish on one tier; a coat under buttercream or fondant is
       the structural default and the far bigger number, so opening on drip
       under-stated the job for the common case. Only the DEFAULT moved:
       `saved.ga` still wins, so a file that chose drip keeps it. */
    ga: saved.ga || { custom: false, dripScope: 'top', app: 'coat', choc: 'dark', layers: 3, tiers: null },
    sc: saved.sc || {
      src: { d: 8, shape: 'round', layers: 2 },
      tgt: { d: 10, shape: 'quarterSheet', layers: 1 },
      text: ''
    },
    fl: saved.fl || { custom: false, tiers: null, type: 'studio' },
    ct: saved.ct || {
      custom: false, cakeLayers: [], cakeFlavours: [],
      tiers: [{ d: 6, shape: 'round', layers: 3 }, { d: 8, shape: 'round', layers: 3 }],
      vessel: 'sheet',
      roundRef: (cfg && cfg.batter && cfg.batter.roundRefIn) || 8,
      roundRefLayers: (cfg && cfg.batter && cfg.batter.roundRefLayers) || 2
    }
  };
  /* legacy state saved earlier this visit predates the strip — default
     the new flags so it keeps working (its cake seeded state.cake above) */
  if (state.bc.custom == null) state.bc.custom = false;
  /* 2026-08-04: state saved before dams existed comes back without the key.
     Normalise it HERE, not only where the number is computed — otherwise the
     math quietly used two dams while the chip row showed nothing selected,
     which is worse than either default (caught in verification). */
  if (state.bc.dams == null) state.bc.dams = 2;
  if (state.ga.custom == null) { state.ga.custom = false; }
  if (!state.ga.dripScope) state.ga.dripScope = 'top';
  if (state.ct.custom == null) state.ct.custom = false;
  if (!state.ct.cakeLayers) state.ct.cakeLayers = [];
  if (!state.ct.cakeFlavours) state.ct.cakeFlavours = [];
  if (!state.fl) state.fl = { custom: false, tiers: null, type: 'studio' };
  /* 2026-09-14 (Mariya): per-calculator tier overrides retired - force every
     calculator back onto the shared cake tiers, clearing any saved custom set. */
  ['bc', 'ga', 'ct', 'fl'].forEach(function (k) { if (state[k]) { state[k].custom = false; state[k].tiers = null; } });
  if (state.bookingId === undefined) state.bookingId = null;      /* §3.2 scoped-booking id */
  if (state.bookingName === undefined) state.bookingName = null;
  /* legacy scaler states picked "Half sheet" before the quarter-only
     rule — migrate loss-free: 1 half = exactly 2 quarter sheets */
  ['src', 'tgt'].forEach(function (k) {
    var p = state.sc && state.sc[k];
    if (p && p.shape === 'halfSheet') { p.shape = 'quarterSheet'; p.layers = (p.layers || 1) * 2; }
  });

  /* ---------- the cake every tool reads ---------- */
  var updaters = [];   // each tool registers a refresh; cake edits fan out
  function cloneTiers(ts) { return ts.map(function (t) { return { d: t.d, h: t.h, shape: t.shape }; }); }
  function topTierOf(ts) { return ts.slice().sort(function (a, b) { return a.d - b.d; })[0] || null; }
  function cakeSummary() {
    /* r42: a faux tier is labelled in the summary so the drop in batter
       and filling reads as deliberate, not as a bug. Silently smaller
       numbers are the thing that makes her distrust the tool. */
    return state.cake.tiers.slice().sort(function (a, b) { return b.d - a.d; })
      .map(function (t) { return sizeLabel(t.d) + (t.faux ? ' faux' : ''); }).join(' + ');
  }
  /* batter layers derived from the cake tier's height: her 4" standard
     tier = 3 layers (matches every pre-strip default), one more layer
     per extra inch. Explicit per-tier picks in ct.cakeLayers win. */
  function ctDerivedLayers(i) {
    var explicit = state.ct.cakeLayers[i];
    if (explicit != null) return explicit;
    var t = state.cake.tiers[i];
    return stdLayers((t && t.h) || 4);
  }
  function bcTiersEff() { return state.bc.custom ? state.bc.tiers : state.cake.tiers; }
  function gaTiersEff() {
    if (state.ga.custom) return state.ga.tiers;
    if (state.ga.app === 'drip' && state.ga.dripScope !== 'cake') {
      var t = topTierOf(state.cake.tiers);
      return t ? [t] : [];
    }
    return state.cake.tiers;
  }
  function ctPerEff() {
    if (state.ct.custom) return state.ct.tiers;
    /* r42: a FAUX tier is never baked, so it contributes no batter and no
       filling. Mapped first so ctDerivedLayers(i) still reads the right
       index, then dropped — filtering first would shift every layer
       lookup by one and quietly mis-size the real tiers. Coverage is a
       different question: gaTiersEff/bcTiersEff deliberately KEEP faux
       tiers, because a dummy still gets ganached and covered. */
    return state.cake.tiers.map(function (t, i) {
      return { d: t.d, shape: t.shape, layers: ctDerivedLayers(i), flavour: state.ct.cakeFlavours[i] || '', faux: !!t.faux };
    }).filter(function (t) { return !t.faux; });
  }

  /* persist = this tool's own state ONLY. The shared cake broadcasts
     exclusively through persistCake (a real strip edit) — a recompute
     in any calculator can never clobber a cake sized elsewhere. */
  function persist() {
    writeJSON(STATE_KEY, state);
  }
  /* ---- the shared Cake Chip (§3.1): the "your cake" strip's identity in
     one line, driven live so it always mirrors the strip. ---- */
  var CHIP_ORIGINS = { serving: 'Serving', structure: 'Structure', 'batch-math': 'Batch Math', pricing: 'Pricing', planner: 'the Planner', timeline: 'the Planner' };
  function chipCakeSummary() {
    var ts = state.cake.tiers.slice().sort(function (a, b) { return b.d - a.d; });
    var sizes = ts.map(function (t) { return sizeLabel(t.d); }).join(' + ');
    var shp = {};
    ts.forEach(function (t) { shp[normShape(t.shape)] = 1; });
    var keys = Object.keys(shp);
    return sizes + ' · ' + (keys.length === 1 ? keys[0] : 'mixed shapes');
  }
  /* Landing handoff round 2 (2026-07-21): the Your-cake builder card stays
     FULLY visible even when a client file is active — the mock's always-on
     top section with the interactive tiers. (This retires Fix 02 P1-8's
     collapse-to-chip; the chip stays as the identity line inside the card.) */
  var ycExpanded = false;
  function syncYourCake() {
    var sec = document.getElementById('your-cake');
    if (!sec) return;
    sec.classList.remove('is-collapsed');
  }
  /* r5: "change" opens the shared file popover — it must NOT also expand the
     Your-cake section underneath it (two things moving on one tap). The
     section is expanded by its own control now. */

  function driveBatchChip() {
    var mount = document.getElementById('bmath-cakechip');
    if (!mount) return;
    mount.setAttribute('data-ld-summary', chipCakeSummary());
    mount.setAttribute('data-ld-origin',
      (cakeFrom && cakeFrom !== 'batch-math' && CHIP_ORIGINS[cakeFrom])
        ? 'from ' + CHIP_ORIGINS[cakeFrom] : 'your cake');
    var C = window.LAYERD && window.LAYERD.components;
    if (C && C.refreshCakeChips) C.refreshCakeChips();
    /* the flow's whole existence depends on whether a file is scoped, and
       this runs on every scope change — so it is the right hook */
    try { flowRender(); } catch (e) { }
  }

  /* Toolkit Fix 01: persistence is scope-aware. Unscoped edits keep today's
     scratch-slot broadcast. Scoped edits go through the §3.3 choice — asked
     once per client per page-session: "Update [name]'s file" writes the
     booking record (writeCake); "This calculation only" detaches to the
     just-the-math view with the edited tiers as the anonymous scratch cake.
     fromScope=true (re-seeding FROM the file) never writes back. */
  function persistCake(fromScope) {
    state.cake.at = Date.now();
    persist();
    if (state.bookingId && window.LdCakeFile) {
      if (!fromScope) scopedPersist();
    } else {
      writeSharedCake(state.cake.tiers);
    }
    driveBatchChip();
    try { window.dispatchEvent(new Event('layerd:cake-updated')); } catch (e) { }
  }
  function scopedPersist() {
    var key = 'bmath-scope-choice:' + state.bookingId;
    var choice = null;
    try { choice = sessionStorage.getItem(key); } catch (e) { }
    if (choice === 'file') {
      window.LdCakeFile.writeCake(state.cake.tiers, 'batch-math');
      return;
    }
    /* no remembered choice yet → ask, right above the strip */
    var host = document.getElementById('bmath-cake');
    if (!host || host.querySelector('.bmath-scopeask')) return;
    var name = state.bookingName || 'this file';
    var card = el('div', { class: 'ld-callout ld-callout--check bmath-scopeask' }, [
      el('span', { class: 'ld-callout__label', text: 'Where should these tiers go?' }),
      el('div', { class: 'bmath-scopeask__row' }, [
        el('button', { class: 'ld-btn ld-btn--primary', type: 'button', text: 'Update ' + name + '’s file',
          onclick: function () {
            try { sessionStorage.setItem(key, 'file'); } catch (e) { }
            card.remove();
            window.LdCakeFile.writeCake(state.cake.tiers, 'batch-math');
            driveBatchChip();
          } }),
        el('button', { class: 'ld-btn ld-btn--secondary', type: 'button', text: 'This calculation only',
          onclick: function () {
            card.remove();
            var tiersNow = state.cake.tiers;
            window.LdCakeFile.writeScratch(tiersNow, 'batch-math');
            clearBookingScope();
            window.LdCakeFile.setActiveBooking(null, 'batch-math');
          } })
      ])
    ]);
    host.insertBefore(card, host.firstChild);
  }

  /* ---------- shared form widgets ---------- */
  function select(options, value, onchange) {
    var s = el('select', { class: 'bmath-select' });
    options.forEach(function (o) {
      s.appendChild(el('option', { value: String(o[0]), text: o[1] }));
    });
    s.value = String(value);
    s.addEventListener('change', function () { onchange(s.value); });
    return s;
  }
  function field(labelText, control) {
    return el('label', { class: 'ld-field' }, [
      el('span', { class: 'ld-field__label', text: labelText }), control
    ]);
  }

  /* Same height range as the Serving calculator. 4" is the standard
     two-layer tier (Wilton-aligned — matches Structure's standardTierIn);
     5" is offered as its own option; 6"+ reads as tall, 8" is
     double-barrel territory. Option labels follow the units toggle. */
  function diameterOpts() {
    var a = [];
    for (var d = 4; d <= 16; d++) a.push([d, sizeLabel(d)]);
    return a;
  }
  var HEIGHT_TAGS = { 4: ' standard', 5: '', 6: ' tall', 7: ' tall', 8: ' double-barrel' };
  function heightOpts() {
    return [4, 5, 6, 7, 8].map(function (h) { return [h, sizeLabel(h) + HEIGHT_TAGS[h]]; });
  }
  var SHAPES = [['round', 'Round'], ['square', 'Square'], ['heart', 'Heart']];

  /* r92 (Mariya): units + mixer bowl COMBINED into the one settings
     chip — "both the metric and bowl size are stated with one button
     to change in settings." The inline pill is fully retired on this
     page: the settings popup is the one editor for both facts, its
     writes land as (synthetic) storage events, and the r87 listener
     below re-runs every calculator and re-labels this chip. */
  function unitsBowlLabel() {
    var u = unitPref() === 'cm' ? 'cm' : 'inches';
    var b = (cfg && cfg.bowl && cfg.bowl.sizes) ? bowlPref() + ' qt bowl · ' : '';
    return u + ' · ' + b + 'change in settings';
  }
  function unitToggle() {
    var chip = el('a', {
      class: 'bmath-bowlnote ld-setopen', href: '/pages/studio?ldsp=account',
      'aria-label': 'Measurement units and mixer bowl, change in Studio settings'
    });
    chip.id = 'bmathBowlNote';
    chip.textContent = unitsBowlLabel();
    return el('span', { class: 'bmath-units' }, [chip]);
  }

  /* One tier row: size / height / shape / remove */
  function tierRow(tiers, i, onAny) {
    var tier = tiers[i];
    var kids = [
      /* redesign r2 slice 3: the prototype's serif number chip (presentational) */
      el('span', { class: 'bmath-tiernum', 'aria-hidden': 'true', text: String(i + 1) }),
      field('Size', select(diameterOpts(), tier.d, function (v) { tier.d = +v; onAny(); })),
      field('Height', select(heightOpts(), tier.h, function (v) { tier.h = +v; onAny(); })),
      field('Shape', select(SHAPES, tier.shape, function (v) { tier.shape = v; onAny(); }))
    ];
    if (tiers.length > 1) {
      /* round 25 (handoff 18a fix 4): a quiet × in muted ink — no alarm
         red anywhere in this system */
      kids.push(el('button', {
        class: 'bmath-remove', type: 'button', text: '×',
        title: 'Remove tier ' + (i + 1),
        'aria-label': 'Remove tier ' + (i + 1),
        onclick: function () { tiers.splice(i, 1); onAny(true); }
      }));
    }
    return el('div', { class: 'bmath-tierrow' }, kids);
  }

  /* Tier list + add button. rerender(true) rebuilds the rows.
     Returns the rebuild function so callers can refresh the rows after
     replacing the array's contents (the ganache "use my tiers" sync). */
  function tierList(container, tiers, maxTiers, onChange) {
    function rebuild() {
      clearNode(container);
      tiers.forEach(function (_, i) {
        container.appendChild(tierRow(tiers, i, function (structural) {
          if (structural) rebuild();
          onChange();
        }));
      });
      if (tiers.length < maxTiers) {
        container.appendChild(el('button', {
          class: 'ld-btn ld-btn--secondary bmath-add', type: 'button', text: '+ Add a tier',
          onclick: function () {
            var last = tiers[tiers.length - 1];
            var next = Math.min(last.d + 2, 16);
            tiers.push({ d: next, h: last.h, shape: last.shape });
            rebuild();
            onChange();
          }
        }));
      }
    }
    rebuild();
    return rebuild;
  }

  /* §3.1 (addendum) — the six "This cake / A different cake" switches are
     retired. The cake is declared ONCE at the top; each calculator carries
     only a quiet, collapsed "Override for this calculator" link for the
     genuine one-off. Using it visibly detaches the calculator (outlined
     chip state) with one obvious way back. Same signature and seeding as
     the old toggle, so every call site is unchanged. */
  function scopeToggle(s, onFlip) {
    /* 2026-09-14 (Mariya): the per-calculator "Override for this calculator"
       tier editor is retired with the main cake tier editor - Batch Math reads
       the cake (resize it in Serving), so every calculator uses the shared cake
       tiers. The override UI is gone; s.custom is forced false at load. */
    s.custom = false;
    return document.createDocumentFragment();
    /* eslint-disable no-unreachable */
    if (!s.custom) {
      var link = el('button', {
        class: 'bmath-override__link', type: 'button',
        text: 'Override for this calculator',
        'aria-expanded': 'false'
      });
      link.addEventListener('click', function () {
        s.custom = true;
        if (!s.tiers || !s.tiers.length) s.tiers = cloneTiers(state.cake.tiers);
        onFlip();
      });
      return el('div', { class: 'bmath-override' }, [link]);
    }
    /* detached: the outlined chip + the way home */
    var back = el('button', {
      class: 'bmath-override__back', type: 'button',
      text: 'Back to your cake, ' + cakeSummary()
    });
    back.addEventListener('click', function () { s.custom = false; onFlip(); });
    return el('div', { class: 'bmath-override is-detached' }, [
      el('span', { class: 'bmath-override__chip', text: 'Using its own cake, detached from the strip' }),
      back
    ]);
  }

  /* The strip itself. Editing the cake re-renders every registered tool.
     If the mount is missing (an older template still live — safe deploy
     order is JS first), every tool falls back to its own tier list. */
  var cakeRoot = document.getElementById('bmath-cake');
  var NO_STRIP = !cakeRoot;
  if (NO_STRIP) {
    ['bc', 'ga', 'ct', 'fl'].forEach(function (k) {
      state[k].custom = true;
      if (!state[k].tiers || !state[k].tiers.length) {
        state[k].tiers = (k === 'ct')
          ? state.cake.tiers.map(function (t, i) { return { d: t.d, shape: t.shape, layers: ctDerivedLayers(i), flavour: state.ct.cakeFlavours[i] || '' }; })
          : cloneTiers(state.cake.tiers);
      }
    });
  }
  var cakeStripRebuild = null;   /* captured so a booking scope can re-render the strip */
  var bakeDayRender = null;   /* the picker's re-render hook (batter save) */
  function cakeInit() {
    if (!cakeRoot) return;
    var FROM_LABEL = { serving: 'Serving', pricing: 'Pricing', structure: 'Structure', 'batch-math': 'your last visit here' };
    var note = cakeSeed === 'suite'
      ? 'Started from the cake you sized in ' + (FROM_LABEL[cakeFrom] || 'the LAYER’D Toolkit') +
        ', adjust anything here and every calculator below (and the other tools) follows.'
      : cakeSeed === 'visit'
        ? 'Your cake from earlier, every calculator below reads it.'
        : 'Set it once, every calculator below reads this cake. For a genuine one-off, each calculator has a quiet “Override” link.';

    /* 7a — the off-book state opens with every tier COLLAPSED; Edit opens
       exactly one. Scoped-to-a-client keeps the classic full form (the
       file supplies the tiers there). */
    var openIdx = null;

    function jmTierLabel(t) { return sizeLabel(t.d) + ' ' + (t.shape || 'round'); }
    function jmRole(i, n) { return i === 0 ? 'base' : (i === n - 1 ? 'top' : ''); }
    function jmEffFor(tiers) {
      var s = state.ct;
      return {
        tiers: tiers.map(function (t, i) { return { d: t.d, h: t.h, shape: t.shape, layers: stdLayers(t.h), flavour: '' }; }),
        vessel: s.vessel, roundRef: s.roundRef, roundRefLayers: s.roundRefLayers
      };
    }
    function jmBatchText(run) {
      var s = state.ct;
      return s.vessel === 'round'
        ? run.batches + (run.batches === 1 ? ' batch' : ' batches')
        : run.batchesQ + ' quarter-sheet ' + (run.batchesQ === 1 ? 'batch' : 'batches');
    }
    /* the slim cake-so-far elevation (7a): stacked to scale, the tier
       being edited tinted plum */
    function jmElevation() {
      var tiers = state.cake.tiers.slice().sort(function (a, b) { return b.d - a.d; });
      var maxD = tiers[0] ? tiers[0].d : 10;
      var W = 96, PADX = 10, boardH = 6;
      var scale = (W - PADX * 2) / maxD;
      var hpx = function (t) { return Math.max(14, (t.h || 4) * 3.2); };
      var totalH = tiers.reduce(function (a, t) { return a + hpx(t); }, 0);
      var H = totalH + boardH + 16;
      var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" width="82" style="display:block;flex:none" aria-label="Your cake taking shape">';
      s += '<rect x="' + (PADX - 4) + '" y="' + (H - boardH - 2) + '" width="' + (W - PADX * 2 + 8) + '" height="' + boardH + '" rx="2" fill="#2A2138"/>';
      var y = H - boardH - 2;
      /* editing highlight follows the UNSORTED index the rows use */
      var srcIdx = state.cake.tiers.map(function (t, i) { return { t: t, i: i }; }).sort(function (a, b) { return b.t.d - a.t.d; });
      srcIdx.forEach(function (x) {
        var th = hpx(x.t), tw = x.t.d * scale;
        y -= th;
        var on = openIdx === x.i;
        s += '<rect x="' + ((W - tw) / 2) + '" y="' + y + '" width="' + tw + '" height="' + (th - 2) + '" rx="3" ' +
             (on ? 'fill="#2A2138" opacity="0.16" stroke="#2A2138"' : 'fill="#F3EEF0" stroke="rgba(42,33,56,.35)"') + '/>';
      });
      return s + '</svg>';
    }

    /* redesign r2f (her screenshot): ONE Cake set-up card for both states.
       Each row states the tier, carries THIS calculator's per-tier figure,
       and opens the real fields in place on EDIT. The figures come from the
       same engine as the totals, run one tier at a time - which is why they
       round up on their own (the note under the rows says exactly that). */
    var SETUP_TAB = { batter: 'Batter', ganache: 'Ganache', fillings: 'Fillings', buttercream: 'Buttercream' };
    function activeTabId() {
      var on = document.querySelector('.bmath-tool.is-tab-active');
      return on ? on.id : 'batter';
    }
    function perTierFigure(t, i) {
      var Q = window.LAYERD && window.LAYERD.quantities;
      if (!Q || !cfg) return '';
      var one = [{ d: t.d, h: t.h, shape: t.shape }];
      try {
        var id = activeTabId();
        if (id === 'buttercream') {
          var b = bcEffState();
          var rc = Q.buttercream(cfg, { tiers: one, finish: b.finish, fillOn: b.fillOn, layers: b.layers, fillThick: b.fillThick }, { bowl: bowlPref() });
          return (rc.per && rc.per[0]) ? fmtG(rc.per[0].total) : '';
        }
        if (id === 'ganache') {
          var g = gaEffState();
          var rg = Q.ganache(cfg, { tiers: one, app: g.app, choc: g.choc, layers: g.layers });
          return (rg.per && rg.per[0]) ? fmtG(rg.per[0].grams) : '';
        }
        if (id === 'fillings') {
          var f = flEffState();
          var rf = Q.fillings(cfg, { tiers: one, type: f.type });
          return (rf.per && rf.per[0]) ? fmtG(flRound(rf.per[0].g)) : '';
        }
        /* default: batter, the page's opening question */
        /* short form on the row \u2014 the panel beside it spells the unit out */
        return '\u2248 ' + jmBatchText(ctCompute(jmEffFor(one))).replace('quarter-sheet ', '');
      } catch (e) { return ''; }
    }
    /* the card - identical markup scoped or not; `tiers` is the live array */
    /* ---- Studio Book r90 (her screenshots): THE BUILD card. Head is
       the design's "The build \u00b7 gold rule \u00b7 + tier"; the tier stack is
       the control; below a hairline, the ACTIVE tier's editor \u2014
       diameter chips, a layers stepper and the shape pills. One tier
       is always active. The layers stepper drives the live model's
       HEIGHT (layers = height \u2212 1, the standing standard-layers rule),
       so Serving, Structure and the shared cake read exactly what they
       always did \u2014 the stepper is a different handle on the same fact,
       shown with its height so nothing is hidden. The old per-tier
       figure rows retire; the bake sheet below carries per-tier maths. */
    function setupCard(tiers, onEdit) {
      if (openIdx == null || openIdx >= tiers.length || openIdx < 0) openIdx = 0;

      var addBtn = el('button', { class: 'bmath-build__add', type: 'button', text: '+ tier' });
      addBtn.addEventListener('click', function () {
        if (tiers.length >= 6) return;
        var last = tiers[tiers.length - 1] || { d: 6, h: 4, shape: 'round' };
        tiers.push({ d: Math.min(last.d + 2, 16), h: last.h, shape: last.shape });
        openIdx = tiers.length - 1;
        onEdit();
      });
      if (tiers.length >= 6) addBtn.hidden = true;
      cakeRoot.appendChild(el('div', { class: 'bmath-build__head' }, [
        el('span', { class: 'bmath-build__eyebrow', text: 'The build' }),
        el('span', { class: 'bmath-build__rule', 'aria-hidden': 'true' }),
        addBtn
      ]));

      /* r92 (Mariya): the cake drawing is now the SAME renderer Serving
         uses \u2014 LAYERD.cakeCore.renderStack, one cake illustration for
         the whole suite \u2014 with the r92 interactive opts: each tier is a
         tappable, focusable group and the selected tier wears a quiet
         lavender wash. A theme still serving the older cake-core (no
         renderStackInteractive) falls back to the labelled slab stack,
         which stays fully selectable. */
      var CORE = window.LAYERD && window.LAYERD.cakeCore;
      if (CORE && CORE.renderStackInteractive) {
        var fig = el('div', { class: 'bmath-cakefig' });
        fig.innerHTML = CORE.renderStack(tiers.map(function (t) {
          return { size: t.d, height: t.h || 4, shape: t.shape || 'round' };
        }), { highlight: openIdx, interactive: true });
        var pickFromFig = function (ev) {
          var g = ev.target && ev.target.closest ? ev.target.closest('[data-tier-i]') : null;
          if (!g) return false;
          openIdx = +g.getAttribute('data-tier-i') || 0;
          rebuildStrip();
          return true;
        };
        fig.addEventListener('click', pickFromFig);
        fig.addEventListener('keydown', function (ev) {
          if (ev.key !== 'Enter' && ev.key !== ' ') return;
          if (pickFromFig(ev)) ev.preventDefault();
        });
        cakeRoot.appendChild(fig);
        cakeRoot.appendChild(el('p', { class: 'bmath-cakefig__hint', text: 'Tap a tier on the cake to edit it' }));
      } else {
        var stack = el('div', { class: 'bmath-stack', role: 'group', 'aria-label': 'Your tiers, stacked to scale' });
        tiers.map(function (t, i) { return { t: t, i: i }; })
          .sort(function (a, b) { return a.t.d - b.t.d; })
          .forEach(function (x) {
            var layers = stdLayers(x.t.h);
            var on = openIdx === x.i;
            var slab = el('button', {
              class: 'bmath-stack__tier' + (on ? ' is-active' : '') + (x.t.shape === 'square' ? ' is-square' : ''),
              type: 'button',
              'aria-label': 'Tier ' + (x.i + 1) + ' \u2014 ' + sizeLabel(x.t.d) + ' ' + (x.t.shape || 'round') + ', ' + layers + ' layers' + (on ? ' (selected)' : ''),
              onclick: function () { openIdx = x.i; rebuildStrip(); }
            }, [
              el('span', { class: 'bmath-stack__d', text: sizeLabel(x.t.d) }),
              el('span', { class: 'bmath-stack__l', text: layers + 'L' +
                (x.t.shape === 'heart' ? ' \u2661' : (x.t.shape === 'square' ? ' \u25a1' : '')) })
            ]);
            slab.style.width = Math.min(300, 26 + x.t.d * 15) + 'px';
            slab.style.height = (layers * 12 + 12) + 'px';
            stack.appendChild(slab);
          });
        stack.appendChild(el('span', { class: 'bmath-stack__board', 'aria-hidden': 'true' }));
        cakeRoot.appendChild(stack);
      }

      /* ---- the active tier's editor ---- */
      var t = tiers[openIdx];
      var ed = el('div', { class: 'bmath-build__editor' });

      var row1 = el('div', { class: 'bmath-build__row' }, [
        el('span', { class: 'bmath-build__lbl', text: 'Tier ' + (openIdx + 1) + ' \u00b7 diameter' })
      ]);
      if (tiers.length > 1) {
        var rm = el('button', { class: 'bmath-build__remove', type: 'button', text: 'remove',
          'aria-label': 'Remove tier ' + (openIdx + 1) });
        rm.addEventListener('click', function () {
          tiers.splice(openIdx, 1);
          openIdx = Math.max(0, openIdx - 1);
          onEdit();
        });
        row1.appendChild(rm);
      }
      ed.appendChild(row1);

      var chips = el('div', { class: 'bmath-build__diams' });
      for (var dv = 4; dv <= 16; dv++) (function (d) {
        var on = t.d === d;
        var b = el('button', { class: 'bmath-build__diam' + (on ? ' is-active' : ''),
          type: 'button', text: sizeLabel(d), 'aria-pressed': on ? 'true' : 'false' });
        b.addEventListener('click', function () { t.d = d; onEdit(); });
        chips.appendChild(b);
      })(dv);
      ed.appendChild(chips);

      /* layers stepper \u2014 height is the stored fact; shown beside it */
      function stepBtn(sym, delta) {
        var b = el('button', { class: 'bmath-build__stepbtn', type: 'button', text: sym,
          'aria-label': (delta > 0 ? 'One more layer' : 'One layer fewer') });
        b.addEventListener('click', function () {
          var h = Math.min(8, Math.max(4, (t.h || 4) + delta));
          if (h !== t.h) { t.h = h; onEdit(); }
        });
        return b;
      }
      ed.appendChild(el('div', { class: 'bmath-build__row bmath-build__row--step' }, [
        el('span', { class: 'bmath-build__lblcol' }, [
          el('span', { class: 'bmath-build__lbl', text: 'Layers' }),
          el('span', { class: 'bmath-build__hint', text: sizeLabel(t.h) + ' tall tier' })
        ]),
        el('span', { class: 'bmath-build__step' }, [
          stepBtn('\u2212', -1),
          el('span', { class: 'bmath-build__stepnum', text: String(stdLayers(t.h)) }),
          stepBtn('+', 1)
        ])
      ]));

      var shapes = el('span', { class: 'bmath-build__shapes' });
      SHAPES.forEach(function (s) {
        var on = (t.shape || 'round') === s[0];
        var b = el('button', { class: 'bmath-build__shape' + (on ? ' is-active' : ''),
          type: 'button', text: s[1], 'aria-pressed': on ? 'true' : 'false' });
        b.addEventListener('click', function () { t.shape = s[0]; onEdit(); });
        shapes.appendChild(b);
      });
      ed.appendChild(el('div', { class: 'bmath-build__row bmath-build__row--step' }, [
        el('span', { class: 'bmath-build__lbl', text: 'Shape' }),
        shapes
      ]));

      cakeRoot.appendChild(ed);
    }

    /* the shared why-it-rounds note, now under the bake sheet (its
       per-tier figures are the ones that round up on their own) */
    function roundNote() {
      var note = el('p', { class: 'bmath-infowrap bmath-setup__note' });
      note.appendChild(el('span', { class: 'bmath-info__lbl', text: 'Per-tier figures round up. Mix the cake total.' }));
      var qb = el('button', { class: 'bmath-info', type: 'button', 'aria-expanded': 'false' });
      qb.innerHTML = '<span aria-hidden="true">?</span><span class="learn-visually-hidden">Why per-tier figures do not add up</span>';
      note.appendChild(qb);
      note.appendChild(el('span', { class: 'bmath-info__pop', role: 'note',
        text: 'Each tier rounds up on its own, so the per-tier figures can add to more than the cake total. The total beside them is the number to mix; it rounds once, over the whole cake.' }));
      return note;
    }

    /* ---- Studio Book r87: the ink summary band. The design's dark
       card under the build: the tier line plus the three headline
       figures — batter, fillings, buttercream — computed with the SAME
       engine calls and effective states the sections themselves use,
       so the band can never disagree with a section. No servings here:
       servings live in the Serving calculator, and this page never
       invents a number it doesn't own. Text-only refresh on the
       debounced document listener below, so an in-section change
       (finish, filling type) updates the band without tearing down
       the cake card mid-interaction. ---- */
    /* wedding-portion servings from the ONE shared Wilton-verified table
       (learn-cake-core, height-scaled). Absent core or an off-chart size
       → 0, and the band falls back to the fillings figure — a number is
       never invented. Labelled "wedding servings" deliberately: the
       party/wedding distinction is the documented open contradiction,
       so the band says which column it is quoting. */
    /* r91b (Mariya): off-chart tier sizes now get a FLAGGED estimate from
       the shared table (cakeCore.servingsEstimated — area-interpolated
       between the charted sizes, her sanctioned exception to the
       no-interpolation rule) instead of a dash. The star + footnote are
       non-negotiable: an estimate never renders unmarked. */
    /* r94 (Mariya): "shouldn't it have an option to switch to party
       servings?" — the occasion is now a persisted page preference
       (wedding default, the standing column) with a small toggle in the
       band; the band AND the bake sheet follow it. */
    var OCC_KEY = 'layerd-bm-occasion';
    function occPref() {
      try { return localStorage.getItem(OCC_KEY) === 'party' ? 'party' : 'wedding'; } catch (e) { return 'wedding'; }
    }
    function cakeServings(tiers, occ) {
      var core = window.LAYERD && window.LAYERD.cakeCore;
      if (!core || !core.servingsFor) return null;   /* no table on this page */
      var est = core.servingsEstimated || null;
      var total = 0, estimated = [], unknowable = false;
      tiers.forEach(function (t) {
        if (t.faux) return;   /* a dummy tier feeds no one */
        var shape = t.shape || 'round';
        var r = est ? est(shape, t.d, occ, t.h || 4)
          : { n: core.servingsFor(shape, t.d, occ, t.h || 4), estimate: false };
        if (!r.n) { unknowable = true; return; }
        if (r.estimate) {
          var lbl = sizeLabel(t.d) + ' ' + shape;
          if (estimated.indexOf(lbl) === -1) estimated.push(lbl);
        }
        total += r.n;
      });
      return { total: total, estimated: estimated, unknowable: unknowable };
    }
    var sumRefs = null;
    function sumValues() {
      var tiers = state.cake.tiers;
      var run = ctCompute(jmEffFor(tiers));
      var bc = bcCompute(bcEffState());
      var fl = flCompute(flEffState());
      var sizes = tiers.slice().sort(function (a, b) { return b.d - a.d; })
        .map(function (t) { return sizeLabel(t.d); }).join(' + ');
      var line = tiers.length + (tiers.length === 1 ? ' tier · ' : ' tiers · ') + sizes;
      if (state.bookingId) {
        var bs = readBookings();
        for (var i = 0; i < bs.length; i++) {
          if (bs[i].id === state.bookingId && (bs[i].name || '').trim()) { line += ' · ' + bs[i].name.trim(); break; }
        }
      }
      var occ = occPref();
      var sv = cakeServings(tiers, occ);
      var first, svNote = '';
      if (!sv) {
        /* no servings table on this page (older theme asset) — fillings stands in */
        first = { v: '≈ ' + fmtG(flRound(fl.total)), l: 'fillings' };
      } else if (sv.unknowable) {
        /* stale cake-core without the estimator + an uncharted size */
        first = { v: 'n/a', l: 'servings · size not in the chart' };
      } else if (sv.estimated.length) {
        first = { v: sv.total + '*', l: occ + ' servings' };
        svNote = '* ' + sv.estimated.join(' & ') +
          (sv.estimated.length === 1 ? ' isn’t' : ' aren’t') +
          ' in the Wilton chart, estimated from the charted sizes.';
      } else {
        first = { v: String(sv.total), l: occ + ' servings' };
      }
      return {
        line: line,
        note: svNote,
        batterV: first.v, batterL: first.l,
        flV: '≈ ' + (state.ct.vessel === 'round' ? run.batches : run.batchesQ),
        flL: state.ct.vessel === 'round'
          ? (run.batches === 1 ? 'batter batch' : 'batter batches')
          : 'qtr-sheet batches',
        bcV: '≈ ' + fmtG(bc.total), bcL: 'buttercream'
      };
    }
    function summaryBand() {
      var v;
      try { v = sumValues(); } catch (e) { sumRefs = null; return null; }
      var mk = function (val, lbl) {
        var vs = el('span', { class: 'bmath-sumband__num', text: val });
        var ls = el('span', { class: 'bmath-sumband__lbl', text: lbl });
        return { cell: el('span', { class: 'bmath-sumband__stat' }, [vs, ls]), v: vs, l: ls };
      };
      var line = el('span', { class: 'bmath-sumband__line', text: v.line });
      var a = mk(v.batterV, v.batterL), b = mk(v.flV, v.flL), c = mk(v.bcV, v.bcL);
      var foot = el('span', { class: 'bmath-sumband__foot', text: v.note || '' });
      foot.hidden = !v.note;
      /* r94: the wedding / party toggle rides the band's top line */
      var occNow = occPref();
      var occWrap = el('span', { class: 'bmath-sumband__occ', role: 'group', 'aria-label': 'Serving size standard' });
      [['wedding', 'Wedding'], ['party', 'Party']].forEach(function (o) {
        var on = occNow === o[0];
        var ob = el('button', { class: 'bmath-sumband__occb' + (on ? ' is-active' : ''),
          type: 'button', text: o[1], 'aria-pressed': on ? 'true' : 'false' });
        ob.addEventListener('click', function () {
          try { localStorage.setItem(OCC_KEY, o[0]); } catch (e) { }
          rebuildStrip();   /* band + bake sheet both follow */
        });
        occWrap.appendChild(ob);
      });
      sumRefs = { line: line, a: a, b: b, c: c, foot: foot };
      return el('div', { class: 'bmath-sumband' }, [
        el('span', { class: 'bmath-sumband__top' }, [line, occWrap]),
        el('span', { class: 'bmath-sumband__stats' }, [a.cell, b.cell, c.cell]),
        foot
      ]);
    }
    function refreshSumBand() {
      if (!sumRefs || !sumRefs.line.isConnected) return;
      var v;
      try { v = sumValues(); } catch (e) { return; }
      sumRefs.line.textContent = v.line;
      sumRefs.a.v.textContent = v.batterV; sumRefs.a.l.textContent = v.batterL;
      sumRefs.b.v.textContent = v.flV; sumRefs.b.l.textContent = v.flL;
      sumRefs.c.v.textContent = v.bcV; sumRefs.c.l.textContent = v.bcL;
      sumRefs.foot.textContent = v.note || '';
      sumRefs.foot.hidden = !v.note;
    }
    /* ---- Studio Book r90: WEIGH OUT — the design's consolidated list.
       One row per product the page's calculators own (batter, filling,
       buttercream, ganache): kind eyebrow, the real product name, a
       quiet fact line, the figure in serif on the right with the batch
       line under it. Every number is the section's own engine call with
       the section's own effective state — a row is a summary of, and a
       door to, its calculator (tap = open that section). No soak and no
       garnish rows: this page has no calculator for them, and a number
       is never invented. ---- */
    var APP_LBL = { drip: 'drip', coat: 'full coat', fill: 'as the filling' };
    function finishLabel(key) {
      for (var i = 0; i < FINISHES.length; i++) if (FINISHES[i][0] === key) return FINISHES[i][1];
      return key;
    }
    function weighValues() {
      var run = ctCompute(jmEffFor(state.cake.tiers));
      var fl = flCompute(flEffState());
      var bc = bcCompute(bcEffState());
      var ga = gaCompute(gaEffState());
      var types = flTypes();
      var ft = types[state.fl.type];
      if (!ft) { for (var k in types) { ft = types[k]; break; } }
      var beds = 0;
      (fl.per || []).forEach(function (p) { beds += p.layers; });
      var round = state.ct.vessel === 'round';
      return {
        batter: {
          name: round ? 'Sponge batter, round pans' : 'Sponge batter, sheet pans',
          sub: state.cake.tiers.length + (state.cake.tiers.length === 1 ? ' tier' : ' tiers') + ' · layers from your build',
          val: '≈ ' + (round ? run.batches : run.batchesQ),
          subv: round ? (run.batches === 1 ? 'batch of your base' : 'batches of your base') : 'quarter-sheet batches'
        },
        fill: {
          name: (ft && ft.label) || 'Filling',
          sub: beds + (beds === 1 ? ' filling bed' : ' filling beds') + ' · ' + (fl.insurancePct || 10) + '% margin in',
          val: '≈ ' + fmtG(flRound(fl.total)),
          subv: ''
        },
        bc: {
          name: (cfg && cfg.batchLabel) || 'Buttercream',
          sub: finishLabel(state.bc.finish).toLowerCase() + ' finish · crumb + final coat',
          val: '≈ ' + fmtG(bc.total),
          subv: 'make ' + bc.makeBatches + (bc.makeBatches === 1 ? ' batch' : ' batches')
        },
        ga: {
          name: 'Ganache, ' + (CHOC_SHORT[state.ga.choc] || state.ga.choc),
          sub: (APP_LBL[state.ga.app] || state.ga.app) + ' · ' + ga.ratio + ':1 chocolate to cream',
          val: '≈ ' + fmtG(ga.total),
          subv: fmtG(ga.choc) + ' choc · ' + fmtG(ga.cream) + ' cream'
        }
      };
    }
    var weighRefs = null;
    /* r169 (Mariya: "pick and choose which items you want in your top
       summary table ... I don't want ganache included most days").
       DISPLAY ONLY - the calculators and the save path are untouched, so
       hiding a row can never drop that component from a cake. */
    var WEIGH_KEY = 'layerd-batch-weigh-rows';
    function weighPrefs() {
      var p = { batter: true, fill: true, bc: true, ga: true };
      try {
        var raw = JSON.parse(localStorage.getItem(WEIGH_KEY));
        if (raw && raw.v === 1 && raw.rows) {
          for (var k in p) if (raw.rows[k] === false) p[k] = false;
        }
      } catch (e) { }
      return p;
    }
    function setWeighPref(key, on) {
      var p = weighPrefs();
      p[key] = !!on;
      try { localStorage.setItem(WEIGH_KEY, JSON.stringify({ v: 1, rows: p })); } catch (e) { }
    }
    function weighOut() {
      var v;
      try { v = weighValues(); } catch (e) { weighRefs = null; return null; }
      var refs = {};
      var prefs = weighPrefs();
      var wrap = el('div', { class: 'bmath-weigh' });
      var chooseBtn = el('button', { class: 'bmath-weigh__choose', type: 'button',
        'aria-expanded': 'false', text: 'choose' });
      wrap.appendChild(el('div', { class: 'bmath-build__head bmath-weigh__head' }, [
        el('span', { class: 'bmath-build__eyebrow', text: 'Weigh out' }),
        el('span', { class: 'bmath-build__rule', 'aria-hidden': 'true' }),
        chooseBtn
      ]));
      var DEFS = [['batter', 'Batter', 'batter'], ['fill', 'Filling', 'fillings'],
        ['bc', 'Frosting', 'buttercream'], ['ga', 'Ganache', 'ganache']];
      /* the picker: four toggles, shown on demand, redrawn on change */
      var pick = el('div', { class: 'bmath-weigh__pick' });
      pick.hidden = true;
      DEFS.forEach(function (d) {
        var on = prefs[d[0]] !== false;
        var t = el('button', { class: 'bmath-weigh__pickb' + (on ? ' is-on' : ''),
          type: 'button', 'aria-pressed': on ? 'true' : 'false', text: d[1] });
        t.addEventListener('click', function () {
          setWeighPref(d[0], !(prefs[d[0]] !== false));
          redrawWeigh(true);
        });
        pick.appendChild(t);
      });
      wrap.appendChild(pick);
      chooseBtn.addEventListener('click', function () {
        var openNow = pick.hidden;
        pick.hidden = !openNow;
        chooseBtn.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      });
      DEFS.filter(function (d) { return prefs[d[0]] !== false; }).forEach(function (d) {
        var key = d[0], row = v[key];
        var r = {
          name: el('span', { class: 'bmath-weigh__name', text: row.name }),
          sub: el('span', { class: 'bmath-weigh__sub', text: row.sub }),
          val: el('span', { class: 'bmath-weigh__val', text: row.val }),
          subv: el('span', { class: 'bmath-weigh__subv', text: row.subv })
        };
        refs[key] = r;
        var btn = el('button', { class: 'bmath-weigh__row', type: 'button',
          'aria-label': d[1] + ', open its calculator' }, [
          el('span', { class: 'bmath-weigh__main' }, [
            el('span', { class: 'bmath-weigh__kind', text: d[1] }),
            r.name, r.sub
          ]),
          el('span', { class: 'bmath-weigh__right' }, [r.val, r.subv])
        ]);
        btn.addEventListener('click', function () {
          var s = document.getElementById(d[2]);
          if (!s) return;
          var acc = s.querySelector('details[data-bmacc]');
          if (acc) acc.open = true;
          try { s.scrollIntoView({ block: 'start' }); } catch (e2) { s.scrollIntoView(); }
        });
        wrap.appendChild(btn);
      });
      weighRefs = refs;
      return wrap;
    }
    /* r169: rebuild in place when the row set changes - keeps the picker
       open so she can flip several at once */
    function redrawWeigh(keepPickerOpen) {
      var old = document.querySelector('.bmath-weigh');
      if (!old || !old.parentNode) return;
      var next = weighOut();
      if (!next) return;
      old.parentNode.replaceChild(next, old);
      if (keepPickerOpen) {
        var b = next.querySelector('.bmath-weigh__choose');
        if (b) b.click();
      }
    }
    function refreshWeigh() {
      /* r169: only the rows that are actually on screen - a hidden row
         has no refs, and the old batter-only guard assumed every key */
      if (!weighRefs) return;
      var anchor = weighRefs.batter || weighRefs.fill || weighRefs.bc || weighRefs.ga;
      if (!anchor || !anchor.name.isConnected) return;
      var v;
      try { v = weighValues(); } catch (e) { return; }
      Object.keys(weighRefs).forEach(function (k) {
        weighRefs[k].name.textContent = v[k].name;
        weighRefs[k].sub.textContent = v[k].sub;
        weighRefs[k].val.textContent = v[k].val;
        weighRefs[k].subv.textContent = v[k].subv;
      });
    }

    /* ---- Studio Book r90: BAKE SHEET — per tier, the numbers this
       page really owns: layer count + shape, wedding servings from the
       shared Wilton table (when the size is on the chart), and that
       tier's batter on its own. No oven temps or bake minutes — those
       live with the recipes, and this page never invents a number. ---- */
    function bakeSheet() {
      var core = window.LAYERD && window.LAYERD.cakeCore;
      var occ = occPref();
      var wrap = el('div', { class: 'bmath-bakesheet' });
      wrap.appendChild(el('div', { class: 'bmath-build__head bmath-weigh__head' }, [
        el('span', { class: 'bmath-build__eyebrow', text: 'Bake sheet' }),
        el('span', { class: 'bmath-build__rule', 'aria-hidden': 'true' }),
        el('span', { class: 'bmath-weigh__note', text: occ + ' servings' })
      ]));
      var card = el('div', { class: 'bmath-bakesheet__card' });
      var tiers = state.cake.tiers.slice().sort(function (a, b) { return a.d - b.d; });
      var starred = false;
      tiers.forEach(function (t) {
        var layers = stdLayers(t.h);
        /* r94 (her wrap complaint): the batter stacks as number-over-unit
           so the column stays narrow, and the servings line drops the
           occasion word (the sheet head names it once) */
        var perN = '', perL = '';
        try {
          var est = ctCompute(jmEffFor([t]));
          if (state.ct.vessel === 'round') {
            perN = '≈ ' + est.batches;
            perL = est.batches === 1 ? 'batch' : 'batches';
          } else {
            perN = '≈ ' + est.batchesQ;
            perL = 'qtr-sheet ' + (est.batchesQ === 1 ? 'batch' : 'batches');
          }
        } catch (e) { }
        var svTxt = '';
        if (core && core.servingsFor) {
          var r = core.servingsEstimated
            ? core.servingsEstimated(t.shape || 'round', t.d, occ, t.h || 4)
            : { n: core.servingsFor(t.shape || 'round', t.d, occ, t.h || 4), estimate: false };
          if (r.n) {
            svTxt = r.n + ' servings' + (r.estimate ? '*' : '');
            if (r.estimate) starred = true;
          }
        }
        card.appendChild(el('div', { class: 'bmath-bakesheet__row' }, [
          el('span', { class: 'bmath-bakesheet__d', text: sizeLabel(t.d) }),
          el('span', { class: 'bmath-bakesheet__mid' }, [
            /* round is the default — naming it on every row just fed the
               phone-width wrap; square/heart still say so */
            el('span', { class: 'bmath-bakesheet__line', text: layers + ' layers' +
              ((t.shape || 'round') === 'round' ? '' : ' · ' + t.shape) }),
            el('span', { class: 'bmath-bakesheet__sub', text: svTxt })
          ]),
          el('span', { class: 'bmath-bakesheet__per' }, [
            el('span', { class: 'bmath-bakesheet__pern', text: perN }),
            el('span', { class: 'bmath-bakesheet__perl', text: perL })
          ])
        ]));
      });
      wrap.appendChild(card);
      if (starred) wrap.appendChild(el('p', { class: 'bmath-bakesheet__foot',
        text: '* not in the Wilton chart, estimated from the charted sizes.' }));
      return wrap;
    }

    var sumTimer = null;
    ['input', 'change', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        if (sumTimer) clearTimeout(sumTimer);
        sumTimer = setTimeout(function () { refreshSumBand(); refreshWeigh(); }, 220);
      }, true);
    });

    function appendSummaries() {
      var sb = summaryBand();
      if (sb) cakeRoot.appendChild(sb);
      var w = weighOut();
      if (w) cakeRoot.appendChild(w);
      cakeRoot.appendChild(bakeSheet());
      cakeRoot.appendChild(roundNote());
    }

    /* UX 2026-09-11 (Mariya): the scoped read-only cake. The tiers come from
       the booking; editing them lives on the Studio booking page, reached by
       this cake's own "Toolkit" back-link + ?booking=<id>. */
    function scopedStudioUrl() {
      var a = document.querySelector('.bmath-head__back');
      var base = (a && a.getAttribute('href')) || '/pages/studio';
      return base + (base.indexOf('?') > -1 ? '&' : '?') + 'booking=' + encodeURIComponent(state.bookingId);
    }
    function scopedBookingName() {
      var bs = readBookings();
      for (var i = 0; i < bs.length; i++) if (bs[i].id === state.bookingId) return (bs[i].name || '').trim();
      return '';
    }
    function renderScopedCake() {
      var tiers = state.cake.tiers;
      var sizes = tiers.slice().sort(function (a, b) { return b.d - a.d; })
        .map(function (t) { return sizeLabel(t.d); }).join(' + ');
      var shapes = {}; tiers.forEach(function (t) { shapes[t.shape || 'round'] = 1; });
      var shapeTxt = Object.keys(shapes).length === 1 ? Object.keys(shapes)[0] : 'mixed shapes';
      var nm = scopedBookingName();
      var wrap = el('div', { class: 'bmath-scoped' });
      var CORE = window.LAYERD && window.LAYERD.cakeCore;
      var fig = el('div', { class: 'bmath-scoped__fig' });
      if (CORE && CORE.renderStack) {
        fig.innerHTML = CORE.renderStack(tiers.map(function (t) {
          return { size: t.d, height: t.h || 4, shape: t.shape || 'round' };
        }), { interactive: false });
      } else {
        fig.innerHTML = jmElevation();
      }
      wrap.appendChild(fig);
      wrap.appendChild(el('p', { class: 'bmath-scoped__spec',
        text: tiers.length + '-tier · ' + sizes + ' · ' + shapeTxt }));
      /* 2026-09-14 (Mariya): Batch Math no longer edits tiers - resizing lives
         in Serving (it writes the cake, which this page READS to size batches). */
      wrap.appendChild(el('a', { class: 'bmath-scoped__edit',
        href: '/pages/serving-size-calculator' + (state.bookingId ? '?file=' + encodeURIComponent(state.bookingId) : ''),
        text: 'Resize →' }));
      cakeRoot.appendChild(wrap);
    }

    function rebuildStrip() {
      clearNode(cakeRoot);

      if (state.bookingId) {
        /* UX 2026-09-11 (Mariya): scoped to a booking, the tiers are READ-ONLY
           here. The booking is the single source of truth, so edits happen on
           the Studio booking page - no accidental divergence, everything in
           one place. Standalone (no bookingId) keeps the full editor below. */
        renderScopedCake();
        appendSummaries();
        return;
      }
      if (false) {
        var runS = ctCompute(jmEffFor(state.cake.tiers));
        var sizesS = state.cake.tiers.slice().sort(function (a, b) { return b.d - a.d; })
          .map(function (t) { return sizeLabel(t.d); }).join(' · ');
        var shapesS = {}; state.cake.tiers.forEach(function (t) { shapesS[t.shape || 'round'] = 1; });
        var shapeTxtS = Object.keys(shapesS).length === 1 ? Object.keys(shapesS)[0] : 'mixed shapes';
        /* Round 25 (handoff 18a): ONE provenance line replaces the two
           centered paragraphs; the diagram anchors the controls beside it
           (the Serving turn-9 pattern); the batter result is promoted to a
           proper row. The cake is described ONCE — the chip above carries
           the identity, and this caption is the diagram's own label. */
        cakeRoot.appendChild(el('p', { class: 'bmath-yc__from', text:
          'From this cake’s client file, edits here stay on it and every calculator below follows.' }));

        var figure = el('div', { class: 'bmath-yc__figure' });
        figure.innerHTML = jmElevation();
        figure.appendChild(el('div', { class: 'bmath-yc__figcap', text: state.cake.tiers.length + '-tier' }));
        figure.appendChild(el('div', { class: 'bmath-yc__figspec', text: sizesS + ' · ' + shapeTxtS }));

        var side = el('div', { class: 'bmath-yc__side' });
        side.appendChild(el('div', { class: 'bmath-yc__result' }, [
          el('span', { class: 'bmath-yc__resultlbl', text: 'Batter' }),
          el('span', { class: 'bmath-yc__resultval' }, [
            el('span', { class: 'bmath-yc__num', text: '≈ ' + (state.ct.vessel === 'round' ? runS.batches : runS.batchesQ) }),
            el('span', { class: 'bmath-yc__unit', text: (state.ct.vessel === 'round' ? 'batches' : 'qtr-sheet batches') })
          ])
        ]));
        side.appendChild(el('div', { class: 'bmath-yc__cols' }, [
          el('span', { class: 'bmath-yc__col', text: 'Size' }),
          el('span', { class: 'bmath-yc__col', text: 'Height' }),
          el('span', { class: 'bmath-yc__col', text: 'Shape' })
        ]));
        var box = el('div', { class: 'bmath-tiers' });
        tierList(box, state.cake.tiers, 6, function () {
          persistCake();
          updaters.forEach(function (fn) { fn(); });
          rebuildStrip();   /* keep the cake visual live with the rows */
        });
        side.appendChild(box);

        cakeRoot.appendChild(el('div', { class: 'bmath-yc__grid' }, [figure, side]));
        return;
      }

      /* ---- 7a/7b: JUST THE MATH ---- */
      var tiers = state.cake.tiers;
      function onEdit() {
        persistCake();
        updaters.forEach(function (fn) { fn(); });
        rebuildStrip();
      }

      /* r93 (Mariya): the "Just the math · Attach a client" mode strip is
         retired — the client chip above the page already says the scope
         and carries the "start a client file" door, so this was the same
         fact twice. The card now leads straight with THE BUILD.
         2026-09-14 (Mariya): the editable BUILD (setupCard) is retired too -
         Batch Math reads the cake and sizes batches; resizing tiers lives in
         Serving. Unscoped now shows the same read-only cake + "Resize in
         Serving →" as scoped does (renderScopedCake reads state.cake.tiers). */
      renderScopedCake();
      appendSummaries();
      return;
      /* eslint-disable no-unreachable */
      /* live preview + running result (the REAL engine, batches only —
         servings live in the Serving calculator, not here) */
      var run = ctCompute(jmEffFor(tiers));
      var sizes = tiers.slice().sort(function (a, b) { return b.d - a.d; })
        .map(function (t) { return sizeLabel(t.d); }).join(' · ');
      var shapes = {}; tiers.forEach(function (t) { shapes[t.shape || 'round'] = 1; });
      var shapeTxt = Object.keys(shapes).length === 1 ? Object.keys(shapes)[0] : 'mixed shapes';
      var preview = el('div', { class: 'bmath-jm__preview' });
      preview.innerHTML = jmElevation();
      preview.appendChild(el('div', {}, [
        el('div', { class: 'bmath-jm__title', text: tiers.length + '-tier cake' }),
        el('div', { class: 'bmath-jm__sizes', text: sizes + ' · ' + shapeTxt + (openIdx != null ? ', editing tier ' + (openIdx + 1) : '') }),
        el('div', { class: 'bmath-jm__run' }, [
          el('span', { class: 'bmath-jm__num', text: '≈ ' + (state.ct.vessel === 'round' ? run.batches : run.batchesQ) }),
          el('span', { class: 'bmath-jm__unit', text: (state.ct.vessel === 'round' ? '' : 'quarter-sheet ') + 'batches of batter' })
        ])
      ]));
      cakeRoot.appendChild(preview);

      cakeRoot.appendChild(el('div', { class: 'subheading bmath-jm__tiershead', text: 'Tiers' }));
      var rows = el('div', { class: 'bmath-jm__rows' });

      tiers.forEach(function (t, i) {
        if (openIdx === i) {
          /* 7b — the open tier: the SAME controls, in place */
          var card = el('div', { class: 'bmath-jm__open' });
          card.appendChild(el('div', { class: 'bmath-jm__openhead' }, [
            el('span', { class: 'bmath-jm__idx bmath-jm__idx--serif', text: 'Tier ' + (i + 1) + (jmRole(i, tiers.length) ? ' · ' + jmRole(i, tiers.length) : '') }),
            el('button', { class: 'bmath-jm__done', type: 'button', text: 'Done', onclick: function () { openIdx = null; rebuildStrip(); } })
          ]));
          card.appendChild(tierRow(tiers, i, function (structural) {
            if (structural) openIdx = null;   /* the tier was removed */
            onEdit();
          }));
          rows.appendChild(card);
        } else {
          var est = ctCompute(jmEffFor([t]));
          var row = el('button', { class: 'bmath-jm__row', type: 'button',
            'aria-label': 'Edit tier ' + (i + 1),
            onclick: function () { openIdx = i; rebuildStrip(); } }, [
            el('span', { class: 'bmath-jm__idx', text: String(i + 1) }),
            el('span', { class: 'bmath-jm__rowbody' }, [
              el('span', { class: 'bmath-jm__rowname' }, [
                el('span', { text: jmTierLabel(t) }),
                jmRole(i, tiers.length) ? el('span', { class: 'bmath-jm__role', text: ' · ' + jmRole(i, tiers.length) }) : null
              ]),
              el('span', { class: 'bmath-jm__rowmeta', text: (t.h >= 6 ? 'Tall' : 'Standard') + ' · ' + sizeLabel(t.h) })
            ]),
            el('span', { class: 'bmath-jm__rowest', text: '≈ ' + jmBatchText(est) }),
            el('span', { class: 'bmath-jm__edit', text: 'Edit' })
          ]);
          rows.appendChild(row);
        }
      });

      if (tiers.length < 6) {
        rows.appendChild(el('button', { class: 'bmath-jm__add', type: 'button', text: '+ Add a tier',
          onclick: function () {
            var last = tiers[tiers.length - 1];
            tiers.push({ d: Math.min(last.d + 2, 16), h: last.h, shape: last.shape });
            openIdx = tiers.length - 1;
            onEdit();
          } }));
      }
      rows.appendChild(el('p', { class: 'bmath-formnote', text: 'Per-tier figures round up on their own, the cake total above is the real number to mix. ' + note }));
      cakeRoot.appendChild(rows);
    }

    cakeStripRebuild = rebuildStrip;
    /* the card's figures + eyebrow follow whichever calculator is on
       screen, so a tab tap refreshes it (r2f) */
    document.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('.bmath-jump a') : null;
      if (a) setTimeout(rebuildStrip, 0);
    });
    rebuildStrip();
    unitListeners.push(function () { rebuildStrip(); driveBatchChip(); });
    driveBatchChip();   /* seed the chip from the strip on first render */
  }

  /* ============================================================
     §3.2/§3.1 — BOOKING PICKER: scope the whole page to one Planner
     booking. Renders only when the Planner has bookings (visitors and
     one-offs never see it); "Just the math, no booking" stays the
     freemium entry. Selecting a booking pre-fills the cake once from the
     booking's tier spec, and every calculator reads it.
     ============================================================ */
  var BOOKINGS_KEY = 'layerd-academy-bookings';   /* the Planner's store */
  /* the filling flavours on a client file, in the Planner's own terms:
     everything that isn't the sponge and isn't the coat. Same test the
     Planner uses (isCoat), so the two pages can't disagree about what
     counts as a filling. */
  var BM_COAT_RE = /buttercream|fondant|smbc|ganache coat/i;
  function fillingComponentsOf(bid) {
    if (!bid) return [];
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || !v.bookings) return [];
      var bk = null, i;
      for (i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === bid) { bk = v.bookings[i]; break; }
      if (!bk || !bk.components) return [];
      var out = [], seen = {};
      bk.components.forEach(function (c) {
        var cat = c.category || '';
        var nm = ((c.name || '') + '').trim();
        if (!nm || cat === 'bases') return;
        /* r44: "other" (soaks, crunch, extras) is not a filling — it must
           not appear in the filling flavour list or it takes a share of the
           filling grams. Mirrors isFillingCat in the Planner. */
        if (cat === 'other') return;
        if (cat === 'finishes' && BM_COAT_RE.test(nm)) return;
        if (seen[nm.toLowerCase()]) return;
        seen[nm.toLowerCase()] = 1; out.push(nm);
      });
      return out;
    } catch (e) { return []; }
  }
  /* r223 (2026-09-16): a scoped cake picks its own filling density class from
     the recipe's category, so the dropdown lands on the right one without the
     baker touching it. montees are whipped, jellies/compotes/curds are dense,
     cremeux is the studio creamy default (a set ganache lives in cremeux too;
     the per-recipe densityClass override is the finer fix, later). A recipe's
     own `densityClass`, when present, wins over the category. */
  var CAT_TO_CLASS = { montees: 'whipped', cremeux: 'studio', jellies: 'dense' };
  function fillingClassOf(bid) {
    if (!bid) return null;
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || !v.bookings) return null;
      var bk = null, i;
      for (i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === bid) { bk = v.bookings[i]; break; }
      if (!bk || !bk.components) return null;
      var types = flTypes();
      var found = null;
      bk.components.forEach(function (c) {
        if (found) return;
        var cat = c.category || '';
        if (cat === 'bases' || cat === 'other') return;
        if (cat === 'finishes' && BM_COAT_RE.test(((c.name || '') + '').trim())) return;
        var cls = c.densityClass || CAT_TO_CLASS[cat];
        if (cls && types[cls]) found = cls;
      });
      return found;
    } catch (e) { return null; }
  }
  /* --layerd-purple is the BRAND ink now (2026-08-11), so pointing slot 0
     at it made this ramp disagree with every other copy and go near-black.
     Read the ramp's own tokens instead. */
  var CAKE_HEX = ['var(--cake-1)', 'var(--cake-2)', 'var(--cake-3)', 'var(--cake-4)'];
  function cakeColor(ci) { return CAKE_HEX[(ci == null ? 0 : ci) % 4]; }
  function bkCi(b) { return (b && b.colorIndex != null) ? b.colorIndex : 0; }
  function readBookings() {
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (v && (v.v === 1 || v.v === 2) && Object.prototype.toString.call(v.bookings) === '[object Array]') return v.bookings;
    } catch (e) { /* private mode / absent */ }
    return [];
  }
  /* booking tier spec -> the cake strip's {d,h,shape} + the batter tool's
     per-tier layers/flavours. Bookings are round-only and carry one global
     `tall` flag, so shape='round' and h=6 (tall) / 4 (standard) per tier. */
  var TIER_PRESETS = { 1: [8], 2: [8, 6], 3: [10, 8, 6], 4: [12, 10, 8, 6], 5: [12, 10, 8, 6, 4], 6: [14, 12, 10, 8, 6, 4] };
  function bookingTiers(b) {
    var n = Math.max(1, +b.tiers || 2);
    var spec = Array.isArray(b.tierSpec) ? b.tierSpec.slice(0, n) : [];
    var preset = TIER_PRESETS[n] || TIER_PRESETS[6];
    var h = b.tall ? 6 : 4;
    var rows = [];
    for (var i = 0; i < n; i++) {
      var s = spec[i] || {};
      var rh = +s.h || h;
      rows.push({ d: +s.d || preset[i] || 6, h: rh, shape: (s.shape === 'square' || s.shape === 'heart') ? s.shape : 'round', flavour: (s.flavour || ''), layers: (s.layersCustom && s.layers != null) ? Math.max(1, +s.layers) : stdLayers(rh), faux: !!s.faux });
    }
    return rows.sort(function (a, b) { return b.d - a.d; });
  }
  /* §2.1.4 (combo-aware): a Signature Combo carrying a compote / cremeux /
     montee / ganache FILLING means that tier is filled with something other
     than buttercream, so the buttercream calc should default to coats-only.
     Returns true (combos fill with non-buttercream) / false (combos are
     buttercream-filled) / null (no combos — fall back to the element flag). */
  function comboFillFlag(b) {
    if (!b.comboAssignments || !b.comboAssignments.some(Boolean)) return null;
    var fillCats = { jellies: 1, cremeux: 1, montees: 1 };
    return b.comboAssignments.some(function (a) {
      return a && (a.components || []).some(function (c) {
        return fillCats[c.category] || /ganache/i.test(c.label || '');
      });
    });
  }
  function scopeToBooking(b) {
    if (window.LdCakeFile) window.LdCakeFile.setActiveBooking(b.id, 'batch-math');
    var rows = bookingTiers(b);
    /* r42: `faux` rides the tier so the batter/filling maths can skip a
       dummy. It is NOT skipped for coverage — a faux tier still gets
       ganached and fondanted, so ganache and buttercream-coat still count
       it (Mariya's own flow: "prep and cover with fondant"). */
    state.cake.tiers = rows.map(function (t) { return { d: t.d, h: t.h, shape: t.shape, faux: !!t.faux }; });
    state.ct.cakeLayers = rows.map(function (t) { return t.layers; });
    state.ct.cakeFlavours = rows.map(function (t) { return t.flavour; });
    /* every calculator reads the one cake (drop any per-tool overrides) */
    ['bc', 'ga', 'ct', 'fl'].forEach(function (k) { state[k].custom = false; });
    /* covering pre-sets the finish/ganache logic */
    if (b.cover === 'fondant') { state.ga.app = 'coat'; }
    /* §2.1.4 default-with-intent: the assigned Signature Combos decide the
       filling — a combo with a compote/cremeux/montee/ganache filling means
       buttercream defaults to coats-only. No combos yet → fall back to the
       booking's compote element flag. The baker can still toggle it. */
    var cf = comboFillFlag(b);
    state.bc.fillOn = (cf === null) ? !b.compote : !cf;
    state.bookingId = b.id;
    state.bookingName = b.name || 'Cake order';
    ycExpanded = false;
    persistCake(true);             /* re-seed FROM the file — never writes back; chip + event only */
    if (cakeStripRebuild) cakeStripRebuild();
    updaters.forEach(function (fn) { fn(); });
  }
  function clearBookingScope() {
    if (window.LdCakeFile) window.LdCakeFile.setActiveBooking(null, 'batch-math');
    ycExpanded = false;
    state.bookingId = null;
    state.bookingName = null;
    persist();
    /* the strip flips back to the "Just the math" view (7a) */
    if (cakeStripRebuild) cakeStripRebuild();
    /* re-render every calculator so the save slots drop the old cake's
       name — a stale "Save to [couple]" after unscoping would fail */
    updaters.forEach(function (fn) { fn(); });
  }

  /* redesign r2b (Mariya 2026-07-30): STUDIO DAY / bake-day mode is
     retired from Batch Math. Multi-cake batching belongs to the Planner -
     this page answers ONE question: the cake I am working on. The picker
     collapses behind the chip's Change; the tier rows do the editing. */
  function bookingInit() {
    var mount = document.getElementById('bmath-booking');
    if (!mount) return;
    var bookings = readBookings();
    if (!bookings.length) return;   /* no bookings → no picker (freemium path) */
    /* §3.4/§3.6 — a Planner "adjust → Batch Math" link arrives as
       ?booking=<id>#<calculator>: scope to that booking before first render
       (the #hash scroll is the browser's own). Only re-scope when the link
       names a DIFFERENT booking than the remembered one, so a plain reload
       never clobbers in-progress edits. */
    try {
      if (window.LdCakeFile) {
        /* Toolkit Fix 01: the global pointer decides (?booking= wins and
           sets it). Re-seed from the FILE when the client changed or the
           file's cake is newer than what this page is holding — the booking
           record is the source of truth; local unsaved edits survive a
           plain reload only until the file moves on. */
        var eff = window.LdCakeFile.resolveScope();
        if (eff) {
          if (state.bookingId !== eff.id) scopeToBooking(eff);
          else if (eff.cake && eff.cake.updatedAt > (state.cake.at || 0)) scopeToBooking(eff);
        } else if (state.bookingId) {
          clearBookingScope();
        }
      } else {
        /* no-helper fallback: the pre-fix behaviour */
        var bid = null;
        var m = location.search.match(/[?&]booking=([^&]+)/);
        if (m) bid = decodeURIComponent(m[1]);
        if (!bid) bid = state.bookingId || null;
        if (bid) {
          var bk = null;
          for (var bi = 0; bi < bookings.length; bi++) { if (bookings[bi].id === bid) { bk = bookings[bi]; break; } }
          if (bk) {
            var sc = readSharedCake();
            var scBid = (sc && sc.bookingId !== undefined) ? (sc.bookingId || null) : null;
            if (scBid !== bid) scopeToBooking(bk);
            else if (state.bookingId !== bid) { state.bookingId = bid; state.bookingName = bk.name || 'Cake order'; persist(); }
          } else if (state.bookingId === bid) {
            clearBookingScope();   /* the remembered client is gone — unscope */
          }
        }
      }
    } catch (e) { /* malformed URL — the picker still renders */ }
    /* the picker is the client picker now (§4.5): show status, hide archived */
    var STATUS_LBL = { inquiry: 'Inquiry', quoted: 'Quoted', booked: 'Booked' };
    function stLbl(b) { return STATUS_LBL[(b.status || 'booked')] || ''; }
    /* most-imminent delivery first; undated bookings sink to the end.
       Round five (2026-07-21, Mariya): files whose delivery date has
       already passed drop out of the picker — there's nothing left to
       bake for them. Undated files stay (still planning), and the
       currently-scoped file stays visible even when past, so the page
       never claims a client the picker won't show. */
    var todayLocal = (function () {
      var d = new Date();
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    })();
    var sorted = bookings.filter(function (b) {
      if ((b.status || 'booked') === 'archived') return false;
      if (b.date && b.date < todayLocal && b.id !== state.bookingId) return false;
      return true;
    }).sort(function (a, b) {
      if (!a.date) return 1; if (!b.date) return -1;
      return a.date < b.date ? -1 : (a.date > b.date ? 1 : 0);
    });
    if (!sorted.length) return;   /* everything past-dated → no picker */
    /* Studio day is the premium surface; the server-rendered #lbm-premium
       marker island is the synchronous gate (presence only — the old day-plan
       payload it carried was retired 2026-07-15, plans live on client files) */
    var isPremium = !!document.getElementById('lbm-premium');
    var lockedPanel = document.querySelector('.lh-locked[data-tool="batch-math"]');
    function render() {
      clearNode(mount);
      /* r5 (2026-07-30): Batch Math's bespoke radio list is RETIRED. It was
         the only tool not using the shared control, which is half of why the
         suite felt inconsistent ("some have the bar, some have the drop
         down"). The shared bar's "change" opens the same file popover here
         as everywhere else; picking navigates to ?booking=<id>, which is
         what scopeToBooking below already responds to. The mount and this
         renderer stay so every existing caller keeps working. */
      mount.hidden = true;
      return;
      /* eslint-disable no-unreachable */
      /* round 25 (handoff 18a fix 3): with a single cake there is nothing
         to pick — the chip already names it. The picker still renders (so
         the chip's "change" has somewhere to go) but stays hidden until
         that link asks for it. */
      /* redesign r2b: whenever a cake IS scoped the list stays folded -
         the chip names it and "Change" is the one way back in. With
         nothing scoped the list shows, so there is always a way in. */
      mount.classList.add('bmath-booking--solo');   /* always folded; Change opens it */

      /* Toolkit Fix 02 P0-3: scoping is SINGLE-choice, so the rows carry
         radio semantics; the Pro bake-day multi-select is its own explicit
         mode behind a toggle (the old overloaded tick-squares implied
         multi-select everywhere). The Pro gate moves onto the toggle —
         same locked-panel nudge, same #lbm-premium island. */
      function selIds() { return state.bookingId ? [state.bookingId] : []; }
      function setSelection(ids) {
        mount.classList.remove('is-open');   /* r2e: picking puts the list away */
        if (ids.length) {
          var one = null;
          sorted.forEach(function (b) { if (b.id === ids[0]) one = b; });
          if (one) scopeToBooking(one);
          render();
        } else {
          clearBookingScope(); render();
        }
      }
      function fmtRowDate(iso) {
        if (!iso) return '';
        var p = String(iso).split('-');
        if (p.length !== 3) return '';
        var d = new Date(+p[0], +p[1] - 1, +p[2]);
        if (isNaN(d.getTime())) return '';
        var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return DOW[d.getDay()] + ' ' + MON[d.getMonth()] + ' ' + d.getDate();
      }

      var sel = selIds();
      function nudgeLocked() {
        if (!lockedPanel) return;
        ldNav(lockedPanel, { block: 'center' });
        lockedPanel.classList.add('is-nudged');
        setTimeout(function () { lockedPanel.classList.remove('is-nudged'); }, 1600);
      }

      /* redesign r2e (Mariya 2026-07-30): no heading - the bar above IS the
         question ("which cake"), and this list only exists once you tap
         Change on it. Two identity elements, never three (the r34 rule). */
      var rows = el('div', {
        class: 'bmath-bookrows is-radio',
        role: 'radiogroup',
        'aria-label': 'Which client file to work on'
      });
      sorted.forEach(function (b) {
        var on = sel.indexOf(b.id) > -1;
        var tiers = bookingTiers(b);
        var sizes = tiers.map(function (t) { return t.d + '″'; }).join(' + ');
        var meta = sizes + (b.date ? ' · ' + fmtRowDate(b.date) : '') + (stLbl(b) && stLbl(b) !== 'Booked' ? ' · ' + stLbl(b) : '');
        var aria = { role: 'radio', 'aria-checked': on ? 'true' : 'false' };
        var attrs = {
          class: 'bmath-bookrow' + (on ? ' is-on' : ''), type: 'button',
          style: '--c:' + cakeColor(bkCi(b)),
          onclick: function () {
            /* radio: picking a row scopes to it, nothing to un-tick */
            if (!on) setSelection([b.id]);
          }
        };
        for (var k in aria) attrs[k] = aria[k];
        var row = el('button', attrs, [
          el('span', { class: 'bmath-bookrow__tick', 'aria-hidden': 'true' }),
          el('span', {}, [
            el('span', { class: 'bmath-bookrow__name', text: b.name || 'Cake order' }),
            el('span', { class: 'bmath-bookrow__meta', style: 'display:block', text: meta })
          ]),
          el('span', { class: 'bmath-bookrow__right', text: tiers.length + (tiers.length === 1 ? ' tier' : ' tiers') })
        ]);
        rows.appendChild(row);
      });
      var noneAttrs = {
        class: 'bmath-bookrow bmath-bookrow--none' + (sel.length ? '' : ' is-on'), type: 'button',
        onclick: function () { setSelection([]); }
      };
      noneAttrs.role = 'radio';
      noneAttrs['aria-checked'] = sel.length ? 'false' : 'true';
      rows.appendChild(el('button', noneAttrs, [
        el('span', { class: 'bmath-bookrow__tick', 'aria-hidden': 'true' }),
        el('span', { class: 'bmath-bookrow__meta', text: 'Just the math, no client' })
      ]));
      mount.appendChild(rows);

      /* round 25 (handoff 18a fix 2): the "Working on X — tiers, covering
         and flavours come from the client file" paragraph is retired — the
         chip names the cake and the panel's one provenance line says the
         rest, without repeating it in centered prose. */
    }
    /* r5 (2026-07-30): the bespoke radio list is retired. "change" now opens
       the SHARED file popover inside the bar, identical to every other tool —
       so this page no longer hijacks the shared button. */
    var _r0 = render;
    render = function () { _r0(); syncYourCake(); };
    render();
    bakeDayRender = render;   /* the batter tool re-draws the picker after a save */
  }

  /* Copy-results button (label overridable — the make list says "Copy today's make list") */
  function copyBtn(getText, label) {
    label = label || 'Copy results';
    var b = el('button', {
      class: 'ld-btn ld-btn--secondary bmath-copy', type: 'button', text: label
    });
    b.addEventListener('click', function () {
      var text = getText();
      function done() {
        b.textContent = 'Copied ✓';
        setTimeout(function () { b.textContent = label; }, 1600);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { legacyCopy(text); done(); });
      } else { legacyCopy(text); done(); }
    });
    return b;
  }
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', '');
    ta.style.position = 'absolute'; ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) { /* nothing more we can do */ }
    document.body.removeChild(ta);
  }

  /* The "save" slot on every result panel. Plans live in ONE place — the
     client file (the in-page "Today's make list" day plan was RETIRED
     2026-07-15, Mariya: redundant with the Planner). Scoped to a cake, the
     save writes to ITS file; unscoped with files available, a quiet nudge
     points at the picker; no files at all → no button (the anonymous
     quick-math path stays clean). getState hands over a detached copy of
     the tool's INPUT state — saved figures recompute from inputs, so
     config edits update saved plans too. */
  /* Toolkit Fix 02 P1-7: every results card's actions sit in ONE shared
     row — equal widths, centred, stacked on phones (.ld-btnrow). */
  function actionRow(panel, copyEl, saveEl) {
    var row = el('div', { class: 'ld-btnrow' }, [copyEl]);
    if (saveEl) row.appendChild(saveEl);
    panel.appendChild(row);
  }

  /* ============================================================
     r95 (Mariya's design call, 2026-08-24): TUNE TO YOUR RECIPE.
     The weigh-out at the top carries the answers now; each
     calculator below doubles as the place to make the model
     match YOUR results. The studio rates are Mariya's bench
     data — another baker's recipes run heavier or lighter, and
     rather than argue, the tool learns: a per-product multiplier
     (engine-level, Q.calibration) that every figure follows —
     this page, the band, the bake sheet, the Planner's task
     quantities and its shopping lists. Saved on this device;
     0.5×–2× clamp; one tap back to the studio model.
     Two ways in: ±5% nudges, or "tune from a real bake" — enter
     what you actually used and the factor is computed for you.
     ============================================================ */
  function tuneBlock(product, opts) {
    var Qc = Q && Q.calibration;
    /* older engine asset — no tuning surface, and never a crash */
    if (!Qc) { var none = el('span'); none.hidden = true; return none; }
    /* r223 (Phase 3): when a single saved recipe is in scope, the tune targets
       THAT recipe (its own factor), not the whole product. opts.recipeId is a
       function so the target stays live; absent or null = per-product, exactly
       as before. Older engine without setRecipe falls back to per-product. */
    function curId() {
      if (!opts.recipeId || !Qc.setRecipe) return null;
      try { return opts.recipeId() || null; } catch (e) { return null; }
    }
    function curName() { try { return (opts.recipeName && opts.recipeName()) || null; } catch (e) { return null; } }
    function getF() { var id = curId(); var rf = id ? Qc.recipeFactor(id) : null; return (rf != null) ? rf : Qc.factor(product); }
    function setF(f) { var id = curId(); if (id) Qc.setRecipe(id, f); else Qc.set(product, f); }
    function resetF() { var id = curId(); if (id) Qc.resetRecipe(id); else Qc.reset(product); }
    /* UX 2026-09-11 (Mariya): the fine-tune block folds away - closed by
       default, its summary carries the live factor so you see at a glance
       whether it's on the studio model or nudged. */
    var wrap = el('details', { class: 'bmath-tune' });
    var sumVal = el('span', { class: 'bmath-tune__sumval' });
    wrap.appendChild(el('summary', { class: 'bmath-build__head bmath-tune__head' }, [
      el('span', { class: 'bmath-build__eyebrow', text: 'Tune to your recipe' }),
      el('span', { class: 'bmath-build__rule', 'aria-hidden': 'true' }),
      sumVal,
      el('span', { class: 'bmath-tune__chev', 'aria-hidden': 'true', text: '⌄' })
    ]));

    var valEl = el('span', { class: 'bmath-tune__val' });
    var status = el('p', { class: 'bmath-tune__status' });
    var resetB = el('button', { class: 'bmath-tune__reset', type: 'button', text: 'back to the studio model' });
    function fmtPct(f) {
      var p = Math.round((f - 1) * 100);
      return (p > 0 ? '+' : '') + p + '%';
    }
    function paint() {
      var f = getF();
      var tuned = Math.abs(f - 1) > 0.001;
      var nm = curName();
      valEl.textContent = tuned ? fmtPct(f) : 'studio model';
      sumVal.textContent = tuned ? fmtPct(f) : 'studio model';
      if (curId()) {
        /* recipe-scoped: only this recipe moves (the Planner pass-through is a
           follow-up, so this copy does not promise it yet). */
        status.textContent = tuned
          ? 'Every batch of ' + (nm || 'this filling') + ' here now runs ' + fmtPct(f) + ' vs the studio model.'
          : 'Ran over or short on ' + (nm || 'this filling') + '? Tune it from a real bake and only this recipe moves.';
      } else {
        status.textContent = tuned
          ? 'Every ' + opts.noun + ' figure, here, the summary above and your Planner, now runs ' + fmtPct(f) + ' vs the studio model.'
          : 'Running over or short with your own recipe? Nudge the model and the whole Toolkit follows, this page, the summary above and your Planner’s shopping lists.';
      }
      resetB.hidden = !tuned;
      wrap.classList.toggle('is-tuned', tuned);
    }
    function stepBtn(sym, d) {
      var b = el('button', { class: 'bmath-tune__step', type: 'button', text: sym,
        'aria-label': (d > 0 ? '5% more ' : '5% less ') + opts.noun });
      b.addEventListener('click', function () {
        setF(Math.round((getF() + d) * 100) / 100);
        paint();
      });
      return b;
    }
    resetB.addEventListener('click', function () { resetF(); paint(); });
    wrap.appendChild(el('div', { class: 'bmath-tune__row' }, [
      stepBtn('−', -0.05), valEl, stepBtn('+', 0.05), resetB
    ]));
    wrap.appendChild(status);

    /* "tune from a real bake" — the intelligent path: the baker enters
       what they actually used and the factor is computed, never guessed */
    if (opts.getModel) {
      var lede = el('p', { class: 'bmath-tune__lede' });
      var inp = el('input', { class: 'learn-input bmath-tune__input', type: 'number',
        min: '1', step: '10', inputmode: 'numeric', 'aria-label': 'What you actually used, in grams' });
      var apply = el('button', { class: 'ld-btn ld-btn--secondary bmath-tune__apply', type: 'button', text: 'Tune it' });
      var note = el('span', { class: 'bmath-tune__note', role: 'status' });
      var fold = el('details', { class: 'ld-collapse bmath-tune__fold' }, [
        el('summary', { class: 'ld-collapse__sum bmath-tune__sum', text: 'Tune from a real bake' }),
        el('div', { class: 'ld-collapse__body' }, [
          lede,
          el('div', { class: 'bmath-tune__bakerow' }, [inp, el('span', { class: 'bmath-tune__unit', text: 'g' }), apply]),
          note
        ])
      ]);
      fold.addEventListener('toggle', function () {
        if (!fold.open) return;
        var m = opts.getModel();
        lede.textContent = m
          ? 'For this cake the model says ' + m.display + '. What did you actually use?'
          : 'Set the cake up above first, then tell me what you actually used.';
      });
      apply.addEventListener('click', function () {
        var m = opts.getModel();
        var used = parseFloat(inp.value);
        if (!m || !isFinite(used) || used <= 0 || !(m.raw > 0)) {
          note.textContent = 'Enter what you used in grams and I’ll work out the rest.';
          return;
        }
        var f = Math.min(2, Math.max(0.5, used / m.raw));
        setF(f);
        paint();
        note.textContent = 'Tuned to ' + fmtPct(getF()) + ' from your bake ✓';
        inp.value = '';
      });
      wrap.appendChild(fold);
    }

    /* another tab / the settings popup can change the store too */
    window.addEventListener('storage', function (e) {
      if (e && e.key && e.key !== Qc.key) return;
      if (wrap.isConnected) paint();
    });
    paint();
    return wrap;
  }

  function saveSlot(tool, getState) {
    if (state.bookingId) return bookingSaveBtn(tool, getState);
    if (!readBookings().length) return null;
    var b = el('button', { class: 'ld-btn ld-btn--secondary bmath-savebooking bmath-savebooking--pick',
      type: 'button', text: 'Save to a cake, pick one first ↑' });
    b.addEventListener('click', function () {
      var picker = document.getElementById('bmath-booking');
      if (picker) {
        ldNav(picker, { block: 'center' });
        picker.classList.add('is-nudged');
        setTimeout(function () { picker.classList.remove('is-nudged'); }, 1600);
      }
    });
    return b;
  }

  /* ---- §3.3/§4.5: the booking's batch sheet ----
     booking.batchSheet[tool] = { v, inputs, outputs, engineVersion, savedAt }.
     Inputs = the calculator's eff state (recomputable through the engine);
     outputs = a small display snapshot so the Planner shows the SAME figures
     verbatim (§4.2). Lives inside the existing booking record, so the
     Planner's one backup file carries it automatically. */
  function batchOutputsOf(tool, inputs) {
    /* r127: the four cake tools live in the engine now, so the Planner can
       re-derive a resized sheet with the same code. `sc` is a pan
       conversion, not a cake, and stays here. */
    if (tool !== 'sc' && Q.sheetOutputs) return Q.sheetOutputs(tool, cfg, inputs, { bowl: bowlPref() });
    if (tool === 'bc') {
      var r = bcCompute(inputs);
      return { total: Math.round(r.total), coats: Math.round(r.coatsSubtotal),
        fill: Math.round(r.fillingSubtotal), fillOn: !!inputs.fillOn,
        makeBatches: r.makeBatches, eggWhites: r.eggWhites, mixerRuns: r.mixerRuns };
    }
    if (tool === 'ga') {
      var g = gaCompute(inputs);
      return { total: Math.round(g.total), choc: Math.round(g.choc),
        cream: Math.round(g.cream), ratio: g.ratio, app: inputs.app, chocType: inputs.choc };
    }
    if (tool === 'ct') {
      var c = ctCompute(inputs);
      return c.vessel === 'round'
        ? { vessel: 'round', batches: c.batches }
        : { vessel: 'sheet', batchesQ: c.batchesQ, qSheets: c.qSheets, hSheets: c.hSheets };
    }
    if (tool === 'fl') {
      var f = flCompute(inputs);
      return { total: flRound(f.total), type: inputs.type, label: f.label, estimate: f.estimate };
    }
    if (tool === 'sc') {
      return { factor: Math.round(scFactor(inputs) * 100) / 100 };
    }
    return {};
  }
  function writeBatchSheet(tool, inputs, forId) {
    var wantId = forId || state.bookingId;
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || (v.v !== 1 && v.v !== 2) || !v.bookings) return null;
      var bk = null;
      for (var i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === wantId) { bk = v.bookings[i]; break; }
      if (!bk) return null;
      bk.batchSheet = bk.batchSheet || {};
      var updated = !!bk.batchSheet[tool];
      bk.batchSheet[tool] = {
        v: 1, inputs: inputs, outputs: batchOutputsOf(tool, inputs),
        engineVersion: Q.version, savedAt: Date.now()
      };
      delete bk.batchSheet._stale;   /* re-run after a size change → fresh again */
      localStorage.setItem(BOOKINGS_KEY, JSON.stringify(v));
      try { window.dispatchEvent(new CustomEvent('layerd:cakefile', { detail: { type: 'file', source: 'batch-math' } })); } catch (e) { }
      return { updated: updated };
    } catch (e) { return null; }
  }
  /* ---- batter → the file's COMPONENTS (Mariya, 2026-07-15) ----
     Saving the batter writes each flavour onto the client file as a
     component row — the same rows the Planner's Components section edits,
     the day cards name ("— 2× Vanilla sponge") and the shopping list rolls
     up. Batches land pre-filled from the math here and stay EDITABLE on the
     file. A flavour whose name matches one of the baker's saved recipes
     links to it (shopping gets its ingredients); otherwise it lands as the
     free-typed kind the Planner already supports. Re-saving replaces only
     the rows this tool wrote (flagged fromBatter) — hand-added components
     are never touched. */
  var MY_RECIPES_KEY = 'layerd-academy-my-recipes';
  function myRecipeByTitle(title) {
    if (!title) return null;
    try {
      var v = JSON.parse(localStorage.getItem(MY_RECIPES_KEY));
      if (!v || v.v !== 1 || !Array.isArray(v.items)) return null;
      var want = String(title).trim().toLowerCase();
      for (var i = 0; i < v.items.length; i++) {
        if (((v.items[i].title || '') + '').trim().toLowerCase() === want) return v.items[i];
      }
    } catch (e) { /* private mode / corrupt */ }
    return null;
  }
  /* the base recipe the tiers in this flavour group are actually built
     from. The tier's assigned signature combo already NAMES it — read
     that first, because it's an id, not a guess. Title-matching the
     baker's own recipes stays as the fallback for hand-typed flavours.

     2026-08-02: matching by title alone was the whole bug. A tier
     flavoured "London Fog" matched no recipe called exactly "London
     Fog", so the sponge landed with recipeId null — and the Planner's
     shopping roll-up skips an unlinked component in silence. Eleven
     batches of quarter-sheet sponge contributed nothing at all. */
  function baseRecipeIdFor(bk, r, g, prevById) {
    var i, idx, j, k, baseLabels = [];
    if (bk && bk.comboAssignments && r && r.per) {
      for (i = 0; i < (g.per || []).length; i++) {
        idx = r.per.indexOf(g.per[i]);
        if (idx < 0) continue;
        var a = bk.comboAssignments[idx];
        if (!a || !a.components) continue;
        for (j = 0; j < a.components.length; j++) {
          k = a.components[j];
          if ((k.category || 'bases') !== 'bases') continue;
          if (k.recipeId) return k.recipeId;        /* the combo names it */
          if (k.label) baseLabels.push(k.label);    /* "Earl Grey cake" */
        }
      }
    }
    /* the Planner indexes the baker's own recipes as "mine:<id>" —
       write the key IT reads, or the link silently misses */
    var label = ((g.label || '') + '').trim();
    var tries = baseLabels.concat([label]);
    for (i = 0; i < tries.length; i++) {
      var match = myRecipeByTitle(tries[i]);
      if (match) return 'mine:' + match.id;
    }
    /* nothing resolved it — but if the baker linked this sponge by hand
       on the client file, that pick is the best answer there is, and
       re-running the batter must NOT wipe it (2026-08-02) */
    var keep = prevById[(label || 'Sponge').toLowerCase()];
    return keep || null;
  }
  function writeBatterComponents(inputs, forId) {
    var wantId = forId || state.bookingId;
    try {
      var r = ctCompute(inputs);
      if (!r.groups || !r.groups.length) return null;
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || (v.v !== 1 && v.v !== 2) || !v.bookings) return null;
      var bk = null;
      for (var i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === wantId) { bk = v.bookings[i]; break; }
      if (!bk) return null;
      /* recipes the baker linked to a previous batter row, by row name —
         re-running the math replaces the NUMBERS, never her links */
      var prevById = {};
      (bk.components || []).forEach(function (c) {
        if (c.fromBatter && c.recipeId) prevById[((c.name || '') + '').toLowerCase()] = c.recipeId;
      });
      var linked = 0;
      var rows = r.groups.map(function (g) {
        var n = inputs.vessel === 'round' ? g.batches : g.batchesQ;
        var label = ((g.label || '') + '').trim();
        var rid = baseRecipeIdFor(bk, r, g, prevById);
        if (rid) linked++;
        return {
          recipeId: rid,
          name: label || 'Sponge',
          category: 'bases',
          batches: (n != null && n > 0) ? n : 1,
          /* the batter tool owns this number — it re-derives on every
             save, so it must not be mistaken for a hand-typed one */
          batchesSet: false,
          batchesAuto: true,
          fromBatter: true
        };
      });
      var kept = (bk.components || []).filter(function (c) { return !c.fromBatter; });
      bk.components = kept.concat(rows);
      localStorage.setItem(BOOKINGS_KEY, JSON.stringify(v));
      return { rows: rows.length, linked: linked };
    } catch (e) { return null; }
  }

  function bookingSaveBtn(tool, getState) {
    var label = 'Save to ' + (state.bookingName || 'this client file');
    var b = el('button', { class: 'ld-btn ld-btn--secondary bmath-savebooking', type: 'button', text: label });
    b.addEventListener('click', function () {
      var inputs = getState();
      var res = writeBatchSheet(tool, inputs);
      /* the batter save also fills the file's Components — the batches
         land where the Planner (and the baker) can edit them */
      var comp = (tool === 'ct' && res) ? writeBatterComponents(inputs) : null;
      /* an unlinked base row still can't be shopped — say it here, on the
         save, instead of letting the shopping list come up short later */
      b.textContent = res
        ? (comp ? (comp.linked < comp.rows
                    ? 'Saved ✓, link the sponge to a recipe to shop it'
                    : 'Saved ✓, components on file')
                : (res.updated ? 'Updated ✓' : 'Saved to ' + (state.bookingName || 'the client file') + ' ✓'))
        : 'Couldn’t save, try again';
      /* round nineteen (Mariya): the per-tool Next link is retired — the
         STICKY pipeline bar's Next pill is the one next-step control */
      setTimeout(function () { b.textContent = label; }, 2200);
      /* 2026-08-12: a save is a step completed, so hand her the next one */
      if (res) flowAdvanceFrom(tool);
    });
    return b;
  }

  /* ============================================================
     THE ASSIGNMENT FLOW (2026-08-12, her brief)
     "the tool should automatically go through each tab for assignment
      (e.g. batter once saved, jumps to ganache, and so on). It should
      also allow you to skip a section ... It should just be very clear
      that you're going through specific steps and assigning things to
      a file and I think the tool overall is still missing that flow."

     FOUR steps, in bench order: Batter → Fillings → Ganache → Buttercream.
     PAN-SCALING IS DELIBERATELY NOT ONE (her call, same message): it is a
     standalone converter, not something assigned to a file — nothing it
     produces is recorded on the batch sheet for the Planner.

     "Done" is the STRICT reading she chose: a step counts when it is SAVED
     TO THE FILE, or explicitly SKIPPED. A skip is recorded, not merely
     absent — so "no ganache on this cake" becomes a fact the shopping list
     and the Planner can rely on, and it is remembered per file instead of
     being re-skipped on every visit.

     The flow only exists when a client file is scoped. Unscoped ("just the
     math") the five calculators stay exactly as they were — there is
     nothing to assign to.
     ============================================================ */
  var FLOW = [
    { key: 'ct', tab: 'batter', label: 'Batter' },
    { key: 'fl', tab: 'fillings', label: 'Fillings' },
    { key: 'ga', tab: 'ganache', label: 'Ganache' },
    { key: 'bc', tab: 'buttercream', label: 'Buttercream' }
  ];
  function flowActiveSheet() {
    if (!state.bookingId) return null;
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || !v.bookings) return null;
      for (var i = 0; i < v.bookings.length; i++) {
        if (v.bookings[i].id === state.bookingId) return v.bookings[i].batchSheet || {};
      }
    } catch (e) { }
    return null;
  }
  /* 'saved' | 'skipped' | 'todo' — the one place a step's state is decided */
  function flowStateOf(key, sheet) {
    sheet = sheet || flowActiveSheet();
    if (!sheet) return 'todo';
    var rec = sheet[key];
    if (!rec) return 'todo';
    if (rec.skipped) return 'skipped';
    /* a sheet gone stale (size or flavours changed) reopens the step —
       the saved figures are for a cake that no longer exists */
    if (sheet._stale) return 'todo';
    return 'saved';
  }
  function flowWriteSkip(key, on) {
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || !v.bookings) return false;
      for (var i = 0; i < v.bookings.length; i++) {
        var bk = v.bookings[i];
        if (bk.id !== state.bookingId) continue;
        bk.batchSheet = bk.batchSheet || {};
        if (on) bk.batchSheet[key] = { v: 1, skipped: true, savedAt: Date.now() };
        else delete bk.batchSheet[key];
        localStorage.setItem(BOOKINGS_KEY, JSON.stringify(v));
        try {
          window.dispatchEvent(new CustomEvent('layerd:cakefile',
            { detail: { type: 'file', source: 'batch-math' } }));
        } catch (e2) { }
        return true;
      }
    } catch (e) { }
    return false;
  }
  /* ---- r129: what belongs on THIS cake ----
     Her ask: "It should be smart enough to know what categories to save
     based on what recipes I chose ... and if I had selected in earlier
     steps if it's buttercream only or ganache."

     Reads the booking record only - nothing is invented. Returns
     'save' | 'skip' | 'ask' per step, where 'ask' means the file does not
     say, so neither saving nor claiming "none on this cake" is honest.

       ct  batter       ALWAYS - every cake has sponge
       bc  buttercream  ALWAYS - it coats, fills, or both
       ga  ganache      the cover she picked, or a linked ganache component.
                        A drip on a buttercream cake is the "extra" she
                        said she would go in and save herself.
       fl  fillings     a component in a filling category, a finishes
                        component that is not a coat (the same split the
                        Planner's detailOf makes), or buttercream set to fill
  */
  var FILL_CATS = { jellies: 1, cremeux: 1, montees: 1 };
  function flowRelevance() {
    var out = { ct: 'save', bc: 'save', ga: 'ask', fl: 'ask' };
    var bk = null;
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (v && v.bookings) {
        for (var i = 0; i < v.bookings.length; i++) {
          if (v.bookings[i].id === state.bookingId) { bk = v.bookings[i]; break; }
        }
      }
    } catch (e) { }
    if (!bk) return out;

    var comps = bk.components || [];
    var named = comps.length > 0;

    var coverGanache = /ganache|fondant/i.test(bk.cover || '');
    /* the component carries its own name and category (syncComboComponents
       writes both), so no recipe index is needed here */
    var ganacheComp = comps.some(function (c) { return /ganache/i.test(c.name || ''); });
    if (coverGanache || ganacheComp) out.ga = 'save';
    else if (named) out.ga = 'skip';

    var fillComp = comps.some(function (c) {
      if (FILL_CATS[c.category]) return true;
      if (c.category === 'finishes') {
        return !/buttercream|fondant|smbc|ganache coat/i.test(c.name || '');
      }
      return false;
    });
    /* NOT `|| state.bc.fillOn` - that reads backwards. fillOn TRUE means
       the BUTTERCREAM fills the layers (scopeToBooking: a combo with a
       compote/cremeux/montee filling sets buttercream to coats-only), so
       a separate fillings batch is exactly what is NOT needed. The
       components decide it, which is what she asked for. */
    if (fillComp) out.fl = 'save';
    else if (named) out.fl = 'skip';

    return out;
  }

  /* one button, the whole cake. Saves what belongs, records the rest as
     explicit skips (a skip is a fact the Planner and shopping list rely
     on - this flow's own doctrine - not an absence), and says what it did
     rather than claiming everything is done. */
  function flowSaveAll() {
    if (!state.bookingId) return null;
    var rel = flowRelevance();
    var getters = { ct: ctEffState, fl: flEffState, ga: gaEffState, bc: bcEffState };
    var saved = [], skipped = [], left = [];
    FLOW.forEach(function (step) {
      var how = rel[step.key];
      if (how === 'save') {
        var inputs = getters[step.key]();
        if (writeBatchSheet(step.key, inputs)) {
          saved.push(step.label);
          /* the batter save also fills the file's Components, exactly as
             its own button does - one path, not two */
          if (step.key === 'ct') { try { writeBatterComponents(inputs); } catch (eC) { } }
        }
      } else if (how === 'skip') {
        if (flowWriteSkip(step.key, true)) skipped.push(step.label);
      } else {
        left.push(step.label);
      }
    });
    return { saved: saved, skipped: skipped, left: left };
  }

  function flowGoTo(tabId) {
    var a = document.querySelector('.bmath-jump a[href="#' + tabId + '"]');
    if (a) a.click();
  }
  /* the next step still outstanding — not simply the next in the list, or
     saving a step she came back to edit would bounce her forward past work
     she has already done. Wraps, so an earlier skipped-then-unskipped step
     is still found. Returns null when all four are settled. */
  function flowNextTodo(afterKey) {
    var sheet = flowActiveSheet();
    var start = 0;
    FLOW.forEach(function (s, i) { if (s.key === afterKey) start = i + 1; });
    for (var n = 0; n < FLOW.length; n++) {
      var s2 = FLOW[(start + n) % FLOW.length];
      if (s2.key === afterKey) continue;
      if (flowStateOf(s2.key, sheet) === 'todo') return s2;
    }
    return null;
  }
  function flowAdvanceFrom(key) {
    if (!state.bookingId) return;          /* no file → no flow */
    var next = flowNextTodo(key);
    flowRender();
    if (next) setTimeout(function () { flowGoTo(next.tab); }, 420);
  }

  /* ---- what she sees ----
     (a) a bar under the tabs naming the file and the progress through it,
     (b) a state mark on each of the four tabs (Pan-scaling never gets one),
     (c) a foot in each step with the skip / un-skip control.
     Everything reads flowStateOf, so the three can never disagree. */
  function flowRender() {
    var scoped = !!state.bookingId;
    /* r129 FIX: the jump nav was retired in r79 (the page runs the classic
       STACKED layout now), and this function used to bail on its absence -
       which quietly took the WHOLE assignment flow with it: no progress
       bar, no tab marks, no per-step skip controls. Everything below works
       without the nav; only the tab marks need it, and they are simply
       skipped when it is gone. */
    var nav = document.querySelector('.bmath-jump');
    var sheet = flowActiveSheet();

    /* (b) tab state marks - only when the nav exists */
    if (nav) FLOW.forEach(function (s) {
      var a = nav.querySelector('a[href="#' + s.tab + '"]');
      if (!a) return;
      a.classList.remove('is-saved', 'is-skipped', 'is-todo');
      if (scoped) a.classList.add('is-' + flowStateOf(s.key, sheet));
    });

    /* (a) the flow bar */
    var bar = document.querySelector('.bmath-flowbar');
    if (!scoped) { if (bar) bar.parentNode.removeChild(bar); }
    else {
      if (!bar) {
        bar = el('div', { class: 'bmath-flowbar' });
        /* after the nav when there is one; otherwise above the first
           calculator, which is where the stacked layout starts */
        var host = nav || document.getElementById('batter');
        if (nav) nav.parentNode.insertBefore(bar, nav.nextSibling);
        else if (host && host.parentNode) host.parentNode.insertBefore(bar, host);
        else return;
      }
      while (bar.firstChild) bar.removeChild(bar.firstChild);
      var settled = FLOW.filter(function (s) { return flowStateOf(s.key, sheet) !== 'todo'; }).length;
      /* "Next" is measured from where she IS, using the same rule that
         advancing uses — otherwise the bar can read "Next: Fillings" while
         a save has just moved her on to Buttercream, and the two disagree
         on screen at the same time. */
      var hereA = nav ? nav.querySelector('a.is-here') : null;
      var hereTab = hereA ? (hereA.getAttribute('href') || '').replace('#', '') : '';
      var hereKey = '';
      FLOW.forEach(function (s) { if (s.tab === hereTab) hereKey = s.key; });
      var next = flowNextTodo(hereKey || null);
      bar.appendChild(el('span', { class: 'bmath-flowbar__lbl',
        text: 'Assigning to ' + (state.bookingName || 'this client file') }));
      bar.appendChild(el('span', { class: 'bmath-flowbar__n' + (settled === FLOW.length ? ' is-done' : ''),
        text: settled + ' of ' + FLOW.length + ' assigned' }));
      bar.appendChild(el('span', { class: 'bmath-flowbar__next',
        text: next ? 'Next: ' + next.label : 'All four assigned ✓' }));
      /* r129: the one button. Present whenever anything is still
         outstanding - once all four are settled there is nothing to do. */
      if (settled < FLOW.length) {
        var all = el('button', { class: 'bmath-flowbar__all', type: 'button',
          text: 'Save all to this cake' });
        all.addEventListener('click', function () {
          var res = flowSaveAll();
          if (!res) return;
          var bits = [];
          if (res.saved.length) bits.push('Saved ' + res.saved.join(', ').toLowerCase());
          if (res.skipped.length) bits.push('skipped ' + res.skipped.join(', ').toLowerCase());
          all.textContent = bits.length ? bits.join(' · ') + ' ✓' : 'Nothing to save yet';
          all.disabled = true;
          setTimeout(function () { flowRender(); }, 2400);
        });
        bar.appendChild(all);
        /* name what the cake could not decide, so a step left open never
           looks like the button forgot it */
        var rel0 = flowRelevance();
        var ask = FLOW.filter(function (st0) {
          return rel0[st0.key] === 'ask' && flowStateOf(st0.key, sheet) === 'todo';
        }).map(function (st0) { return st0.label.toLowerCase(); });
        if (ask.length) {
          bar.appendChild(el('span', { class: 'bmath-flowbar__ask',
            text: 'Link this cake’s recipes and it will know about ' + ask.join(' and ') + ' too' }));
        }
      }
    }

    /* (c) the skip control at the foot of each step */
    FLOW.forEach(function (s) {
      var sec = document.getElementById(s.tab);
      if (!sec) return;
      var foot = sec.querySelector('.bmath-stepfoot');
      if (!scoped) { if (foot) foot.parentNode.removeChild(foot); return; }
      if (!foot) { foot = el('div', { class: 'bmath-stepfoot' }); sec.appendChild(foot); }
      while (foot.firstChild) foot.removeChild(foot.firstChild);
      var st = flowStateOf(s.key, sheet);
      foot.className = 'bmath-stepfoot is-' + st;
      if (st === 'skipped') {
        foot.appendChild(el('span', { class: 'bmath-stepfoot__state',
          text: 'Skipped, no ' + s.label.toLowerCase() + ' on this cake' }));
        foot.appendChild(el('button', { class: 'bmath-stepfoot__btn', type: 'button',
          text: 'Use ' + s.label.toLowerCase() + ' after all',
          onclick: function () { flowWriteSkip(s.key, false); flowRender(); } }));
      } else if (st === 'saved') {
        foot.appendChild(el('span', { class: 'bmath-stepfoot__state', text: 'Assigned to the file ✓' }));
      } else {
        foot.appendChild(el('span', { class: 'bmath-stepfoot__state',
          text: 'Not using ' + s.label.toLowerCase() + ' on this cake?' }));
        foot.appendChild(el('button', { class: 'bmath-stepfoot__btn', type: 'button',
          text: 'Skip this step',
          onclick: function () {
            if (!flowWriteSkip(s.key, true)) return;
            flowAdvanceFrom(s.key);
          } }));
      }
    });

    flowFineTune(scoped);
  }

  /* UX 2026-09-11 (Mariya): scoped view - the five calculators fold behind
     one "Fine-tune the numbers" toggle, closed by default, so an assigned
     cake reads clean instead of a wall of numbered calculators squished under
     the "assigning to" bar. Unscoped (standalone tool) keeps them all open. */
  var FT_CALC_IDS = ['batter', 'ganache', 'fillings', 'buttercream', 'scaling'];
  var ftOpen = false;
  function flowPaintFineTune() {
    var tg = document.querySelector('.bmath-ftfold');
    if (tg) { tg.setAttribute('aria-expanded', ftOpen ? 'true' : 'false'); tg.classList.toggle('is-open', ftOpen); }
    FT_CALC_IDS.forEach(function (id) { var s = document.getElementById(id); if (s) s.hidden = !ftOpen; });
  }
  function flowFineTune(scoped) {
    var tg = document.querySelector('.bmath-ftfold');
    if (!scoped) {
      if (tg && tg.parentNode) tg.parentNode.removeChild(tg);
      FT_CALC_IDS.forEach(function (id) { var s = document.getElementById(id); if (s) s.hidden = false; });
      return;
    }
    if (!tg) {
      tg = el('button', { class: 'bmath-ftfold', type: 'button', 'aria-expanded': 'false' }, [
        el('span', { class: 'bmath-ftfold__t', text: 'Fine-tune the numbers' }),
        el('span', { class: 'bmath-ftfold__chev', 'aria-hidden': 'true', text: '⌄' })
      ]);
      tg.addEventListener('click', function () { ftOpen = !ftOpen; flowPaintFineTune(); });
      /* anchor to the first calculator so the fold always sits directly above
         the five sections it collapses, wherever the (retired) jump nav and
         the flowbar land. In production the flowbar sits right here too, so
         the order reads: assigning bar, this toggle, the calculators. */
      var first = document.getElementById('batter');
      if (first && first.parentNode) first.parentNode.insertBefore(tg, first);
      else { var bar = document.querySelector('.bmath-flowbar'); if (bar && bar.parentNode) bar.parentNode.insertBefore(tg, bar.nextSibling); }
    }
    flowPaintFineTune();
  }

  function resultLine(label, value, cls) {
    return el('div', { class: 'bmath-line' + (cls ? ' ' + cls : '') }, [
      el('span', { html: label }),
      el('span', { class: 'bmath-num', text: value })
    ]);
  }

  /* ============================================================
     TOOL 1 — Buttercream quantity
     ============================================================ */
  /* the §2.1 coats/filling rule + batch conversion live in the engine;
     this binds the page's cfg and the baker's chosen bowl for mixer runs */
  function bcCompute(s) { return Q.buttercream(cfg, s, { bowl: bowlPref() }); }

  /* "4 batches = 4 separate mixer runs — a 5 qt bowl whips one batch at
     a time." Empty string when everything fits one run. */
  function mixerRunsLine(r) {
    var b = bowlCfg();
    if (r.mixerRuns <= 1) return '';
    return 'That’s ' + r.mixerRuns + ' separate mixer runs, a ' + b.label + ' whips ' +
      (b.smbcPerBowl === 1 ? 'one batch' : 'about ' + b.smbcPerBowl + ' batches') + ' at a time.';
  }

  /* 5d finish chips — design labels over Mariya's verified multipliers
     (sharp/rustic/piped). "semi" (semi-naked) is NEW 2026-07-15 with a
     derived 1.5 g/in² in the config — MARIYA VERIFY. Renders only when
     the config actually carries the key, so an older config can't show
     a chip with no number behind it. */
  var FINISHES = [
    ['sharp', 'Smooth'],
    ['rustic', 'Textured'],
    ['semi', 'Semi-naked'],
    ['piped', 'Piped']
  ].filter(function (f) { return !!(cfg && cfg.coat && cfg.coat[f[0]] != null); });

  /* 2026-08-04: dams as an explicit choice. Not everyone pipes two — some
     pipe one, some none at all — so the tool asks instead of assuming. */
  var DAM_MODES = [
    [2, 'Two per layer'],
    [1, 'One per layer'],
    [0, 'None']
  ];

  /* the global chip on/off state (redesign §10) as a small control row */
  function chipRow(options, current, onPick) {
    var box = el('div', { class: 'ld-chips', role: 'group' });
    options.forEach(function (o) {
      var on = String(current) === String(o[0]);
      var c = el('button', { class: 'ld-chip' + (on ? ' is-on' : ''), type: 'button',
        'aria-pressed': on ? 'true' : 'false', text: o[1] });
      c.addEventListener('click', function () {
        box.querySelectorAll('.ld-chip').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        c.classList.add('is-on'); c.setAttribute('aria-pressed', 'true');
        onPick(o[0]);
      });
      box.appendChild(c);
    });
    return box;
  }
  var LAYERS = [[2, '2 cake layers (1 filling)'], [3, '3 cake layers (2 fillings)'], [4, '4 cake layers (3 fillings)']];
  var THICKNESSES = [['thin', 'Thin'], ['standard', 'Standard'], ['generous', 'Generous']];

  function bcEffState() {
    /* the tool's options + whichever cake it's pointed at — detached, so
       premium saved recipes stay self-contained snapshots */
    var s = state.bc;
    return {
      tiers: JSON.parse(JSON.stringify(bcTiersEff())),
      finish: s.finish, fillOn: s.fillOn, layers: s.layers, fillThick: s.fillThick,
      /* a state saved before dams existed has no `dams` key — default it to
         the studio method rather than 0, or those cakes silently keep the
         old under-count that sent her back to the mixer */
      dams: (s.dams == null ? 2 : s.dams)
    };
  }
  function bcCopyText() {
    var s = state.bc, r = bcCompute(bcEffState());
    var lines = ['LAYER\'D Batch Math - Buttercream'];
    lines.push('Finish: ' + s.finish);
    lines.push(s.fillOn
      ? 'Includes buttercream filling (toggle on) - ' + Math.max(0, s.layers - 1) + ' filling layer(s) per tier, ' + s.fillThick + '.'
      : 'Coats only - filling handled in the Fillings calculator.');
    lines.push('');
    r.per.forEach(function (p) {
      lines.push(tierLabel(p.tier) + ': ' + (s.fillOn
        ? 'coats ' + fmtG(p.crumb + p.coat) + ' + filling ' + fmtG(p.fill)
        : 'crumb ' + fmtG(p.crumb) + ' + final coat ' + fmtG(p.coat)) + ' = ' + fmtG(p.total));
    });
    lines.push('');
    lines.push('Coats subtotal: ' + fmtG(r.crumb + r.coat));
    if (s.fillOn) lines.push('Filling subtotal: ' + fmtG(r.fill));
    lines.push('Subtotal: ' + fmtG(r.subtotal));
    lines.push('+' + cfg.insurancePct + '% insurance (on ' + (s.fillOn ? 'coats + filling' : 'coats') + '): ' + fmtG(r.insurance));
    lines.push('TOTAL: ' + fmtG(r.total) + ' (about ' + fmt1(r.cups) + ' cups)');
    lines.push('MAKE ' + r.makeBatches + (r.makeBatches === 1 ? ' batch' : ' batches') +
      ' of ' + cfg.batchLabel + ' (~' + fmtInt(cfg.batchGrams) + ' g each)' + batchTail(r));
    /* grams, not a count — she buys liquid whites by weight (2026-08-11) */
    if (r.eggWhiteGrams) lines.push('= ' + fmtInt(r.eggWhiteGrams) + ' g egg whites');
    else if (r.eggWhites) lines.push('= ' + r.eggWhites + ' egg whites');
    var runsLine = mixerRunsLine(r);
    if (runsLine) lines.push(runsLine);
    return lines.join('\n');
  }

  /* "- about 220 g to spare." / "- almost exactly." / the sliver case */
  function batchTail(r) {
    if (r.leftover < 0) return ' - covers it; the ' + cfg.insurancePct + '% insurance absorbs the sliver.';
    if (r.leftover < 25) return ' - almost exactly.';
    return ' - about ' + fmtG(r.leftover) + ' to spare.';
  }

  function bcInit() {
    if (!bcRoot) return;
    var s = state.bc;
    var tiersBox = el('div', { class: 'bmath-tiers' });
    var resultBox = el('div', { class: 'bmath-resultbox', 'aria-live': 'polite' });

    var fillLayersField = field('Cake layers per tier', select(LAYERS, s.layers, function (v) { s.layers = +v; update(); }));
    var fillThickField = field('Filling thickness', select(THICKNESSES, s.fillThick, function (v) { s.fillThick = v; update(); }));

    function syncFillFields() {
      fillLayersField.style.display = s.fillOn ? '' : 'none';
      fillThickField.style.display = s.fillOn ? '' : 'none';
    }

    var fillCheck = el('input', { type: 'checkbox', id: 'bmath-fill-on' });
    fillCheck.checked = s.fillOn;
    fillCheck.addEventListener('change', function () {
      s.fillOn = fillCheck.checked; syncFillFields(); update();
    });
    /* the toggle's own row, id'd so the Result Card's "change" jump-link
       (§2.1.2) can scroll back to it and flash it */
    var fillCheckRow = el('div', { class: 'bmath-check', id: 'bmath-fill-toggle' }, [
      fillCheck,
      el('label', { for: 'bmath-fill-on', text: 'Buttercream filling between layers' })
    ]);
    function jumpToToggle() {
      ldNav(fillCheckRow, { block: 'center' });
      fillCheckRow.classList.add('is-nudged');
      setTimeout(function () { fillCheckRow.classList.remove('is-nudged'); }, 1600);
    }
    /* §2.1.2 — the Result Card states its own configuration beside the
       total, so the table can never be read without knowing which mode
       produced it. Both variants carry a working jump-link to the toggle. */
    function configLine() {
      var msg = s.fillOn
        ? 'Includes buttercream filling (toggle on). '
        : 'Coats only, filling handled in the Fillings calculator. ';
      var jump = el('button', { class: 'bmath-config__jump', type: 'button', text: 'change' });
      jump.addEventListener('click', jumpToToggle);
      return el('p', { class: 'bmath-config' }, [el('span', { text: msg }), jump]);
    }

    /* the which-cake toggle + (custom only) the tool's own tier rows —
       the old "use my tiers from the batter tool" button is retired,
       the cake strip does that job for the whole page */
    var tiersWrap = el('div', { class: 'bmath-tierswrap' });
    /* shared mode: no tiers heading — the cake set-up above owns the tiers,
       only the quiet override link renders here (Mariya 2026-07-15) */
    var tiersHead = el('h3', { text: 'Your tiers' });
    function renderTiersArea() {
      clearNode(tiersWrap);
      tiersHead.style.display = s.custom ? '' : 'none';
      if (!NO_STRIP) tiersWrap.appendChild(scopeToggle(s, function () { renderTiersArea(); update(); }));
      if (s.custom) {
        clearNode(tiersBox);
        tierList(tiersBox, s.tiers, 6, update);
        tiersWrap.appendChild(tiersBox);
      }
    }

    /* the teaching sits behind the "?" — the second dam is STRUCTURAL, not
       just a bigger barrier, and that is the part worth knowing */
    var damNote = el('p', { class: 'bmath-formnote bmath-infowrap' }, [
      el('span', { text: 'Two dams is the LAYER’D method. ' })
    ]);
    (function () {
      var q = el('button', { class: 'bmath-info', type: 'button', 'aria-expanded': 'false' });
      q.innerHTML = '<span aria-hidden="true">?</span><span class="learn-visually-hidden">Why two dams</span>';
      damNote.appendChild(q);
      damNote.appendChild(el('span', { class: 'bmath-info__pop', role: 'note', text:
        'A dam is piped buttercream, so it comes out of this total, on a 10″ + 8″ cake it can be a whole extra batch. ' +
        'One dam rings the outer edge and holds the filling in. The second is piped halfway between that edge and the centre: ' +
        'buttercream sets far firmer than a compote or a crémeux, so that inner ring carries load and stops the layers ' +
        'settling into the soft filling, it is support, not just a barrier. Off means your filling holds its own shape, ' +
        'or you are filling with buttercream itself (tick the filling box instead).' }));
    })();

    var form = el('div', { class: 'bmath-form' }, [
      tiersHead,
      tiersWrap,
      el('div', { class: 'bmath-opts' }, [
        field('Finish style', chipRow(FINISHES, s.finish, function (v) { s.finish = v; update(); })),
        el('p', { class: 'bmath-formnote', text: 'Smooth is the LAYER’D signature sharp coat; Piped covers full Vintage Piping.' }),
        fillCheckRow,
        fillLayersField,
        fillThickField,
        /* ---- DAMS (2026-08-04, from Mariya's bench data) ----
           A dam is piped buttercream and was missing from this total
           entirely — on her own 10″+8″ cake it was ~1,000 g, a batch and a
           bit. It is a CHOICE, not an assumption: plenty of bakers pipe one
           dam, or none at all. Two is the studio method and the default,
           because that is what the rate was calibrated against. */
        field('Dams', chipRow(DAM_MODES, s.dams, function (v) { s.dams = +v; update(); })),
        damNote
      ]),
      el('p', { class: 'bmath-formnote', text: 'Filling with compote, crémeux or ganache instead? Leave this off, those aren’t buttercream, and the Fillings and Ganache calculators above handle them.' })
    ]);

    function update() {
      persist();
      var eff = bcEffState();
      var r = bcCompute(eff);
      clearNode(resultBox);
      var panel = el('div', { class: 'ld-result ld-result--attention' });

      /* 5d — the answer FIRST, as data: serif total on the headline row,
         the verified breakdown follows (grams + the 10% margin — the mock's
         lb + 15% waste were illustrative; Mariya's numbers stand). */
      /* redesign r2j (her mockup + "middle ground"): the answer, the split,
         and ONE line of what to actually do. Everything evergreen folds
         into the "?"; situational cautions still speak up on their own. */
      bigAnswer(panel, fmtInt(r.total), 'g of buttercream',
        s.fillOn ? 'Crumb + finish coats and filling, by surface.' : 'Crumb + finish coats, by outer surface.',
        'Total buttercream', fmtG(r.total));

      var splitKids = [
        el('span', { class: 'bmath-split__v', text: fmtG(r.crumb) }),
        el('span', { class: 'bmath-split__k', text: ' crumb coat \u00b7 ' }),
        el('span', { class: 'bmath-split__v', text: fmtG(r.coat) }),
        el('span', { class: 'bmath-split__k', text: ' finish' })
      ];
      if (s.fillOn) {
        splitKids.push(el('span', { class: 'bmath-split__k', text: ' \u00b7 ' }));
        splitKids.push(el('span', { class: 'bmath-split__v', text: fmtG(r.fill) }));
        splitKids.push(el('span', { class: 'bmath-split__k', text: ' filling' }));
      }
      /* dams get their OWN figure in the split \u2014 a thousand grams cannot
         hide inside a total, and seeing it is what makes the choice real */
      if (r.dam > 0) {
        splitKids.push(el('span', { class: 'bmath-split__k', text: ' \u00b7 ' }));
        splitKids.push(el('span', { class: 'bmath-split__v', text: fmtG(r.dam) }));
        splitKids.push(el('span', { class: 'bmath-split__k',
          text: ' dams (' + (r.damMode === 2 ? '2 per layer' : '1 per layer') + ')' }));
      }
      panel.appendChild(el('p', { class: 'bmath-split' }, splitKids));

      /* THE ONE ACTION LINE - make N batches / eggs / mixer runs */
      var doBits = [fmtInt(r.makeBatches) + (r.makeBatches === 1 ? ' batch' : ' batches')];
      if (r.eggWhiteGrams) doBits.push(fmtInt(r.eggWhiteGrams) + ' g egg whites');
      else if (r.eggWhites) doBits.push(r.eggWhites + ' egg whites');
      if (r.mixerRuns > 1) doBits.push(r.mixerRuns + ' mixer runs');
      var doRow = el('p', { class: 'bmath-do bmath-infowrap' }, [
        el('span', { class: 'bmath-do__k', text: 'Make ' }),
        el('span', { class: 'bmath-do__v', text: doBits.join(' \u00b7 ') })
      ]);
      var dq = el('button', { class: 'bmath-info', type: 'button', 'aria-expanded': 'false' });
      dq.innerHTML = '<span aria-hidden="true">?</span><span class="learn-visually-hidden">How this batch count works</span>';
      doRow.appendChild(dq);
      doRow.appendChild(el('span', { class: 'bmath-info__pop', role: 'note', text:
        'One batch of your standard ' + cfg.batchLabel + ' is about ' + fmtInt(cfg.batchGrams) + ' g' +
        (batchTail(r) ? batchTail(r).replace(/^\s*[-\u2014]\s*/, ' \u2014 ').replace(/\.\s*$/, '') : '') + '. '
        + (r.mixerRuns > 1 ? 'A ' + bowlCfg().label + ' whips about ' + bowlCfg().smbcPerBowl + ' at a time, hence the runs. ' : '')
        + 'The total already includes your ' + cfg.insurancePct + '% insurance margin (about ' + fmt1(r.cups) + ' cups in all). '
        + 'Colour dries deeper than it looks in the bowl \u2014 use oil-based colour, under-tint slightly, and rest 10 min before judging the shade. '
        + 'Whip full batches and reserve any you\u2019ll colour: dyed buttercream can\u2019t go back into the plain reserve.' }));
      panel.appendChild(doRow);

      /* the configuration line stays - it names WHICH total this is */
      panel.appendChild(configLine());
      if (!s.fillOn) {
        panel.appendChild(el('p', { class: 'bmath-secondary', html:
          'Filling \u2192 the <a href="#fillings">Fillings</a> or <a href="#ganache">Ganache</a> calculator.' }));
      }
      /* situational only - these speak up when the cake is unusual */
      if (eff.tiers.some(function (t) { return t.h >= 8; })) {
        panel.appendChild(el('p', { class: 'ld-callout ld-callout--caution', html:
          'An ' + sizeLabel(8) + ' tall tier is really two half-tiers on a shared board (double-barrel) \u2014 plan filling for the extra seam, and let <a href="/pages/structure">Structure</a> check the build.'
        }));
      }
      if (eff.tiers.some(function (t) { return t.shape === 'heart'; })) {
        panel.appendChild(el('p', { class: 'ld-callout ld-callout--caution', text:
          'Heart tiers are estimated at ' + Math.round(HEART_FACTOR * 100) + '% of the round of the same size for coats-top and filling (a heart pan holds a little less); the sides use the bounding round. Weigh one and tell the template if your hearts run bigger or smaller.'
        }));
      }
      var save = saveSlot('bc', bcEffState);
      actionRow(panel, copyBtn(bcCopyText), save);
      resultBox.appendChild(panel);
    }

    renderTiersArea();
    unitListeners.push(function () { renderTiersArea(); update(); });
    /* a booking scope can flip s.fillOn (§2.1.4 combo inheritance); sync the
       checkbox so it never contradicts the result's "coats only / includes
       filling" line */
    updaters.push(function () { fillCheck.checked = s.fillOn; renderTiersArea(); syncFillFields(); update(); });
    syncFillFields();
    bcRoot.appendChild(form);
    bcRoot.appendChild(resultBox);
    bcRoot.appendChild(tuneBlock('buttercream', { noun: 'buttercream',
      getModel: function () {
        try {
          var f = Q.calibration.factor('buttercream');
          var t = bcCompute(bcEffState()).total;
          return { display: '≈ ' + fmtG(t), raw: t / f };
        } catch (e) { return null; }
      } }));
    update();
  }

  /* ============================================================
     TOOL 2 — Ganache & drip
     ============================================================ */
  /* two applications only (Mariya 2026-07-15): a coat under buttercream or
     fondant, and a drip. Ganache-as-filling was retired — it duplicated the
     Fillings calculator. Saved 'filling' states migrate to 'coat' in gaInit. */
  var GA_APPS = [
    ['coat', 'Under buttercream or fondant'],
    ['drip', 'Drip']
  ];
  var CHOCS = [
    ['dark', 'Dark 54% (Callebaut 811)'],
    ['milk', 'Milk 33% (Callebaut 823)'],
    ['white', 'White (Callebaut W2)']
  ];
  var CHOC_SHORT = { dark: 'dark 54%', milk: 'milk 33%', white: 'white' };

  /* redesign r2h (her ganache/fillings mockups): the answer as a big
     figure + one plain line saying what it covers. Shared by the tabs so
     they read as one family. `.bmath-line--total` stays in the DOM,
     visually hidden, because the tab pills + accordion previews read it. */
  function bigAnswer(panel, num, unit, lede, totalLabel, short) {
    var head = el('div', { class: 'bmath-big' }, [
      el('span', { class: 'bmath-big__num', text: num }),
      el('span', { class: 'bmath-big__unit', text: unit })
    ]);
    panel.appendChild(head);
    if (lede) panel.appendChild(el('p', { class: 'bmath-big__lede', text: lede }));
    /* the machine-readable twin the previews already query */
    panel.appendChild(el('div', { class: 'bmath-line bmath-line--total bmath-line--quiet' }, [
      el('span', { text: totalLabel || 'Total' }),
      el('span', { class: 'bmath-num', text: short || (num + ' ' + unit) })
    ]));
  }

  function gaCompute(s) { return Q.ganache(cfg, s); }

  function ratioText(r) {
    // 2 -> "2 : 1", 2.5 -> "2.5 : 1"
    return String(Math.round(r * 10) / 10) + ' : 1';
  }

  /* r2h: "Dark 2 : 1" - the ratio shown on the chip is the one this
     chocolate uses for the application currently chosen (they differ per
     app), read straight from the config. No new numbers. */
  function chocOptions() {
    var s = state.ga;
    return CHOCS.map(function (o) {
      var short = { dark: 'Dark', milk: 'Milk', white: 'White' }[o[0]] || o[1];
      var r = null;
      try { r = cfg.ganache.ratios[o[0]][s.app]; } catch (e) { r = null; }
      return [o[0], r ? short + ' ' + ratioText(r) : short];
    });
  }

  function gaEffState() {
    var s = state.ga;
    return {
      tiers: JSON.parse(JSON.stringify(gaTiersEff())),
      app: s.app, choc: s.choc, layers: s.layers
    };
  }
  function gaCopyText() {
    var s = state.ga, r = gaCompute(gaEffState());
    var appLabel = { coat: 'under buttercream or fondant', drip: 'drip' }[s.app] || 'under buttercream or fondant';
    var lines = ['LAYER\'D Batch Math - Ganache (' + appLabel + ', ' + CHOC_SHORT[s.choc] + ')'];
    lines.push('');
    r.per.forEach(function (p) { lines.push(tierLabel(p.tier) + ': ' + fmtG(p.grams)); });
    lines.push('');
    lines.push('Total ganache: ' + fmtG(r.total));
    lines.push('Chocolate: ' + fmtG(r.choc));
    lines.push('Cream: ' + fmtG(r.cream));
    lines.push('Ratio: ' + ratioText(r.ratio) + ', chocolate to cream');
    return lines.join('\n');
  }

  function gaInit() {
    if (!gaRoot) return;
    var s = state.ga;
    /* migrate a retired 'filling' application (2026-07-15) to a coat */
    if (s.app === 'filling') s.app = 'coat';
    var tiersBox = el('div', { class: 'bmath-tiers' });
    var resultBox = el('div', { class: 'bmath-resultbox', 'aria-live': 'polite' });

    /* which-cake toggle; in this-cake mode a drip gets its own honest
       sub-question (a drip usually runs over the top tier only — edge
       length is what matters, so the whole cake would overestimate) */
    var tiersWrap = el('div', { class: 'bmath-tierswrap' });
    /* shared mode: no tiers heading — the cake set-up above owns the tiers
       (Mariya 2026-07-15); the drip scope chips still render when relevant */
    var tiersHead = el('h3', { text: 'Tier(s)' });
    function renderTiersArea() {
      clearNode(tiersWrap);
      tiersHead.style.display = s.custom ? '' : 'none';
      if (!NO_STRIP) tiersWrap.appendChild(scopeToggle(s, function () { renderTiersArea(); update(); }));
      if (s.custom) {
        if (s.app === 'drip') {
          tiersWrap.appendChild(el('p', { class: 'bmath-formnote', text:
            'For a drip, add only the tier(s) the drip runs over, usually just the top one. Height doesn’t change a drip; the edge length does.' }));
        }
        clearNode(tiersBox);
        tierList(tiersBox, s.tiers, 6, update);
        tiersWrap.appendChild(tiersBox);
      } else if (s.app === 'drip') {
        var scope = el('div', { class: 'bmath-scope bmath-scope--drip', role: 'group', 'aria-label': 'Where the drip runs' });
        [['top', 'Drip on the top tier only'], ['cake', 'Drip on every tier']].forEach(function (o) {
          var active = (s.dripScope || 'top') === o[0];
          var b = el('button', {
            class: 'ld-chip' + (active ? ' is-on' : ''), type: 'button',
            text: o[1], 'aria-pressed': active ? 'true' : 'false',
            onclick: function () { if (s.dripScope !== o[0]) { s.dripScope = o[0]; renderTiersArea(); update(); } }
          });
          scope.appendChild(b);
        });
        tiersWrap.appendChild(scope);
      }
    }

    var form = el('div', { class: 'bmath-form' }, [
      el('div', { class: 'bmath-opts bmath-ga__opts' }, [
        /* r2h: the two selects become the mockup's chip rows - the app on
           one line, the chocolate on the next WITH its live ratio, so the
           ratio is part of the choice instead of a sentence underneath. */
        el('div', { class: 'bmath-ga__apps' }, [
          chipRow(GA_APPS, s.app, function (v) { s.app = v; renderTiersArea(); update(); })
        ]),
        el('div', { class: 'bmath-ga__chocs' }, [
          chipRow(chocOptions(), s.choc, function (v) { s.choc = v; update(); })
        ])
      ]),
      tiersHead,
      tiersWrap
    ]);

    function update() {
      persist();
      var r = gaCompute(gaEffState());
      clearNode(resultBox);
      var panel = el('div', { class: 'ld-result ld-result--attention' });

      /* r2h: per-tier grams now live in the Cake set-up card beside this
         panel, so the answer here is the cake total + the split to weigh. */
      bigAnswer(panel, fmtInt(r.total), 'g of ganache',
        s.app === 'drip'
          ? 'A drip \u2014 by the top edge it runs over.'
          : 'A full coat across every tier\u2019s sides and top.',
        'Total ganache', fmtG(r.total));
      panel.appendChild(el('p', { class: 'bmath-split' }, [
        el('span', { class: 'bmath-split__v', text: fmtG(r.choc) }),
        el('span', { class: 'bmath-split__k', text: ' chocolate \u00b7 ' }),
        el('span', { class: 'bmath-split__v', text: fmtG(r.cream) }),
        el('span', { class: 'bmath-split__k', text: ' cream' })
      ]));
      /* 2026-08-11: say the margin out loud. Ganache used to quote the bare
         area maths, so the number looked exact when it was not; the split
         above is taken AFTER the margin, so chocolate + cream still equals
         the headline. */
      if (r.insurance > 0) {
        panel.appendChild(el('p', { class: 'tl-hint bmath-marginnote',
          text: 'Includes a ' + r.insurancePct + '% margin (' + fmtG(r.insurance) + '), ' + fmtG(r.subtotal) + ' is the bare coverage.' }));
      }
      if (s.app === 'drip') {
        panel.appendChild(el('p', { class: 'ld-callout ld-callout--caution', html:
          'Test the consistency on the back of the chilled cake (or an upturned chilled bowl) before you commit to the front. If the drip has already gone wrong, <a href="/pages/cake-er">Cake ER</a> has the rescue.'
        }));
      }
      var save = saveSlot('ga', gaEffState);
      actionRow(panel, copyBtn(gaCopyText), save);
      resultBox.appendChild(panel);
    }

    renderTiersArea();
    unitListeners.push(function () { renderTiersArea(); update(); });
    updaters.push(function () { renderTiersArea(); update(); });
    gaRoot.appendChild(form);
    gaRoot.appendChild(resultBox);
    gaRoot.appendChild(tuneBlock('ganache', { noun: 'ganache',
      getModel: function () {
        try {
          var f = Q.calibration.factor('ganache');
          var t = gaCompute(gaEffState()).total;
          return { display: '≈ ' + fmtG(t), raw: t / f };
        } catch (e) { return null; }
      } }));
    update();
  }

  /* ============================================================
     TOOL 3 — Recipe pan-scaling
     ============================================================ */
  var SC_LAYERS = [[1, '1'], [2, '2'], [3, '3'], [4, '4'], [5, '5'], [6, '6']];
  /* Quarter sheet is the ONLY sheet offered (Mariya, 2026-07-10): it's
     the unit recipes are written for, and the batter tool's batch unit.
     A half sheet is exactly two quarters, so nothing is lost. */
  var SC_TYPES = [['round', 'Round'], ['square', 'Square'], ['quarterSheet', 'Quarter sheet']];

  /* A pan's top area in square inches - round/square from geometry,
     sheet pans from their fixed usable size (the batter config). */
  function isSheetPan(p) { return p.shape === 'quarterSheet' || p.shape === 'halfSheet'; }
  function panArea(p) {
    if (p.shape === 'quarterSheet') { var q = batterPans().quarter; return q[0] * q[1]; }
    if (p.shape === 'halfSheet') { var h = batterPans().half; return h[0] * h[1]; }
    return topArea({ d: p.d, shape: p.shape });
  }

  function scFactor(s) {
    var src = panArea(s.src) * s.src.layers;
    var tgt = panArea(s.tgt) * s.tgt.layers;
    return src > 0 ? tgt / src : 1;
  }

  /* Factor + every pasted line scaled — one call for the result panel,
     the copy text and the premium day planner alike. */
  function scScale(s) {
    var factor = scFactor(s);
    var rows = s.text.split('\n').map(parseLine).filter(Boolean).map(function (it) {
      return scaleItem(it, factor);
    });
    return { factor: factor, rows: rows };
  }

  /* ----- ingredient line parser -----
     Tolerates "350g flour", "350 g flour", "1.5 cups sugar",
     "2 1/2 tsp vanilla", "3 eggs". Anything it can't read is
     passed through unscaled with a gentle flag — never an error. */
  var UNITS = {};
  ('g gram grams kg ml l litre litres liter liters cup cups tsp tbsp teaspoon teaspoons ' +
   'tablespoon tablespoons oz ounce ounces lb lbs pound pounds pinch pinches stick sticks ' +
   'can cans tin tins drop drops').split(' ').forEach(function (u) { UNITS[u] = true; });

  function parseQty(str) {
    str = str.replace(',', '.');
    var m = str.match(/^(\d+)\s+(\d+)\/(\d+)$/);
    if (m) return +m[1] + (+m[2] / +m[3]);
    m = str.match(/^(\d+)\/(\d+)$/);
    if (m) return +m[1] / +m[2];
    return parseFloat(str);
  }

  /* Recipes pasted from websites use unicode fractions ("1½ cups") far
     more often than typed ones ("1 1/2 cups") - normalize before parsing. */
  var VULGAR = {
    '¼': '1/4', '½': '1/2', '¾': '3/4',
    '⅓': '1/3', '⅔': '2/3',
    '⅕': '1/5', '⅖': '2/5', '⅗': '3/5', '⅘': '4/5',
    '⅙': '1/6', '⅚': '5/6',
    '⅛': '1/8', '⅜': '3/8', '⅝': '5/8', '⅞': '7/8'
  };
  function normalizeFractions(s) {
    return s.replace(/[¼-¾⅓-⅞]/g, function (ch) {
      return VULGAR[ch] ? ' ' + VULGAR[ch] : ch;
    }).replace(/^\s+/, '');
  }

  function parseLine(raw) {
    var line = normalizeFractions(raw.trim());
    if (!line) return null;
    var m = line.match(/^(\d+\s+\d+\/\d+|\d+\/\d+|\d+(?:[.,]\d+)?)\s*([A-Za-z]+\.?)?\s*(.*)$/);
    if (!m) return { raw: line, ok: false };
    var qty = parseQty(m[1]);
    if (isNaN(qty)) return { raw: line, ok: false };
    var unit = (m[2] || '').replace(/\.$/, '');
    var name = (m[3] || '').trim();
    if (unit && !UNITS[unit.toLowerCase()]) {
      name = (unit + (name ? ' ' + name : ''));
      unit = '';
    }
    if (!name && !unit) return { raw: line, ok: false };
    return { raw: line, ok: true, qty: qty, unit: unit, name: name };
  }

  function isEgg(item) { return !item.unit && /\begg/i.test(item.name); }
  function isLeavener(item) { return /baking\s*powder|baking\s*soda|bicarbonate|bicarb/i.test(item.name); }

  function smartRound(v) {
    if (v >= 100) return Math.round(v / 5) * 5;   // big weights to the nearest 5
    if (v >= 10) return Math.round(v);
    if (v >= 1) return Math.round(v * 2) / 2;     // spoons and small amounts to halves
    return Math.round(v * 100) / 100;
  }

  function scaleItem(item, factor) {
    var out = { item: item, flags: [] };
    if (!item.ok) { out.text = item.raw; out.passthrough = true; return out; }
    var v = item.qty * factor;
    if (isEgg(item)) {
      v = Math.max(0.5, Math.round(v * 2) / 2);
      if (v !== Math.round(v)) out.flags.push('halfEgg');
    } else {
      v = smartRound(v);
    }
    if (isLeavener(item) && (factor >= 2 || factor <= 0.5)) out.flags.push('leavener');
    out.scaled = v;
    out.text = fmtNum(v) + (item.unit ? ' ' + item.unit : '') + (item.name ? ' ' + item.name : '');
    return out;
  }

  function panLabel(p) {
    if (isSheetPan(p)) {
      /* sheets bake one slab — "layers" only exists for tins. A count
         above 1 only appears via the half-sheet migration (×2). */
      var sheetBase = p.shape === 'halfSheet' ? 'half sheet' : 'quarter sheet';
      return sheetBase + ((p.layers || 1) > 1 ? ' × ' + p.layers : '');
    }
    return sizeLabel(p.d) + ' ' + p.shape + ', ' + p.layers + (p.layers === 1 ? ' layer' : ' layers');
  }

  function scCopyText() {
    var s = state.sc;
    var factor = scFactor(s);
    var lines = ['LAYER\'D Batch Math - Recipe scaled x ' + (Math.round(factor * 100) / 100)];
    lines.push('(' + panLabel(s.src) + ' -> ' + panLabel(s.tgt) + ')');
    lines.push(bowlFit(panArea(s.tgt) * s.tgt.layers).text);
    var items = s.text.split('\n').map(parseLine).filter(Boolean);
    if (items.length) {
      lines.push('');
      items.forEach(function (it) {
        var r = scaleItem(it, factor);
        if (r.passthrough) lines.push(r.text + '   (left as written - no quantity found)');
        else lines.push(r.text + '   (was ' + it.raw + ')');
      });
    }
    return lines.join('\n');
  }

  function scInit() {
    if (!scRoot) return;
    var s = state.sc;
    var resultBox = el('div', { class: 'bmath-resultbox', 'aria-live': 'polite' });

    /* r2k (her pan-scaling mockup): a stepper instead of a dropdown -
       "- 8\u2033 +". `opts` is the same option list the select used, so the
       allowed values (and therefore the math) are identical; this only
       walks the list instead of opening it. */
    function stepper(opts, current, onPick, fmt) {
      var vals = opts.map(function (o) { return o[0]; });
      var i = vals.map(String).indexOf(String(current));
      if (i < 0) i = 0;
      function go(d) {
        var j = Math.min(vals.length - 1, Math.max(0, i + d));
        if (j !== i) onPick(vals[j]);
      }
      var minus = el('button', { class: 'bmath-step__btn', type: 'button', 'aria-label': 'Less',
        text: '\u2212', onclick: function () { go(-1); } });
      var plus = el('button', { class: 'bmath-step__btn', type: 'button', 'aria-label': 'More',
        text: '+', onclick: function () { go(1); } });
      if (i === 0) minus.disabled = true;
      if (i === vals.length - 1) plus.disabled = true;
      return el('div', { class: 'bmath-step' }, [
        minus,
        el('span', { class: 'bmath-step__v', text: fmt ? fmt(vals[i], opts[i]) : opts[i][1] }),
        plus
      ]);
    }

    function panFields(p, legend) {
      /* r2k: shape as segmented chips, size + layers as steppers - the
         mockup's anatomy. Same options, same values, same math. */
      var row1 = el('div', { class: 'bmath-pan__row' }, [
        chipRow(SC_TYPES, p.shape, function (v) {
          p.shape = v;
          /* a sheet bakes one slab — layers only exist for tins */
          if (isSheetPan(p)) p.layers = 1;
          rebuildPans(); update();
        })
      ]);
      var kids = [row1];
      if (!isSheetPan(p)) {
        row1.appendChild(stepper(diameterOpts(), p.d, function (v) {
          p.d = +v; rebuildPans(); update();
        }, function (v) { return sizeLabel(v); }));
        kids.push(el('div', { class: 'bmath-pan__row' }, [
          stepper(SC_LAYERS, p.layers, function (v) {
            p.layers = +v; rebuildPans(); update();
          }, function (v) { return v + (v === 1 ? ' layer' : ' layers'); })
        ]));
      }
      return el('fieldset', { class: 'bmath-pan' }, [
        el('legend', { text: legend })
      ].concat(kids));
    }

    var pansBox = el('div', { class: 'bmath-pans' });
    function rebuildPans() {
      clearNode(pansBox);
      pansBox.appendChild(panFields(s.src, 'The recipe was written for'));
      pansBox.appendChild(panFields(s.tgt, 'You’re baking in'));
    }
    rebuildPans();
    unitListeners.push(function () { rebuildPans(); update(); });

    var ta = el('textarea', {
      class: 'learn-input bmath-textarea', rows: '6',
      placeholder: 'Optional: paste your ingredient list, one per line\n350 g flour\n1.5 cups sugar\n3 eggs\n2 tsp baking powder',
      'aria-label': 'Ingredient list, one ingredient per line'
    });
    ta.value = s.text;
    ta.addEventListener('input', function () { s.text = ta.value; update(); });

    /* ---- My recipes bridge (Mariya, 2026-07-10) ----
       Pro members type their recipes ONCE, on the Recipe Library page
       ("My recipes", stored per-browser). This reads that same store so
       a saved recipe drops straight into the scaler — no re-typing. The
       control only exists when the store has recipes: visitors and
       members who haven't used the builder see nothing. The data is the
       member's own writing, so nothing gated is exposed here. */
    var MINE_KEY = 'layerd-academy-my-recipes';
    function readMyRecipes() {
      try {
        var v = JSON.parse(localStorage.getItem(MINE_KEY));
        if (v && v.v === 1 && Object.prototype.toString.call(v.items) === '[object Array]') return v.items;
      } catch (e) { /* private mode / corrupt — behave as empty */ }
      return [];
    }
    function myRecipeText(r) {
      return (r.ingredients || []).map(function (ing) {
        var bits = [];
        if (ing.qty != null) bits.push(String(ing.qty));
        if (ing.unit) bits.push(ing.unit);
        bits.push(ing.item + (ing.note ? ' (' + ing.note + ')' : ''));
        return bits.join(' ');
      }).join('\n');
    }
    var mineWrap = el('div', { class: 'bmath-minepick' });
    function renderMinePick() {
      clearNode(mineWrap);
      var items = readMyRecipes();
      /* r8 (Mariya, 2026-07-31: "the view is not functional right now").
         With no saved recipes this rendered NOTHING, so the tab opened on
         two pan pickers and an empty box with no visible way to bring a
         recipe in — it read as broken. The control is always here now; when
         the shelf is empty it says so and points at the Library. */
      if (!items.length) {
        mineWrap.appendChild(field('Start from one of my recipes',
          el('p', { class: 'bmath-formnote bmath-minepick__empty' }, [
            el('span', { text: 'No saved recipes on this device yet, add them in the ' }),
            el('a', { href: '/pages/recipe-library', text: 'Recipe Library →' }),
            el('span', { text: ' and they will appear here. You can also paste an ingredient list below.' })
          ])));
        return;
      }
      var opts = [['', 'Choose a recipe']];
      items.forEach(function (r) { opts.push([r.id, r.title + (r.yieldNote ? ' · ' + r.yieldNote : '')]); });
      var sel = select(opts, '', function (id) {
        var r = null;
        items.forEach(function (x) { if (x.id === id) r = x; });
        if (!r) return;
        s.text = myRecipeText(r);
        ta.value = s.text;
        update();
      });
      mineWrap.appendChild(field('Start from one of my recipes', sel));
      mineWrap.appendChild(el('p', { class: 'bmath-formnote', text:
        'Loads the ingredient list below, then set the pans it was written for above. Edit anything after it lands.' }));
    }
    renderMinePick();
    /* the store can change in another tab (the library page) — refresh
       the options whenever this tab comes back into focus. Also on a
       `storage` write: cloud sync pulls this member's recipes down after
       the page has already rendered, and without this the picker stayed
       empty until a manual reload (r8). */
    window.addEventListener('focus', renderMinePick);
    window.addEventListener('storage', function (e) {
      if (!e || !e.key || e.key === MINE_KEY) renderMinePick();
    });

    var form = el('div', { class: 'bmath-form' }, [
      pansBox,
      mineWrap,
      field('Ingredients (optional)', ta)
    ]);

    function update() {
      persist();
      var factor = scFactor(s);
      var shown = Math.round(factor * 100) / 100;
      clearNode(resultBox);
      var panel = el('div', { class: 'ld-result ld-result--attention' });

      panel.appendChild(el('p', { class: 'bmath-factor' }, [
        el('span', { class: 'bmath-factor__x', text: '× ' + shown }),
        el('span', { class: 'bmath-factor__unit', text: 'per ingredient' })
      ]));

      var meaning;
      if (factor > 1.02) meaning = 'Multiply every ingredient by ' + shown + ', your pans hold about ' + Math.round((factor - 1) * 100) + '% more batter than the ones the recipe was written for.';
      else if (factor < 0.98) meaning = 'Multiply every ingredient by ' + shown + ', your pans hold about ' + Math.round((1 - factor) * 100) + '% less batter than the ones the recipe was written for.';
      else meaning = 'Practically the same capacity, bake it as written.';
      panel.appendChild(el('p', { class: 'bmath-secondary', text: meaning }));

      /* will the scaled batch fit the mixer bowl? (target pans = the
         batter that's actually about to be mixed) */
      var fit = bowlFit(panArea(s.tgt) * s.tgt.layers);
      if (fit.fits) {
        panel.appendChild(el('p', { class: 'bmath-secondary bmath-fit', text: fit.text }));
      } else {
        panel.appendChild(el('div', { class: 'ld-callout ld-callout--caution bmath-caution' }, [
          el('span', { class: 'ld-callout__label', text: 'Bowl check' }),
          el('span', { text: fit.text })
        ]));
      }

      var items = s.text.split('\n').map(parseLine).filter(Boolean);
      var hadHalfEgg = false, hadLeavener = false;
      if (items.length) {
        var list = el('div', { class: 'bmath-scaled' });
        items.forEach(function (it) {
          var r = scaleItem(it, factor);
          if (r.flags.indexOf('halfEgg') !== -1) hadHalfEgg = true;
          if (r.flags.indexOf('leavener') !== -1) hadLeavener = true;
          var row = el('div', { class: 'bmath-scaled__row' + (r.passthrough ? ' is-passthrough' : '') }, [
            el('span', { class: 'bmath-num bmath-scaled__new', text: r.text + (r.flags.indexOf('leavener') !== -1 ? ' ⚠' : '') }),
            el('span', {
              class: 'bmath-scaled__was',
              text: r.passthrough ? 'left as written, no quantity found' : 'was ' + it.raw
            })
          ]);
          list.appendChild(row);
        });
        panel.appendChild(list);
        if (hadHalfEgg) {
          panel.appendChild(el('p', { class: 'ld-callout ld-callout--caution', text: 'Half an egg is real: whisk one egg and use half of it by weight (about 25 g).' }));
        }
        if (hadLeavener) {
          panel.appendChild(el('div', { class: 'ld-callout ld-callout--caution bmath-caution' }, [
            el('span', { class: 'ld-callout__label', text: 'Caution' }),
            el('span', { text: 'Leaveners stop scaling in a straight line much past 2×, or below half. Start a touch under the number and let a test layer be the judge.' })
          ]));
        }
      }

      var save = saveSlot('sc', function () { return JSON.parse(JSON.stringify(s)); });
      actionRow(panel, copyBtn(scCopyText), save);
      resultBox.appendChild(panel);
    }

    scRoot.appendChild(form);
    scRoot.appendChild(resultBox);
    update();
  }

  /* ============================================================
     TOOL — Cake batter (how much sponge to bake)
     Cake volume = sum of (each tier's top area x its number of ~1"
     layers). Divide by what one vessel holds: a batch (one reference
     round layer) or a SHEET (quarter and half both shown). The layer
     depth is the same for the cake and the vessel, so it cancels -
     only the layer counts and the pan areas matter. TALLER cake = more
     layers = more batter, for round tins AND sheets alike.
     ============================================================ */
  var CT_LAYER_OPTS = [];
  (function () { for (var n = 1; n <= 8; n++) CT_LAYER_OPTS.push([n, String(n)]); })();
  var CT_VESSELS = [['sheet', 'Sheet pans'], ['round', 'Round tins']];

  function ctTierLabel(t) { return sizeLabel(t.d) + ' ' + t.shape; }

  /* Per-tier flavour: a free text input — matching is by spelling, so
     "chocolate" twice = one shared batter. Blank means "same as the
     other blanks" (the single-flavour cake never has to touch this). */
  function ctFlavourInput(value, onInput) {
    var inp = el('input', {
      class: 'learn-input bmath-flav', type: 'text',
      placeholder: 'e.g. chocolate', 'aria-label': 'Tier flavour (optional)'
    });
    inp.value = value;
    inp.addEventListener('input', function () { onInput(inp.value); });
    return inp;
  }

  /* pans/yields/flavour-grouping/round-up all live in the engine now
     (§4); batterPans is still used by the scaling tool's panArea below */
  function batterPans() { return Q.batterPans(cfg); }
  function ctGroupTiers(g) {
    return g.per.slice().sort(function (a, b) { return b.tier.d - a.tier.d; })
      .map(function (p) { return sizeLabel(p.tier.d); }).join(' + ');
  }

  function ctCompute(s) { return Q.batter(cfg, s); }

  /* "2 quarter sheets + 1 half sheet (2 batches poured together)" */
  function ctPansText(g) {
    var parts = [];
    if (g.qSheets) parts.push(g.qSheets + ' quarter sheet' + (g.qSheets === 1 ? '' : 's'));
    if (g.hSheets) parts.push(g.hSheets + ' half sheet' + (g.hSheets === 1 ? '' : 's') + ' (two batches poured together' + (g.hSheets === 1 ? '' : ' each') + ')');
    return parts.join(' + ');
  }

  function ctEffState() {
    var s = state.ct;
    return {
      tiers: JSON.parse(JSON.stringify(ctPerEff())),
      vessel: s.vessel, roundRef: s.roundRef, roundRefLayers: s.roundRefLayers
    };
  }
  function ctCopyText() {
    var s = state.ct, r = ctCompute(ctEffState());
    var multi = r.groups.length > 1;
    var lines = ['LAYER\'D Batch Math - Cake batter'];
    r.per.forEach(function (p) {
      lines.push(ctTierLabel(p.tier) + ' - ' + p.layers + (p.layers === 1 ? ' layer' : ' layers') +
        (multi ? ' - ' + (((p.tier.flavour || '') + '').trim() || 'no flavour set') : ''));
    });
    lines.push('');
    if (s.vessel === 'round') {
      lines.push('BAKE ' + r.batches + (r.batches === 1 ? ' batch' : ' batches') +
        ' of sponge (one batch makes ' + s.roundRefLayers + ' x ' + sizeLabel(s.roundRef) + ' round layers)');
      if (multi) {
        r.groups.forEach(function (g) {
          lines.push('- ' + (g.label || 'No flavour set') + ': ' + g.batches +
            (g.batches === 1 ? ' batch' : ' batches') + ' (' + ctGroupTiers(g) + (g.per.length === 1 ? ' tier)' : ' tiers)'));
        });
        lines.push('(each flavour rounded up on its own - separate batters never share a batch)');
      }
      lines.push('(' + (Math.round(r.exact * 100) / 100) + ' batches by cake volume, rounded up)');
    } else {
      lines.push('MIX ' + r.batchesQ + ' quarter-sheet batch' + (r.batchesQ === 1 ? '' : 'es') + ' of batter');
      if (r.batchesQ > 0) lines.push('Bake as: ' + ctPansText(r));
      if (multi) {
        r.groups.forEach(function (g) {
          lines.push('- ' + (g.label || 'No flavour set') + ': ' + g.batchesQ + ' batch' + (g.batchesQ === 1 ? '' : 'es') +
            ' - ' + (ctPansText(g) || 'round tins') + ' (' + ctGroupTiers(g) + (g.per.length === 1 ? ' tier)' : ' tiers)'));
        });
        lines.push('(each flavour fills its own pans - different batters never share a sheet)');
      }
      if (r.hSheets > 0) lines.push('Rings over 9" always bake in half sheets - two quarter batches poured together per sheet.');
      if (r.pieced.length) lines.push('(' + r.pieced.map(function (d) { return d + '"'; }).join(', ') + ' layers are pieced from half-sheet segments - the seams hide under the filling)');
      lines.push('PRO TIP: rings over 9" bake in half sheets, and any two quarter sheets can consolidate into one half whenever oven space is tight.');
      lines.push('Cut-to-fit counts: some sizes leave offcuts, so this can be a slight overestimate. Freeze the trimmings - they cut into extra rounds later.');
    }
    lines.push(bowlFit(r.areaLayers).text);
    return lines.join('\n');
  }

  /* Batter tiers are size + shape + LAYER COUNT (no tier-height field:
     each layer is ~1" of sponge, so the layer count IS the height that
     drives the batter). Its own row, not the shared height-based one. */
  function ctTierRow(tiers, i, onAny) {
    var t = tiers[i];
    var kids = [
      /* redesign r2 slice 3: the serif number chip (presentational) */
      el('span', { class: 'bmath-tiernum', 'aria-hidden': 'true', text: String(i + 1) }),
      field('Size', select(diameterOpts(), t.d, function (v) { t.d = +v; onAny(); })),
      field('Shape', select(SHAPES, t.shape, function (v) { t.shape = v; onAny(); })),
      field('Layers', select(CT_LAYER_OPTS, t.layers, function (v) { t.layers = +v; onAny(); })),
      field('Flavour (optional)', ctFlavourInput(t.flavour || '', function (v) { t.flavour = v; onAny(); }))
    ];
    if (tiers.length > 1) {
      /* round 25 (handoff 18a fix 4): a quiet × in muted ink — no alarm
         red anywhere in this system */
      kids.push(el('button', {
        class: 'bmath-remove', type: 'button', text: '×',
        title: 'Remove tier ' + (i + 1),
        'aria-label': 'Remove tier ' + (i + 1),
        onclick: function () { tiers.splice(i, 1); onAny(true); }
      }));
    }
    return el('div', { class: 'bmath-tierrow' }, kids);
  }

  function ctTierList(container, tiers, onChange) {
    function rebuild() {
      clearNode(container);
      tiers.forEach(function (_, i) {
        container.appendChild(ctTierRow(tiers, i, function (structural) {
          if (structural) rebuild();
          onChange();
        }));
      });
      if (tiers.length < 6) {
        container.appendChild(el('button', {
          class: 'ld-btn ld-btn--secondary bmath-add', type: 'button', text: '+ Add a tier',
          onclick: function () {
            var last = tiers[tiers.length - 1];
            tiers.push({ d: Math.min(last.d + 2, 16), shape: last.shape, layers: last.layers, flavour: last.flavour || '' });
            rebuild();
            onChange();
          }
        }));
      }
    }
    rebuild();
    return rebuild;
  }

  function ctInit() {
    if (!ctRoot) return;
    var s = state.ct;
    var tiersBox = el('div', { class: 'bmath-tiers' });
    var tiersWrap = el('div', { class: 'bmath-tierswrap' });
    var resultBox = el('div', { class: 'bmath-resultbox', 'aria-live': 'polite' });

    var roundLayersField = field('Layers one batch of your recipe makes',
      select(CT_LAYER_OPTS, s.roundRefLayers, function (v) { s.roundRefLayers = +v; update(); }));
    var roundSizeField = field('Round layer size',
      select(diameterOpts(), s.roundRef, function (v) { s.roundRef = +v; update(); }));

    function syncVessel() {
      var show = s.vessel === 'round' ? '' : 'none';
      roundLayersField.style.display = show;
      roundSizeField.style.display = show;
    }

    /* the tiers heading + layer explainer only show when this calculator is
       detached (override) — in shared mode the cake set-up above owns the
       tiers and the explainer moves inside the adjust fold (Mariya 2026-07-15:
       "set once above; a subtle override for each"). */
    var tiersHead = el('h3', { text: 'Your tiers' });
    var tiersNote = el('p', { class: 'bmath-formnote', text: 'One layer is about an inch of baked sponge, add a layer for each inch of height. More layers means more batter.' });
    var form = el('div', { class: 'bmath-form' }, [
      el('div', { class: 'bmath-opts' }, [
        field('You bake your layers in', select(CT_VESSELS, s.vessel, function (v) { s.vessel = v; syncVessel(); update(); })),
        roundLayersField,
        roundSizeField
      ]),
      tiersHead,
      tiersNote,
      tiersWrap
    ]);

    /* this-cake mode: one row per cake tier — size/shape read from the
       strip, only the layer count editable (defaults from the tier's
       height: a 4" standard tier = 3 layers). Custom mode: the old
       fully-editable rows. */
    function renderTiersArea() {
      clearNode(tiersWrap);
      tiersHead.style.display = s.custom ? '' : 'none';
      tiersNote.style.display = s.custom ? '' : 'none';
      var scope = NO_STRIP ? null : scopeToggle(s, function () {
        if (s.custom && (!s.tiers || !s.tiers.length)) {
          s.tiers = state.cake.tiers.map(function (t, i) {
            return { d: t.d, shape: t.shape, layers: ctDerivedLayers(i), flavour: state.ct.cakeFlavours[i] || '' };
          });
        }
        renderTiersArea(); update();
      });
      clearNode(tiersBox);
      if (s.custom) {
        if (scope) tiersWrap.appendChild(scope);
        ctTierList(tiersBox, s.tiers, update);
        tiersWrap.appendChild(tiersBox);
      } else {
        /* shared mode (2026-07-15): the cake set-up above owns the tiers —
           one summary line here, the same per-tier Layers/Flavour rows behind
           a quiet fold, the override link beneath. Same state writes
           (cakeLayers/cakeFlavours), zero engine change. */
        function sumText() {
          return state.cake.tiers.map(function (t, i) {
            return ctTierLabel(t) + ' ×' + ctDerivedLayers(i);
          }).join(' · ') + ', from your cake set-up';
        }
        var sumEl = el('p', { class: 'bmath-tiersum', text: sumText() });
        tiersBox.appendChild(sumEl);
        var fold = el('details', { class: 'bmath-tierfold' });
        fold.appendChild(el('summary', { class: 'bmath-tierfold__sum ld-chip', text: 'Adjust layers & flavours ▾' }));
        var rows = el('div');
        rows.appendChild(el('p', { class: 'bmath-formnote', text: 'One layer is about an inch of baked sponge, add a layer for each inch of height. More layers means more batter.' }));
        state.cake.tiers.forEach(function (t, i) {
          rows.appendChild(el('div', { class: 'bmath-tierrow bmath-tierrow--cake' }, [
            el('span', { class: 'bmath-tiernum', 'aria-hidden': 'true', text: String(i + 1) }),
            el('span', { class: 'bmath-tierrow__cakelabel', text: ctTierLabel(t) + ', ' + sizeLabel(t.h) + ' tall' }),
            field('Layers', select(CT_LAYER_OPTS, ctDerivedLayers(i), function (v) {
              state.ct.cakeLayers[i] = +v; sumEl.textContent = sumText(); update();
            })),
            field('Flavour (optional)', ctFlavourInput(state.ct.cakeFlavours[i] || '', function (v) {
              state.ct.cakeFlavours[i] = v; update();
            }))
          ]));
        });
        /* flavours live on the client file (2026-07-20): combos assign
           them; typing here only labels the math */
        if (state.bookingId && state.cake.tiers.some(function (t2, i2) { return !((state.ct.cakeFlavours[i2] || '').trim()); })) {
          var rHref = null;
          document.querySelectorAll('.learn-subnav__tab').forEach(function (a2) {
            if (!rHref && /recipe/i.test(a2.textContent)) rHref = a2.getAttribute('href');
          });
          var hint = el('p', { class: 'bmath-formnote bmath-flavhint' });
          hint.appendChild(document.createTextNode('No flavour on some tiers yet \u2014 '));
          if (rHref && rHref !== '#') {
            hint.appendChild(el('a', {
              href: rHref + (rHref.indexOf('?') >= 0 ? '&' : '?') + 'booking=' + encodeURIComponent(state.bookingId) + '#arcpCombos',
              text: 'assign a signature combo on ' + (state.bookingName || 'the client') + '\u2019s file'
            }));
          } else {
            hint.appendChild(document.createTextNode('assign a signature combo on ' + (state.bookingName || 'the client') + '\u2019s file (Recipes page)'));
          }
          hint.appendChild(document.createTextNode(' and it fills in here automatically. Typing here only labels the math.'));
          rows.appendChild(hint);
        }
        fold.appendChild(rows);
        tiersBox.appendChild(fold);
        tiersWrap.appendChild(tiersBox);
        if (scope) tiersWrap.appendChild(scope);
      }
    }

    function update() {
      persist();
      var r = ctCompute(ctEffState());
      clearNode(resultBox);
      var panel = el('div', { class: 'ld-result ld-result--attention' });

      var multi = r.groups.length > 1;
      r.per.forEach(function (p) {
        var flav = ((p.tier.flavour || '') + '').trim();
        panel.appendChild(el('div', { class: 'bmath-tierline' }, [
          el('div', { class: 'bmath-tierline__head' }, [
            el('span', { text: ctTierLabel(p.tier) + (multi && flav ? ' · ' + flav : '') }),
            el('span', { class: 'bmath-num', text: p.layers + (p.layers === 1 ? ' layer' : ' layers') })
          ])
        ]));
      });

      /* one line per flavour — which pans belong to which tiers, so a
         two-flavour cake never leaves the baker guessing at the oven */
      function groupLines(unitOf) {
        r.groups.forEach(function (g) {
          panel.appendChild(el('div', { class: 'bmath-line bmath-flavline' }, [
            el('span', { text: (g.label || 'No flavour set') + ', ' + ctGroupTiers(g) + (g.per.length === 1 ? ' tier' : ' tiers') }),
            el('span', { class: 'bmath-num', text: unitOf(g) })
          ]));
        });
      }

      if (s.vessel === 'round') {
        panel.appendChild(el('div', { class: 'bmath-line bmath-line--total' }, [
          el('span', { text: 'Sponge to bake' }),
          el('span', { class: 'bmath-num', text: r.batches + (r.batches === 1 ? ' batch' : ' batches') })
        ]));
        if (multi) {
          groupLines(function (g) { return g.batches + (g.batches === 1 ? ' batch' : ' batches'); });
          panel.appendChild(el('p', { class: 'bmath-secondary',
            text: 'Each flavour rounds up on its own, separate batters never share a batch.' }));
        }
        panel.appendChild(el('p', { class: 'bmath-secondary',
          text: 'About ' + (Math.round(r.exact * 100) / 100) + ' batches by cake volume, rounded up, one batch makes ' + s.roundRefLayers + ' × ' + sizeLabel(s.roundRef) + ' round layers.' }));
      } else {
        var sizes = function (arr) { return arr.map(function (d) { return sizeLabel(d); }).join(', '); };
        if (r.batchesQ > 0) {
          panel.appendChild(el('div', { class: 'bmath-line bmath-line--total' }, [
            el('span', { text: 'Batter to mix' }),
            el('span', { class: 'bmath-num', text: r.batchesQ + ' quarter-sheet batch' + (r.batchesQ === 1 ? '' : 'es') })
          ]));
          /* r2g (Mariya): "each flavour fills its own pans" retired — the
             per-flavour rows above say it without a sentence. */
          if (multi) groupLines(function (g) { return g.batchesQ + ' batch' + (g.batchesQ === 1 ? '' : 'es'); });

          /* r2g: ONE sheet-pan note, on the "Bake as" line where the pans
             are actually named — the half-sheet rule and the offcuts /
             freeze-the-trimmings caveat together, behind a "?". Sheet pans
             only (round tins never raise either point), and the old
             "Baking tips" fold is gone with it. */
          var bakeAs = el('p', { class: 'bmath-secondary bmath-infowrap bmath-bakeas' }, [
            el('span', { class: 'bmath-info__lbl', text: 'Bake as: ' + ctPansText(r) + '.' })
          ]);
          var bqb = el('button', { class: 'bmath-info', type: 'button', 'aria-expanded': 'false' });
          bqb.innerHTML = '<span aria-hidden="true">?</span><span class="learn-visually-hidden">About these pans</span>';
          bakeAs.appendChild(bqb);
          var bnote = (r.hSheets > 0
            ? 'Rings over 9″ always bake in half sheets, two quarter batches poured together per sheet, and your batch count above already includes them. Any two quarter sheets can also consolidate into one half whenever oven space is tight. '
            : 'Any two quarter sheets can consolidate into one half sheet whenever oven space is tight. ')
            + 'These are cut-to-fit counts, so some sizes leave offcuts and this can be a slight overestimate, freeze the trimmings, they cut into extra rounds for another day.';
          bakeAs.appendChild(el('span', { class: 'bmath-info__pop', role: 'note', text: bnote }));
          panel.appendChild(bakeAs);

          if (r.pieced.length) {
            panel.appendChild(el('p', { class: 'ld-callout ld-callout--caution',
              text: sizes(r.pieced) + (r.pieced.length === 1 ? ' layers are' : ' layers are') + ' pieced from half-sheet segments, cut to fit, with the seams hidden under the filling.' }));
          }
        }
      }
      /* the bowl check: the whole cake's batter, as mixer rounds */
      var fit = bowlFit(r.areaLayers);
      if (fit.fits) {
        panel.appendChild(el('p', { class: 'bmath-secondary bmath-fit', text: fit.text }));
      } else {
        panel.appendChild(el('div', { class: 'ld-callout ld-callout--caution bmath-caution' }, [
          el('span', { class: 'ld-callout__label', text: 'Bowl check' }),
          el('span', { text: fit.text })
        ]));
      }

      /* scoped to a cake: the batter saves onto ITS file — batch sheet +
         Components (one row per flavour, batches pre-filled, editable there) */
      var save = saveSlot('ct', ctEffState);
      actionRow(panel, copyBtn(ctCopyText), save);
      resultBox.appendChild(panel);
    }

    renderTiersArea();
    unitListeners.push(function () { renderTiersArea(); update(); });
    updaters.push(function () { renderTiersArea(); update(); });
    syncVessel();
    ctRoot.appendChild(form);
    ctRoot.appendChild(resultBox);
    /* batter tunes by nudge only — its unit is whole pans and batches,
       so a grams input would imply precision the vessel math doesn't have */
    ctRoot.appendChild(tuneBlock('batter', { noun: 'batter' }));
    update();
  }

  /* ============================================================
     TOOL — Fillings (compotes, crémeux, montées)
     Grams per filling bed = tier top area × filling layers ×
     the per-type density from bmath-config. Filling layers derive
     from tier height: sponge layers = height − 1, beds between
     them = sponge − 1 (her 4" standard = 3 sponge, 2 beds).
     Densities ship as PLACEHOLDER ESTIMATES (cfg.fillings.estimate)
     until Mariya weighs real cakes — the banner stays up till then.
     ============================================================ */
  function flTypes() { return Q.fillingTypes(cfg); }
  function flTypeOpts() {
    var t = flTypes();
    return Object.keys(t).map(function (k) { return [k, t[k].label]; });
  }
  function flLayersOf(t) { return Q.fillingLayersOf(t); }
  function flRound(g) { return Math.round(g / 5) * 5; }

  function flCompute(s) { return Q.fillings(cfg, s); }
  /* r42: nothing goes BETWEEN the layers of a dummy — a faux tier drops
     out of the filling maths the same way it drops out of batter. It
     stays in bcTiersEff/gaTiersEff on purpose: the dummy still gets
     coated and covered. */
  function flTiersEff() {
    if (state.fl.custom) return state.fl.tiers;
    return state.cake.tiers.filter(function (t) { return !t.faux; });
  }
  /* r223 (Phase 3): the recipe this filling IS, when the cake is scoped to a
     single saved filling. That id lets the engine apply this recipe's own tune
     factor, and the tune control write to it, instead of the global fillings
     fudge. Multiple fillings or an unsaved flavour = null (per-product tuning). */
  function flScopedFillingComponent() {
    if (state.fl.custom || !state.bookingId) return null;
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || !v.bookings) return null;
      var bk = null, i;
      for (i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === state.bookingId) { bk = v.bookings[i]; break; }
      if (!bk || !bk.components) return null;
      var out = [], seen = {};
      bk.components.forEach(function (c) {
        var cat = c.category || '', nm = ((c.name || '') + '').trim();
        if (!nm || cat === 'bases' || cat === 'other') return;
        if (cat === 'finishes' && BM_COAT_RE.test(nm)) return;
        if (seen[nm.toLowerCase()]) return; seen[nm.toLowerCase()] = 1; out.push(c);
      });
      return out.length === 1 ? out[0] : null;
    } catch (e) { return null; }
  }
  /* r223: tune by the booking component's OWN recipeId when it has one, so the
     factor lines up with what the Planner reads for the same recipe; a
     hand-typed flavour with no linked recipe falls back to the saved-recipe id. */
  function flScopedRecipeId() {
    var c = flScopedFillingComponent();
    if (!c) return null;
    if (c.recipeId) return c.recipeId;
    var m = myRecipeByTitle(c.name);
    return (m && m.id) ? m.id : null;
  }
  function flScopedRecipeName() {
    var c = flScopedFillingComponent();
    return c ? ((c.name || '') + '').trim() : null;
  }
  function flEffState() { return { tiers: JSON.parse(JSON.stringify(flTiersEff())), type: state.fl.type, recipeId: flScopedRecipeId() }; }

  function flCopyText() {
    var r = flCompute(flEffState());
    var lines = ['LAYER\'D Batch Math - Fillings (' + r.label + ')'];
    r.per.forEach(function (p) {
      lines.push(tierLabel(p.tier) + ' - ' + p.layers + (p.layers === 1 ? ' filling layer' : ' filling layers') +
        ' - ' + fmtG(flRound(p.g)));
    });
    lines.push('MAKE ' + fmtG(flRound(r.total)) + ' of ' + r.label.toLowerCase());
    if (r.estimate) lines.push('(placeholder densities - studio-weighed numbers coming; treat as a starting point)');
    return lines.join('\n');
  }

  /* r223 (Phase 2): a filling's yield turns grams into the batch count bakers
     read - "2 batches (2,280 g), about 380 g spare". Yield comes from the
     baker's saved recipe (title match); no saved yield = grams only, no batch
     line, so nothing regresses. Reuses the engine's batchConvert (one rounding
     path, whole batches, never rounds down). */
  function flYieldFor(flavour) {
    var m = myRecipeByTitle(flavour);
    var y = m ? (m.yieldG != null ? m.yieldG : m.yieldGrams) : null;
    return (y != null && +y > 0) ? +y : null;
  }
  function flBatchTail(needsG, yieldG) {
    if (!(yieldG > 0)) return null;
    /* the fillings total already carries the 10% margin, so a whisker over a
       whole batch rides the engine's default sliver rather than demanding an
       extra batch (buttercream uses 0 because its raw total is knowingly light). */
    var c = Q.batchConvert(needsG, yieldG);
    var madeG = c.makeBatches * yieldG;
    var spare = Math.max(0, Math.round(madeG - needsG));
    var spareTxt = spare <= 0 ? 'covers it' : (spare < 25 ? 'almost exactly' : 'about ' + fmtInt(spare) + ' g spare');
    return c.makeBatches + (c.makeBatches === 1 ? ' batch' : ' batches') +
      ' (' + fmtInt(madeG) + ' g), ' + spareTxt;
  }
  function flInit() {
    if (!flRoot) return;
    var s = state.fl;
    /* r223: a scoped cake picks its filling density class from the recipe's
       category, so the dropdown lands right without the baker touching it.
       A hand pick (userPickedType) always wins. */
    if (!s.userPickedType && !s.custom && state.bookingId) {
      var derivedClass = fillingClassOf(state.bookingId);
      if (derivedClass) s.type = derivedClass;
    }
    /* 2026-07-16 calibration: ONE combined filling number (dam + soft filling).
       A saved type that no longer exists migrates to the first configured one. */
    var flOpts = flTypeOpts();
    if (!flOpts.some(function (o) { return o[0] === s.type; }) && flOpts.length) s.type = flOpts[0][0];
    var resultBox = el('div', { class: 'bmath-resultbox', 'aria-live': 'polite' });
    var tiersWrap = el('div', { class: 'bmath-tierswrap' });
    var tiersBox = el('div', { class: 'bmath-tiers' });

    /* heading + layers explainer only in override mode — shared mode defers
       to the cake set-up above (Mariya 2026-07-15) */
    var tiersHead = el('h3', { text: 'Your tiers' });
    var tiersNote = el('p', { class: 'bmath-formnote', text: 'Filling layers come from each tier’s height, a 4″ tier has three sponge layers, so two beds of filling between them.' });
    var form = el('div', { class: 'bmath-form' }, [
      /* with a single combined type there's nothing to choose — the picker
         only renders when the config carries more than one type */
      flOpts.length > 1
        ? el('div', { class: 'bmath-opts' }, [
            field('Filling type', select(flOpts, s.type, function (v) { s.type = v; s.userPickedType = true; update(); }))
          ])
        : null,
      tiersHead,
      tiersNote,
      tiersWrap
    ].filter(Boolean));

    function renderTiersArea() {
      clearNode(tiersWrap);
      tiersHead.style.display = s.custom ? '' : 'none';
      tiersNote.style.display = s.custom ? '' : 'none';
      if (!NO_STRIP) tiersWrap.appendChild(scopeToggle(s, function () { renderTiersArea(); update(); }));
      clearNode(tiersBox);
      if (s.custom) {
        tierList(tiersBox, s.tiers, 6, update);
        tiersWrap.appendChild(tiersBox);
      }
      /* shared mode: no tier rows at all — the read-only labels duplicated
         the cake set-up above (Mariya 2026-07-15); only the override link. */
    }

    function update() {
      persist();
      var r = flCompute(flEffState());
      clearNode(resultBox);
      var panel = el('div', { class: 'ld-result ld-result--attention' });
      /* r2h/i (her mockup): the total first, then the per-tier rows as
         plain data - "14″ · 2 gaps ... 2,001 g". The freezes-flat advice
         moved into the "?" note; the numbers carry the panel. */
      bigAnswer(panel, fmtInt(flRound(r.total)), 'g of filling',
        'Between layers, by tier area and gap count.',
        (r.label || 'Filling') + ' to make', fmtG(flRound(r.total)));
      var flRows = el('div', { class: 'bmath-rows' });
      r.per.forEach(function (p) {
        flRows.appendChild(el('div', { class: 'bmath-row' }, [
          el('span', { class: 'bmath-row__k', text: sizeLabel(p.tier.d) + ' · ' + p.layers + (p.layers === 1 ? ' gap' : ' gaps') }),
          el('span', { class: 'bmath-row__v bmath-num', text: fmtG(flRound(p.g)) })
        ]));
      });
      /* 2026-08-11: the margin gets its own row. Without it the per-tier
         numbers no longer add up to the headline and the panel reads as an
         arithmetic mistake — the same reason buttercream states its
         insurance on its own line rather than folding it in silently. */
      if (r.insurance > 0) {
        flRows.appendChild(el('div', { class: 'bmath-row bmath-row--margin' }, [
          el('span', { class: 'bmath-row__k', text: '+ ' + r.insurancePct + '% margin' }),
          el('span', { class: 'bmath-row__v bmath-num', text: fmtG(flRound(r.insurance)) })
        ]));
      }
      panel.appendChild(flRows);
      /* ---- the split across the flavours on this cake (2026-08-04) ----
         Mariya: "if two fillings are selected it should equally split
         both — 4 batches, 2 flavours, 2 and 2." The Planner already does
         exactly this, but in GRAMS: each tier's filling is divided evenly
         among that tier's fillings, and every flavour then converts to
         batches by ITS OWN yield (which is why two flavours can land on
         different batch counts — the right answer when one recipe makes
         500 g and the other 700 g). Nothing said so on this page, so the
         total read as one undivided lump. Grams only here; the per-recipe
         batch counts live on the file and the plan, where the yields are. */
      var fills = fillingComponentsOf(state.bookingId);
      if (fills.length === 1) {
        /* r223 (Phase 2): one filling — turn the total into its batch count
           when the recipe's yield is saved. */
        var tail1 = flBatchTail(flRound(r.total), flYieldFor(fills[0]));
        if (tail1) panel.appendChild(el('p', { class: 'bmath-formnote bmath-fbatch', text: tail1 }));
      } else if (fills.length > 1) {
        var each = flRound(r.total / fills.length);
        var splitBox = el('div', { class: 'bmath-fsplit' }, [
          el('p', { class: 'bmath-fsplit__lbl', text: 'Split across ' + fills.length + ' fillings on this cake' })
        ]);
        var srows = el('div', { class: 'bmath-rows' });
        var anyMissing = false;
        fills.forEach(function (nm) {
          srows.appendChild(el('div', { class: 'bmath-row' }, [
            el('span', { class: 'bmath-row__k', text: nm }),
            el('span', { class: 'bmath-row__v bmath-num', text: fmtG(each) })
          ]));
          /* r223: each flavour converts by ITS OWN yield, so two can land on
             different batch counts - the right answer. */
          var tail = flBatchTail(each, flYieldFor(nm));
          if (tail) srows.appendChild(el('p', { class: 'bmath-formnote bmath-fbatch bmath-fbatch--sub', text: tail }));
          else anyMissing = true;
        });
        splitBox.appendChild(srows);
        splitBox.appendChild(el('p', { class: 'bmath-fsplit__note', text: anyMissing
          ? 'An even share each. Batches show where you have saved the recipe with a yield; save the rest, or the file and plan work them out.'
          : 'An even share each, converted to batches by what each recipe yields. Always rounds up.' }));
        panel.appendChild(splitBox);
      }
      var flNote = el('p', { class: 'bmath-infowrap bmath-big__note' }, [
        el('span', { class: 'bmath-info__lbl', text: 'Dam-contained beds between sponge layers.' })
      ]);
      var flq = el('button', { class: 'bmath-info', type: 'button', 'aria-expanded': 'false' });
      flq.innerHTML = '<span aria-hidden="true">?</span><span class="learn-visually-hidden">About making filling ahead</span>';
      flNote.appendChild(flq);
      flNote.appendChild(el('span', { class: 'bmath-info__pop', role: 'note',
        text: 'A gap is the space between two sponge layers, three layers means two gaps. Making it ahead? It freezes flat and thaws overnight, so you can cook once for every cake this week.' }));
      panel.appendChild(flNote);
      /* r223: one honest assumptions line, in her voice. Volume is her tiers;
         density is the class default until a real bake tunes it. */
      (function assumeLine() {
        var fc = (cfg && cfg.fillings) || {};
        var ty = (fc.types || {})[flEffState().type];
        if (!ty) return;
        var bedMm = (fc.bedDepthMm != null) ? fc.bedDepthMm : 9;
        var dens = (ty.density != null) ? +ty.density
          : (ty.gPerSqIn != null ? ty.gPerSqIn / ((bedMm / 25.4) * 16.387) : null);
        var densTxt = (dens != null) ? ', ' + (ty.label || 'filling').toLowerCase() + ' at ~' + dens.toFixed(2) + ' g/ml' : '';
        panel.appendChild(el('p', { class: 'bmath-formnote bmath-assume', text:
          'from your tiers at a ' + bedMm + ' mm bed' + densTxt + '. weigh a bake to tune it.' }));
      })();
      if (r.estimate) {
        panel.appendChild(el('div', { class: 'ld-callout ld-callout--caution bmath-caution' }, [
          el('span', { class: 'ld-callout__label', text: 'Numbers pending' }),
          el('span', { text: 'These densities are placeholder estimates until the studio weighs real cakes, treat totals as a starting point.' })
        ]));
      }
      var save = saveSlot('fl', flEffState);
      actionRow(panel, copyBtn(flCopyText), save);
      resultBox.appendChild(panel);
    }

    renderTiersArea();
    unitListeners.push(function () { renderTiersArea(); update(); });
    updaters.push(function () { renderTiersArea(); update(); });
    flRoot.appendChild(form);
    flRoot.appendChild(resultBox);
    flRoot.appendChild(tuneBlock('fillings', { noun: 'filling',
      recipeId: flScopedRecipeId, recipeName: flScopedRecipeName,
      getModel: function () {
        try {
          var id = flScopedRecipeId();
          var f = (id && Q.calibration.recipeFactor(id) != null)
            ? Q.calibration.recipeFactor(id) : Q.calibration.factor('fillings');
          var t = flCompute(flEffState()).total;   /* already tuned by the engine */
          return { display: '≈ ' + fmtG(flRound(t)), raw: t / f };
        } catch (e) { return null; }
      } }));
    update();
  }

  /* ---------- go ---------- */
  /* redesign r2: the units + mixer pills ride the compact header (the
     prototype's row). unitToggle() is position-independent — its handlers
     close over their own boxes and fan out through unitListeners — so the
     mount moves freely. Older template (no .bmath-head) keeps the
     after-the-tab-bar placement. */
  /* r25 (2026-07-31, Mariya): the unit pills move OUT of the header and
     sit just under the client bar. In the header they competed with the
     tier badge for the same row and knocked it out of line on the pages
     that carry them. Position only - the listeners are unchanged. */
  var bmHead = document.querySelector('.bmath-head');
  var jumpNav = document.querySelector('.bmath-jump');
  var bmBar = document.querySelector('.ld-cakechip-row');
  var bmPills = unitToggle();
  if (bmBar && bmBar.parentNode) {
    bmPills.classList.add('ld-unitrow');
    bmPills.classList.add('learn-wrap');   /* r26: same wrap as the bar */
    bmBar.parentNode.insertBefore(bmPills, bmBar.nextSibling);
  }
  else if (bmHead) bmHead.appendChild(bmPills);
  else if (jumpNav && jumpNav.parentNode) jumpNav.parentNode.insertBefore(bmPills, jumpNav.nextSibling);
  else if (bcRoot) bcRoot.insertBefore(bmPills, bcRoot.firstChild);
  cakeInit();
  ctInit();
  bcInit();
  gaInit();
  flInit();
  scInit();
  bookingInit();   /* §3.2 — the booking picker (renders only with bookings) */
  syncYourCake();

  /* UX 2026-09-11 (Mariya): one-tap batch from the Studio. The cake page links
     here with ?booking=<id>&autobatch=1&return=<path>. bookingInit above has
     already scoped this page to that cake, so run the tool's OWN "save the whole
     cake" flow (flowSaveAll — the exact eff-state + engine every Save button
     uses; no math is reimplemented) and go straight back to the file. The baker
     never sees this page; the amounts are just filled in when they land back. */
  (function autoBatchFromStudio() {
    if (!/[?&]autobatch=1/.test(location.search)) return;
    var m = location.search.match(/[?&]return=([^&]+)/);
    var ret = m ? decodeURIComponent(m[1]) : '/pages/studio';
    var bm = location.search.match(/[?&]booking=([^&]+)/);
    var bid = bm ? decodeURIComponent(bm[1]) : null;
    var note = document.createElement('div');
    note.setAttribute('style', 'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:#FCFBF8;color:#2A2138;font:500 15px/1.4 system-ui,-apple-system,sans-serif;');
    note.textContent = 'Working out the batch math…';
    (document.body || document.documentElement).appendChild(note);
    /* one frame for the engine to settle, then scope to the cake ourselves
       (don't depend on the picker's bookingInit, which no-ops without its
       mount), run the tool's own whole-cake save, and return to the file. */
    setTimeout(function () {
      try {
        var bk = null, list = readBookings ? readBookings() : [];
        for (var i = 0; i < list.length; i++) { if (list[i].id === bid) { bk = list[i]; break; } }
        if (!bk && window.LdCakeFile && window.LdCakeFile.getActiveBooking) bk = window.LdCakeFile.getActiveBooking();
        if (bk) { scopeToBooking(bk); flowSaveAll(); }
      } catch (e) { }
      try { window.location.replace(ret); } catch (e2) { window.location.href = ret; }
    }, 80);
  })();

  /* Collapsible calculators (2026-07-15): any in-page anchor — the jump nav,
     the "Fillings or Ganache" pointer links, deep links — must not land on a
     collapsed card. Open the target's ld-collapse before the browser jumps;
     also honour a hash present at load (e.g. ?booking=...#buttercream). */
  function openCollapseFor(hash) {
    if (!hash || hash.length < 2) return;
    var target; try { target = document.querySelector(hash); } catch (e) { return; }
    if (!target) return;
    var d = target.closest('details.ld-collapse') || target.querySelector('details.ld-collapse');
    if (d) d.open = true;
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href^="#"]') : null;
    if (a) openCollapseFor(a.getAttribute('href'));
  });
  if (location.hash) openCollapseFor(location.hash);

  /* ---------- core API ----------
     The free calculators' math and helpers, published for the premium
     day-planner module. Nothing here is gated content — it's the same
     logic every visitor already runs; publishing it keeps ONE source of
     truth for the math, so saved recipes recompute against the current
     bmath-config (Mariya's verified numbers update saved plans too). */
  window.LAYERD = window.LAYERD || {};
  window.LAYERD.batchMathCore = {
    cfg: cfg,
    computeButtercream: bcCompute,
    computeGanache: gaCompute,
    computeFilling: flCompute,
    scaleRecipe: scScale,
    batchTail: batchTail,
    tierLabel: tierLabel,
    panLabel: panLabel,
    sizeLabel: sizeLabel,
    onUnitsChange: function (fn) { unitListeners.push(fn); },
    bowlCfg: bowlCfg,
    chocShort: CHOC_SHORT,
    fmt: { g: fmtG, int: fmtInt, one: fmt1, num: fmtNum },
    el: el,
    copyBtn: copyBtn
  };
})();

/* ============================================================
   REDESIGN round 2 - THE SIMPLIFICATION (Mariya, 2026-07-30):
   the prototype's layout for real. The jump links become TABS -
   exactly one calculator on screen; the Cake set-up (#your-cake)
   always visible beside it on desktop, above it on the phone.
   Engines untouched: this layer only decides what is VISIBLE.
   Progressive: no JS = the classic stacked page. */
/* r14 (2026-07-31) — Mariya: "it should only load at the top of the page."
   The page was settling ~640px down with the sticky tab bar parked at the
   viewport top. Diagnosed as far as: NOT a #hash, NOT autofocus, NOT
   history restoration (a brand-new URL does it too), and NOT this page's
   JS - I wrapped scrollTo/scrollIntoView and the load performs ZERO scroll
   calls. Disabling scroll anchoring on the document did not move it either.
   So the remaining cause is the browser's own layout pass, and rather than
   keep guessing at it this asserts the outcome she asked for: land at the
   top, unless the URL names a section (?booking=...#buttercream still
   works, and any real in-page navigation happens after this).
   Treats the symptom deliberately - noted as such. */
(function bmLandAtTop() {
  if (location.hash && location.hash.length > 1) return;
  function top() { try { window.scrollTo(0, 0); } catch (e) { } }
  top();
  if (document.readyState !== 'complete') window.addEventListener('load', top);
  /* one late correction after the calculators have rendered and the tab
     mode has hidden the inactive sections */
  setTimeout(top, 0);
  setTimeout(top, 250);
})();

(function initBmTabMode() {
  /* r80 (Mariya, 2026-08-23): the slider experiment PROVED the tab strip
     was the app glitch — sticky pinning + hidden sections + replaceState
     on every switch. Its replacement is this in-flow chip row: same five
     destinations, but plain buttons that open the section's card and
     scroll to it. Nothing sticky, nothing hidden, no history writes —
     every ingredient of the glitch omitted. */
  (function initBmSecnav() {
    if (document.querySelector('.bmath-secnav')) return;
    var first = document.querySelector('section.bmath-tool');
    if (!first) return;
    var DEFS = [['batter', 'Batter'], ['fillings', 'Fillings'], ['ganache', 'Ganache'],
      ['buttercream', 'Buttercream'], ['scaling', 'Pan-scaling']];
    var row = document.createElement('nav');
    row.className = 'bmath-secnav learn-wrap';
    row.setAttribute('aria-label', 'Calculators on this page');
    DEFS.forEach(function (d) {
      var s = document.getElementById(d[0]);
      if (!s) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = d[1];
      b.addEventListener('click', function () {
        var acc = s.querySelector('details[data-bmacc]');
        if (acc) acc.open = true;
        /* instant, same as Structure's bar — a re-render mid-scroll
           aborts smooth scrolling and the tap looks dead */
        try { s.scrollIntoView({ block: 'start' }); } catch (e) { s.scrollIntoView(); }
      });
      row.appendChild(b);
    });
    first.parentNode.insertBefore(row, first);
  })();

  var nav = document.querySelector('.bmath-jump');
  if (!nav) return;
  var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
  if (!links.length) return;
  var ids = links.map(function (a) { return a.getAttribute('href').slice(1); });
  var sections = {};
  ids.forEach(function (id) {
    var s = document.getElementById(id);
    if (s) sections[id] = s;
  });
  document.body.classList.add('bmath-tabmode');
  function show(id) {
    ids.forEach(function (k) {
      var s = sections[k];
      if (!s) return;
      var on = (k === id);
      s.classList.toggle('is-tab-active', on);
      if (on) {
        var d = s.querySelector('details[data-bmacc]');
        if (d) d.open = true;   /* the section IS the page now */
      }
    });
    links.forEach(function (a) {
      var on = a.getAttribute('href') === '#' + id;
      a.classList.toggle('is-here', on);
      a.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    try { history.replaceState(null, '', location.pathname + location.search + '#' + id); } catch (e) { }
  }
  nav.setAttribute('role', 'tablist');
  nav.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href^="#"]') : null;
    if (!a || !nav.contains(a)) return;
    ev.preventDefault();
    show(a.getAttribute('href').slice(1));   /* swap in place, no scroll */
  });
  /* in-page pointer links (save-flow "Next", "Fillings or Ganache",
     ?booking=...#buttercream deep links) land on the right tab */
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href^="#"]') : null;
    if (!a || nav.contains(a)) return;
    var id = a.getAttribute('href').slice(1);
    if (sections[id]) show(id);
  });
  var h = (location.hash || '').slice(1);
  show(sections[h] ? h : ids[0]);
})();

/* The "?" notes (Mariya 2026-07-30): hover handles a mouse, this handles a
   tap. One delegated listener; Escape and an outside tap close it. */
(function initBmInfo() {
  /* r14: keep the note on the page. It is absolutely positioned at the
     left edge of its button, so a button near the right margin sent the
     panel off-screen. Measure once it is visible; flip it to the right
     edge if it overflows, and undo the flip if that would push it off the
     LEFT instead (a narrow phone). */
  function clampInfoPop(wrap) {
    var pop = wrap.querySelector('.bmath-info__pop');
    if (!pop) return;
    /* Clamp against the VIEWPORT, not its parent. Measured on a 375px
       phone: the note is 330px wide but the paragraph it hangs off is
       only 257px, so anchoring left overflowed the right edge by 15px
       and anchoring right overflowed the LEFT by 13px - there is no
       edge to pin it to. Position it inside the viewport instead and
       let the offset be whatever it needs to be. */
    pop.style.left = '';
    var pad = 8;
    var wr = wrap.getBoundingClientRect();
    var pr = pop.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var want = wr.left;
    var maxLeft = vw - pad - pr.width;
    if (want > maxLeft) want = maxLeft;
    if (want < pad) want = pad;
    var delta = Math.round(want - wr.left);
    pop.style.left = delta + 'px';
  }
  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('.bmath-infowrap.is-open'), function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var b = w.querySelector('.bmath-info');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('.bmath-info') : null;
    if (!btn) { closeAll(null); return; }
    var wrap = btn.closest('.bmath-infowrap');
    if (!wrap) return;
    ev.preventDefault();
    var open = !wrap.classList.contains('is-open');
    closeAll(wrap);
    wrap.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) clampInfoPop(wrap);
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') closeAll(null);
  });
})();
